var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiddle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1280,
    viewBox: "0 0 1920 1280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-78.79 1369.3V-92.1309H2000.33V1369.3",
    fill: "#04060A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M1063.71 128.83V1098.68H-63.3899V128.83H1063.71Z",
    fill: "url(#paint0_radial_3544_1524)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M-1.84009 128.33H2015.39",
    stroke: "#314766",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.54 378.21L211.9 378.01H211.54V378.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M-1.90991 128.4H2015.32",
    stroke: "#314766",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M2193.89 132.399L1064.22 128.609L1064.02 1098.96L2193.69 1102.75L2193.89 132.399Z",
    fill: "url(#paint1_radial_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M2221.28 128.16H-156.76V1099.15H2221.28V128.16Z",
    fill: "url(#paint2_linear_3544_1524)",
    stroke: "url(#paint3_radial_3544_1524)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1695.79 361.5C1694.77 361.81 1693.62 362.04 1692.37 362.19L1609.09 757.73L1612.08 759.1L1695.79 361.51V361.5Z",
    fill: "url(#paint4_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M1866.95 701.35L1686.78 533.32C1686.51 534.13 1686.21 534.93 1685.85 535.71L1865.72 703.47C1865.97 702.68 1866.38 701.96 1866.94 701.35H1866.95Z",
    fill: "url(#paint5_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.67 568.19C1287.83 568.93 1286.98 569.65 1286.11 570.34C1285.29 567.06 1284.42 563.59 1283.48 559.92C1285.13 562.2 1286.94 564.96 1288.67 568.19Z",
    fill: "#51C8EE",
    stroke: "#8ED6ED",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.79 391.691C1221.33 391.801 1220.87 391.901 1220.4 392.001L1344.8 679.431C1345.45 679.751 1346.13 680.151 1346.84 680.631L1221.79 391.691Z",
    fill: "url(#paint6_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1528.96 764.521L1106.73 524.891C1106.27 525.811 1105.77 526.691 1105.22 527.561L1526.31 766.541C1526.99 765.661 1527.88 764.941 1528.96 764.521Z",
    fill: "url(#paint7_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.46 784.791L1261.4 415.261C1260.23 414.591 1258.98 413.731 1257.65 412.711L1424.26 785.711C1424.98 785.381 1425.71 785.071 1426.46 784.791Z",
    fill: "url(#paint8_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M1356.54 1092.36C1356.88 1093.56 1357.15 1094.93 1357.36 1096.43L1618.86 497.311L1616.96 495.711L1356.54 1092.37V1092.36Z",
    fill: "url(#paint9_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1669.41 331.042C1669.38 329.892 1669.45 328.631 1669.62 327.271L1289.88 745.291L1291.23 747.342L1669.41 331.051V331.042Z",
    fill: "url(#paint10_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.87 139.512C1479.3 140.042 1478.58 140.452 1477.74 140.682L1651.12 721.062C1652.16 721.762 1653.25 722.622 1654.37 723.642L1479.87 139.522V139.512Z",
    fill: "url(#paint11_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M1482.05 137.602C1481.33 137.952 1480.6 138.262 1479.86 138.562L1821.74 755.612C1822.96 756.172 1824.27 756.901 1825.67 757.792L1482.06 137.612L1482.05 137.602Z",
    fill: "url(#paint12_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1597.39 1091.4C1598.11 1090.9 1598.88 1090.44 1599.71 1090.01L1375.65 957.791L1374.25 959.731L1597.39 1091.4Z",
    fill: "url(#paint13_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M1378.24 956.63C1378.13 957.86 1377.9 959.21 1377.56 960.67L1830.73 508.84L1829.54 506.66L1378.24 956.63Z",
    fill: "url(#paint14_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1554.62 828.861L1470.88 1096.5C1471.55 1097.2 1472.2 1097.99 1472.81 1098.85L1556.21 832.331C1555.59 831.221 1555.06 830.061 1554.63 828.871L1554.62 828.861Z",
    fill: "url(#paint15_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.24 1095.12L1566.76 803.14L1564.76 801.82L1423.03 1094.22C1423.89 1094.37 1424.63 1094.68 1425.24 1095.12Z",
    fill: "url(#paint16_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M1380.18 1096.41L1566.27 923.462C1565.99 922.632 1565.77 921.752 1565.6 920.842L1378.75 1094.5C1379.37 1095.02 1379.86 1095.68 1380.19 1096.41H1380.18Z",
    fill: "url(#paint17_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.43 811.601L1587.6 252.421C1587.1 250.171 1586.9 247.691 1586.96 245.031L1232.64 810.841C1234.24 811.081 1235.84 811.331 1237.43 811.601Z",
    fill: "url(#paint18_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M1481.45 138.051C1480.74 137.691 1480.04 137.301 1479.36 136.881L1084.98 703.541C1085.04 704.841 1084.99 706.301 1084.85 707.901L1481.45 138.051Z",
    fill: "url(#paint19_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.2 467.16C1148.88 467.44 1147.38 467.64 1145.72 467.76L1819.05 769.7L1820.76 767.86L1150.2 467.16Z",
    fill: "url(#paint20_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637.65 783.572L1725.51 393.312L1723.36 392.012L1635.38 782.782C1636.15 783.002 1636.9 783.262 1637.64 783.572H1637.65Z",
    fill: "url(#paint21_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1672.66 799.571L1893.65 593.461C1893.23 592.761 1892.84 592.041 1892.48 591.301L1671.15 797.731C1671.8 798.221 1672.3 798.861 1672.66 799.571Z",
    fill: "url(#paint22_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M1695.16 809.371L1853.87 534.431C1853.22 533.961 1852.6 533.441 1852.01 532.891L1692.75 808.781C1693.55 808.931 1694.36 809.121 1695.16 809.361V809.371Z",
    fill: "url(#paint23_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1436.08 202.391C1435.43 202.791 1434.76 203.171 1434.06 203.521L1890.32 654.301L1892.75 653.571L1436.09 202.391H1436.08Z",
    fill: "url(#paint24_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.87 718.38L1798.55 464.77C1797.82 464.46 1797.1 464.11 1796.4 463.73L1695.49 717.92C1696.32 717.92 1697.14 718.08 1697.87 718.38Z",
    fill: "url(#paint25_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.77 999.67L1516.52 1096.08L1517.86 1098.89L1568.68 1005.11C1568.68 1003.3 1568.71 1001.49 1568.76 999.67H1568.77Z",
    fill: "url(#paint26_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303.41 799.55L1654.41 313.28C1653.78 312.8 1653.17 312.29 1652.58 311.75L1300.12 800.05C1301.2 799.81 1302.3 799.63 1303.41 799.55Z",
    fill: "url(#paint27_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1562.51 801.301L1793.95 468.761C1793.25 468.351 1792.59 467.911 1791.97 467.451L1560.59 799.911C1561.37 800.231 1562.01 800.721 1562.51 801.311V801.301Z",
    fill: "url(#paint28_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.81 139.82L1161.79 781.75C1162.12 783.11 1162.35 784.64 1162.51 786.33L1484.58 142.28C1483.75 141.65 1483.16 140.78 1482.8 139.82H1482.81Z",
    fill: "url(#paint29_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M1476.47 145.081C1476.47 145.081 1476.47 145.061 1476.48 145.051C1476.36 145.021 1476.24 144.991 1476.12 144.951C1475.35 146.441 1474.44 148.211 1473.39 150.271L1498.41 752.661C1499.55 752.991 1500.67 753.381 1501.76 753.851L1476.48 145.081H1476.47Z",
    fill: "url(#paint30_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M1452.77 696.611C1452.55 698.751 1452.21 700.871 1451.72 702.941L1576.31 1085.66C1576.78 1084.03 1577.3 1082.46 1577.89 1080.96L1452.77 696.611Z",
    fill: "url(#paint31_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1535.53 204.69C1534.81 204.53 1534.19 204.22 1533.66 203.83L1493.94 428.51C1493.92 433.82 1493.86 439.08 1493.78 444.27L1535.84 206.37V204.75C1535.73 204.73 1535.63 204.72 1535.54 204.7L1535.53 204.69Z",
    fill: "url(#paint32_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M1240.47 804.971L1060.3 636.941C1060.03 637.751 1059.73 638.551 1059.37 639.331L1239.24 807.091C1239.49 806.301 1239.9 805.581 1240.46 804.971H1240.47Z",
    fill: "url(#paint33_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M1218.32 800.821L1283.24 508.861C1282.34 509.441 1281.46 509.921 1280.6 510.311L1216.1 800.361C1216.85 800.481 1217.59 800.631 1218.31 800.821H1218.32Z",
    fill: "url(#paint34_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1163.9 455.611L1147.86 781.631C1148.66 781.741 1149.45 781.891 1150.22 782.081L1166.35 454.221C1165.56 454.731 1164.74 455.201 1163.9 455.611Z",
    fill: "url(#paint35_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M1064.87 575.961L1065.01 573.73L1567.92 802.72C1567.55 803.31 1567.21 803.92 1566.91 804.55",
    fill: "url(#paint36_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M1537.89 765.581L1195.08 425.631C1194.82 425.951 1194.55 426.271 1194.27 426.571C1194.01 426.851 1193.74 427.131 1193.48 427.391L1534.51 765.581H1537.89Z",
    fill: "url(#paint37_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.04 197.861C1432.16 199.211 1431.14 200.471 1429.99 201.611L1470.58 1094.13L1473.84 1095.02L1433.04 197.861Z",
    fill: "url(#paint38_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.64 420.771L1351.39 287.551C1350.83 288.221 1350.23 288.861 1349.59 289.471L1756.5 423.231C1756.5 422.401 1756.54 421.571 1756.64 420.761V420.771Z",
    fill: "url(#paint39_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M1130.08 779.6L1783.73 457.65L1783.23 454.75L1128.12 777.42C1128.82 778.1 1129.47 778.83 1130.07 779.6H1130.08Z",
    fill: "url(#paint40_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1557.25 831.781L1524.3 547.201C1523.49 547.131 1522.67 547.011 1521.86 546.861L1555.2 834.861C1555.85 833.811 1556.53 832.781 1557.24 831.781H1557.25Z",
    fill: "url(#paint41_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.47 696.031L1315.3 313.381C1314.56 313.681 1313.81 313.941 1313.05 314.161L1477.3 697.001C1478.01 696.661 1478.73 696.341 1479.48 696.041L1479.47 696.031Z",
    fill: "url(#paint42_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M1425.01 661.37L1386.72 246.75C1385.93 246.81 1385.13 246.82 1384.33 246.8L1422.64 661.62C1423.42 661.51 1424.21 661.43 1425.01 661.38V661.37Z",
    fill: "url(#paint43_linear_3544_1524)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1731.65 746.77C1734.14 746.77 1736.15 744.755 1736.15 742.27C1736.15 739.784 1734.14 737.77 1731.65 737.77C1729.16 737.77 1727.15 739.784 1727.15 742.27C1727.15 744.755 1729.16 746.77 1731.65 746.77Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1820.43 773.809C1822.92 773.809 1824.93 771.794 1824.93 769.309C1824.93 766.823 1822.92 764.809 1820.43 764.809C1817.94 764.809 1815.93 766.823 1815.93 769.309C1815.93 771.794 1817.94 773.809 1820.43 773.809Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1823.5 760.5C1825.99 760.5 1828 758.485 1828 756C1828 753.515 1825.99 751.5 1823.5 751.5C1821.01 751.5 1819 753.515 1819 756C1819 758.485 1821.01 760.5 1823.5 760.5Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1787.67 695.539C1790.16 695.539 1792.17 693.524 1792.17 691.039C1792.17 688.554 1790.16 686.539 1787.67 686.539C1785.18 686.539 1783.17 688.554 1783.17 691.039C1783.17 693.524 1785.18 695.539 1787.67 695.539Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1775.18 673.141C1777.67 673.141 1779.68 671.126 1779.68 668.641C1779.68 666.155 1777.67 664.141 1775.18 664.141C1772.69 664.141 1770.68 666.155 1770.68 668.641C1770.68 671.126 1772.69 673.141 1775.18 673.141Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1892.55 659.17C1895.04 659.17 1897.05 657.155 1897.05 654.67C1897.05 652.185 1895.04 650.17 1892.55 650.17C1890.06 650.17 1888.05 652.185 1888.05 654.67C1888.05 657.155 1890.06 659.17 1892.55 659.17Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1893.82 596.389C1896.31 596.389 1898.32 594.374 1898.32 591.889C1898.32 589.403 1896.31 587.389 1893.82 587.389C1891.33 587.389 1889.32 589.403 1889.32 591.889C1889.32 594.374 1891.33 596.389 1893.82 596.389Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1852.97 537.639C1855.46 537.639 1857.47 535.624 1857.47 533.139C1857.47 530.653 1855.46 528.639 1852.97 528.639C1850.48 528.639 1848.47 530.653 1848.47 533.139C1848.47 535.624 1850.48 537.639 1852.97 537.639Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1860.39 627.76C1862.88 627.76 1864.89 625.745 1864.89 623.26C1864.89 620.774 1862.88 618.76 1860.39 618.76C1857.9 618.76 1855.89 620.774 1855.89 623.26C1855.89 625.745 1857.9 627.76 1860.39 627.76Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1822.25 590.139C1824.74 590.139 1826.75 588.124 1826.75 585.639C1826.75 583.153 1824.74 581.139 1822.25 581.139C1819.76 581.139 1817.75 583.153 1817.75 585.639C1817.75 588.124 1819.76 590.139 1822.25 590.139Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1740.76 603.84C1743.25 603.84 1745.26 601.825 1745.26 599.34C1745.26 596.855 1743.25 594.84 1740.76 594.84C1738.27 594.84 1736.26 596.855 1736.26 599.34C1736.26 601.825 1738.27 603.84 1740.76 603.84Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1828.22 513.42C1830.71 513.42 1832.72 511.405 1832.72 508.92C1832.72 506.435 1830.71 504.42 1828.22 504.42C1825.73 504.42 1823.72 506.435 1823.72 508.92C1823.72 511.405 1825.73 513.42 1828.22 513.42Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1756.47 525.09C1758.96 525.09 1760.97 523.075 1760.97 520.59C1760.97 518.105 1758.96 516.09 1756.47 516.09C1753.98 516.09 1751.97 518.105 1751.97 520.59C1751.97 523.075 1753.98 525.09 1756.47 525.09Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1794.87 470.99C1797.36 470.99 1799.37 468.976 1799.37 466.49C1799.37 464.005 1797.36 461.99 1794.87 461.99C1792.38 461.99 1790.37 464.005 1790.37 466.49C1790.37 468.976 1792.38 470.99 1794.87 470.99Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1783.83 460.109C1786.32 460.109 1788.33 458.095 1788.33 455.609C1788.33 453.124 1786.32 451.109 1783.83 451.109C1781.34 451.109 1779.33 453.124 1779.33 455.609C1779.33 458.095 1781.34 460.109 1783.83 460.109Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1756.48 426.26C1758.97 426.26 1760.98 424.245 1760.98 421.76C1760.98 419.274 1758.97 417.26 1756.48 417.26C1753.99 417.26 1751.98 419.274 1751.98 421.76C1751.98 424.245 1753.99 426.26 1756.48 426.26Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1724.84 397.049C1727.33 397.049 1729.34 395.034 1729.34 392.549C1729.34 390.064 1727.33 388.049 1724.84 388.049C1722.35 388.049 1720.34 390.064 1720.34 392.549C1720.34 395.034 1722.35 397.049 1724.84 397.049Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1432.04 204.561C1434.53 204.561 1436.54 202.546 1436.54 200.061C1436.54 197.575 1434.53 195.561 1432.04 195.561C1429.55 195.561 1427.54 197.575 1427.54 200.061C1427.54 202.546 1429.55 204.561 1432.04 204.561Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1480.82 142.6C1483.31 142.6 1485.32 140.585 1485.32 138.1C1485.32 135.614 1483.31 133.6 1480.82 133.6C1478.33 133.6 1476.32 135.614 1476.32 138.1C1476.32 140.585 1478.33 142.6 1480.82 142.6Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1535.63 207.289C1538.12 207.289 1540.13 205.274 1540.13 202.789C1540.13 200.304 1538.12 198.289 1535.63 198.289C1533.14 198.289 1531.13 200.304 1531.13 202.789C1531.13 205.274 1533.14 207.289 1535.63 207.289Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1423.37 1101.26C1425.86 1101.26 1427.87 1099.25 1427.87 1096.76C1427.87 1094.27 1425.86 1092.26 1423.37 1092.26C1420.88 1092.26 1418.87 1094.27 1418.87 1096.76C1418.87 1099.25 1420.88 1101.26 1423.37 1101.26Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1471.87 1101.43C1474.36 1101.43 1476.37 1099.41 1476.37 1096.93C1476.37 1094.44 1474.36 1092.43 1471.87 1092.43C1469.38 1092.43 1467.37 1094.44 1467.37 1096.93C1467.37 1099.41 1469.38 1101.43 1471.87 1101.43Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1577.2 1089.01C1579.69 1089.01 1581.7 1087 1581.7 1084.51C1581.7 1082.02 1579.69 1080.01 1577.2 1080.01C1574.71 1080.01 1572.7 1082.02 1572.7 1084.51C1572.7 1087 1574.71 1089.01 1577.2 1089.01Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1599.08 1096.18C1601.57 1096.18 1603.58 1094.16 1603.58 1091.68C1603.58 1089.19 1601.57 1087.18 1599.08 1087.18C1596.59 1087.18 1594.58 1089.19 1594.58 1091.68C1594.58 1094.16 1596.59 1096.18 1599.08 1096.18Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1517.6 1102.32C1520.09 1102.32 1522.1 1100.31 1522.1 1097.82C1522.1 1095.34 1520.09 1093.32 1517.6 1093.32C1515.11 1093.32 1513.1 1095.34 1513.1 1097.82C1513.1 1100.31 1515.11 1102.32 1517.6 1102.32Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1568.91 1006.25C1571.4 1006.25 1573.41 1004.24 1573.41 1001.75C1573.41 999.265 1571.4 997.25 1568.91 997.25C1566.42 997.25 1564.41 999.265 1564.41 1001.75C1564.41 1004.24 1566.42 1006.25 1568.91 1006.25Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1357.71 1097.86C1360.2 1097.86 1362.21 1095.84 1362.21 1093.36C1362.21 1090.87 1360.2 1088.86 1357.71 1088.86C1355.22 1088.86 1353.21 1090.87 1353.21 1093.36C1353.21 1095.84 1355.22 1097.86 1357.71 1097.86Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1379.95 1099.28C1382.44 1099.28 1384.45 1097.26 1384.45 1094.78C1384.45 1092.29 1382.44 1090.28 1379.95 1090.28C1377.46 1090.28 1375.45 1092.29 1375.45 1094.78C1375.45 1097.26 1377.46 1099.28 1379.95 1099.28Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1493.98 1033.19C1496.47 1033.19 1498.48 1031.17 1498.48 1028.69C1498.48 1026.2 1496.47 1024.19 1493.98 1024.19C1491.49 1024.19 1489.48 1026.2 1489.48 1028.69C1489.48 1031.17 1491.49 1033.19 1493.98 1033.19Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1466.08 1016.63C1468.57 1016.63 1470.58 1014.62 1470.58 1012.13C1470.58 1009.65 1468.57 1007.63 1466.08 1007.63C1463.59 1007.63 1461.58 1009.65 1461.58 1012.13C1461.58 1014.62 1463.59 1016.63 1466.08 1016.63Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1566.81 925.971C1569.3 925.971 1571.31 923.956 1571.31 921.471C1571.31 918.985 1569.3 916.971 1566.81 916.971C1564.32 916.971 1562.31 918.985 1562.31 921.471C1562.31 923.956 1564.32 925.971 1566.81 925.971Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1525.95 929.9C1528.44 929.9 1530.45 927.886 1530.45 925.4C1530.45 922.915 1528.44 920.9 1525.95 920.9C1523.46 920.9 1521.45 922.915 1521.45 925.4C1521.45 927.886 1523.46 929.9 1525.95 929.9Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1517.84 905.471C1520.33 905.471 1522.34 903.456 1522.34 900.971C1522.34 898.485 1520.33 896.471 1517.84 896.471C1515.35 896.471 1513.34 898.485 1513.34 900.971C1513.34 903.456 1515.35 905.471 1517.84 905.471Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1376.46 963.98C1378.95 963.98 1380.96 961.966 1380.96 959.48C1380.96 956.995 1378.95 954.98 1376.46 954.98C1373.97 954.98 1371.96 956.995 1371.96 959.48C1371.96 961.966 1373.97 963.98 1376.46 963.98Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1445.35 895.461C1447.84 895.461 1449.85 893.446 1449.85 890.961C1449.85 888.476 1447.84 886.461 1445.35 886.461C1442.86 886.461 1440.85 888.476 1440.85 890.961C1440.85 893.446 1442.86 895.461 1445.35 895.461Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1461.32 859.15C1463.81 859.15 1465.82 857.136 1465.82 854.65C1465.82 852.165 1463.81 850.15 1461.32 850.15C1458.83 850.15 1456.82 852.165 1456.82 854.65C1456.82 857.136 1458.83 859.15 1461.32 859.15Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1498.36 843.59C1500.85 843.59 1502.86 841.575 1502.86 839.09C1502.86 836.605 1500.85 834.59 1498.36 834.59C1495.87 834.59 1493.86 836.605 1493.86 839.09C1493.86 841.575 1495.87 843.59 1498.36 843.59Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1554.98 830.65C1557.47 830.65 1559.48 828.636 1559.48 826.15C1559.48 823.665 1557.47 821.65 1554.98 821.65C1552.49 821.65 1550.48 823.665 1550.48 826.15C1550.48 828.636 1552.49 830.65 1554.98 830.65Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1235.83 813.84C1238.32 813.84 1240.33 811.825 1240.33 809.34C1240.33 806.855 1238.32 804.84 1235.83 804.84C1233.34 804.84 1231.33 806.855 1231.33 809.34C1231.33 811.825 1233.34 813.84 1235.83 813.84Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1217.15 804.5C1219.64 804.5 1221.65 802.485 1221.65 800C1221.65 797.515 1219.64 795.5 1217.15 795.5C1214.66 795.5 1212.65 797.515 1212.65 800C1212.65 802.485 1214.66 804.5 1217.15 804.5Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1162.57 787.891C1165.06 787.891 1167.07 785.876 1167.07 783.391C1167.07 780.905 1165.06 778.891 1162.57 778.891C1160.08 778.891 1158.07 780.905 1158.07 783.391C1158.07 785.876 1160.08 787.891 1162.57 787.891Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter42_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1148.96 787.57C1151.45 787.57 1153.46 785.556 1153.46 783.07C1153.46 780.585 1151.45 778.57 1148.96 778.57C1146.47 778.57 1144.46 780.585 1144.46 783.07C1144.46 785.556 1146.47 787.57 1148.96 787.57Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1129.34 782.35C1131.83 782.35 1133.84 780.335 1133.84 777.85C1133.84 775.364 1131.83 773.35 1129.34 773.35C1126.85 773.35 1124.84 775.364 1124.84 777.85C1124.84 780.335 1126.85 782.35 1129.34 782.35Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1179.1 755.811C1181.59 755.811 1183.6 753.796 1183.6 751.311C1183.6 748.825 1181.59 746.811 1179.1 746.811C1176.61 746.811 1174.6 748.825 1174.6 751.311C1174.6 753.796 1176.61 755.811 1179.1 755.811Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter45_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1151.59 727.65C1154.08 727.65 1156.09 725.636 1156.09 723.15C1156.09 720.665 1154.08 718.65 1151.59 718.65C1149.1 718.65 1147.09 720.665 1147.09 723.15C1147.09 725.636 1149.1 727.65 1151.59 727.65Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter46_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1233.71 730.34C1236.2 730.34 1238.21 728.325 1238.21 725.84C1238.21 723.355 1236.2 721.34 1233.71 721.34C1231.22 721.34 1229.21 723.355 1229.21 725.84C1229.21 728.325 1231.22 730.34 1233.71 730.34Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter47_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1248.59 663.85C1251.08 663.85 1253.09 661.835 1253.09 659.35C1253.09 656.864 1251.08 654.85 1248.59 654.85C1246.1 654.85 1244.09 656.864 1244.09 659.35C1244.09 661.835 1246.1 663.85 1248.59 663.85Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1228.74 654.59C1231.23 654.59 1233.24 652.575 1233.24 650.09C1233.24 647.605 1231.23 645.59 1228.74 645.59C1226.25 645.59 1224.24 647.605 1224.24 650.09C1224.24 652.575 1226.25 654.59 1228.74 654.59Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter49_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1259.34 616.881C1261.83 616.881 1263.84 614.866 1263.84 612.381C1263.84 609.896 1261.83 607.881 1259.34 607.881C1256.85 607.881 1254.84 609.896 1254.84 612.381C1254.84 614.866 1256.85 616.881 1259.34 616.881Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter50_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1249.91 611.75C1252.4 611.75 1254.41 609.735 1254.41 607.25C1254.41 604.765 1252.4 602.75 1249.91 602.75C1247.42 602.75 1245.41 604.765 1245.41 607.25C1245.41 609.735 1247.42 611.75 1249.91 611.75Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter51_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1157.37 621.65C1159.86 621.65 1161.87 619.636 1161.87 617.15C1161.87 614.665 1159.86 612.65 1157.37 612.65C1154.88 612.65 1152.87 614.665 1152.87 617.15C1152.87 619.636 1154.88 621.65 1157.37 621.65Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter52_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1085.27 709.49C1087.76 709.49 1089.77 707.476 1089.77 704.99C1089.77 702.505 1087.76 700.49 1085.27 700.49C1082.78 700.49 1080.77 702.505 1080.77 704.99C1080.77 707.476 1082.78 709.49 1085.27 709.49Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter53_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1060.6 642.789C1063.09 642.789 1065.1 640.774 1065.1 638.289C1065.1 635.804 1063.09 633.789 1060.6 633.789C1058.11 633.789 1056.1 635.804 1056.1 638.289C1056.1 640.774 1058.11 642.789 1060.6 642.789Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter54_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1064.97 579.07C1067.46 579.07 1069.47 577.056 1069.47 574.57C1069.47 572.085 1067.46 570.07 1064.97 570.07C1062.48 570.07 1060.47 572.085 1060.47 574.57C1060.47 577.056 1062.48 579.07 1064.97 579.07Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter55_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1108.01 530.449C1110.5 530.449 1112.51 528.435 1112.51 525.949C1112.51 523.464 1110.5 521.449 1108.01 521.449C1105.52 521.449 1103.51 523.464 1103.51 525.949C1103.51 528.435 1105.52 530.449 1108.01 530.449Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter56_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1180.86 572.311C1183.35 572.311 1185.36 570.296 1185.36 567.811C1185.36 565.325 1183.35 563.311 1180.86 563.311C1178.37 563.311 1176.36 565.325 1176.36 567.811C1176.36 570.296 1178.37 572.311 1180.86 572.311Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter57_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1160.29 560.629C1162.78 560.629 1164.79 558.614 1164.79 556.129C1164.79 553.644 1162.78 551.629 1160.29 551.629C1157.8 551.629 1155.79 553.644 1155.79 556.129C1155.79 558.614 1157.8 560.629 1160.29 560.629Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter58_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1148.72 471.109C1151.21 471.109 1153.22 469.095 1153.22 466.609C1153.22 464.124 1151.21 462.109 1148.72 462.109C1146.23 462.109 1144.22 464.124 1144.22 466.609C1144.22 469.095 1146.23 471.109 1148.72 471.109Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter59_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1164.23 478.52C1166.72 478.52 1168.73 476.505 1168.73 474.02C1168.73 471.534 1166.72 469.52 1164.23 469.52C1161.74 469.52 1159.73 471.534 1159.73 474.02C1159.73 476.505 1161.74 478.52 1164.23 478.52Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter60_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1165.28 460.01C1167.77 460.01 1169.78 457.995 1169.78 455.51C1169.78 453.024 1167.77 451.01 1165.28 451.01C1162.79 451.01 1160.78 453.024 1160.78 455.51C1160.78 457.995 1162.79 460.01 1165.28 460.01Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter61_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1243.64 481C1246.13 481 1248.14 478.985 1248.14 476.5C1248.14 474.015 1246.13 472 1243.64 472C1241.15 472 1239.14 474.015 1239.14 476.5C1239.14 478.985 1241.15 481 1243.64 481Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter62_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1222.57 397.65C1225.06 397.65 1227.07 395.636 1227.07 393.15C1227.07 390.665 1225.06 388.65 1222.57 388.65C1220.08 388.65 1218.07 390.665 1218.07 393.15C1218.07 395.636 1220.08 397.65 1222.57 397.65Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter63_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1195.1 431.4C1197.59 431.4 1199.6 429.386 1199.6 426.9C1199.6 424.415 1197.59 422.4 1195.1 422.4C1192.61 422.4 1190.6 424.415 1190.6 426.9C1190.6 429.386 1192.61 431.4 1195.1 431.4Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter64_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1259.41 417.92C1261.9 417.92 1263.91 415.905 1263.91 413.42C1263.91 410.935 1261.9 408.92 1259.41 408.92C1256.92 408.92 1254.91 410.935 1254.91 413.42C1254.91 415.905 1256.92 417.92 1259.41 417.92Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter65_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1314.34 318.25C1316.83 318.25 1318.84 316.235 1318.84 313.75C1318.84 311.265 1316.83 309.25 1314.34 309.25C1311.85 309.25 1309.84 311.265 1309.84 313.75C1309.84 316.235 1311.85 318.25 1314.34 318.25Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter66_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1350.68 292.82C1353.17 292.82 1355.18 290.806 1355.18 288.32C1355.18 285.835 1353.17 283.82 1350.68 283.82C1348.19 283.82 1346.18 285.835 1346.18 288.32C1346.18 290.806 1348.19 292.82 1350.68 292.82Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter67_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1370.29 299.1C1372.78 299.1 1374.79 297.085 1374.79 294.6C1374.79 292.114 1372.78 290.1 1370.29 290.1C1367.8 290.1 1365.79 292.114 1365.79 294.6C1365.79 297.085 1367.8 299.1 1370.29 299.1Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter68_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1385.5 252.09C1387.99 252.09 1390 250.075 1390 247.59C1390 245.105 1387.99 243.09 1385.5 243.09C1383.01 243.09 1381 245.105 1381 247.59C1381 250.075 1383.01 252.09 1385.5 252.09Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter69_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1392.2 327.9C1394.69 327.9 1396.7 325.886 1396.7 323.4C1396.7 320.915 1394.69 318.9 1392.2 318.9C1389.71 318.9 1387.7 320.915 1387.7 323.4C1387.7 325.886 1389.71 327.9 1392.2 327.9Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter70_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1587.69 253.279C1590.18 253.279 1592.19 251.265 1592.19 248.779C1592.19 246.294 1590.18 244.279 1587.69 244.279C1585.2 244.279 1583.19 246.294 1583.19 248.779C1583.19 251.265 1585.2 253.279 1587.69 253.279Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter71_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1563.26 290.5C1565.75 290.5 1567.76 288.485 1567.76 286C1567.76 283.515 1565.75 281.5 1563.26 281.5C1560.77 281.5 1558.76 283.515 1558.76 286C1558.76 288.485 1560.77 290.5 1563.26 290.5Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter72_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1535.96 334.949C1538.45 334.949 1540.46 332.935 1540.46 330.449C1540.46 327.964 1538.45 325.949 1535.96 325.949C1533.47 325.949 1531.46 327.964 1531.46 330.449C1531.46 332.935 1533.47 334.949 1535.96 334.949Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter73_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1521.49 290.359C1523.98 290.359 1525.99 288.345 1525.99 285.859C1525.99 283.374 1523.98 281.359 1521.49 281.359C1519 281.359 1516.99 283.374 1516.99 285.859C1516.99 288.345 1519 290.359 1521.49 290.359Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter74_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1478.93 250.51C1481.42 250.51 1483.43 248.495 1483.43 246.01C1483.43 243.524 1481.42 241.51 1478.93 241.51C1476.44 241.51 1474.43 243.524 1474.43 246.01C1474.43 248.495 1476.44 250.51 1478.93 250.51Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter75_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1482.62 336.699C1485.11 336.699 1487.12 334.685 1487.12 332.199C1487.12 329.714 1485.11 327.699 1482.62 327.699C1480.13 327.699 1478.12 329.714 1478.12 332.199C1478.12 334.685 1480.13 336.699 1482.62 336.699Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter76_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1671.34 332.77C1673.83 332.77 1675.84 330.755 1675.84 328.27C1675.84 325.784 1673.83 323.77 1671.34 323.77C1668.85 323.77 1666.84 325.784 1666.84 328.27C1666.84 330.755 1668.85 332.77 1671.34 332.77Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter77_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1654.1 316.6C1656.59 316.6 1658.6 314.585 1658.6 312.1C1658.6 309.614 1656.59 307.6 1654.1 307.6C1651.61 307.6 1649.6 309.614 1649.6 312.1C1649.6 314.585 1651.61 316.6 1654.1 316.6Z",
    fill: "#8FFFFC"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter78_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1867.22 707.42C1869.71 707.42 1871.72 705.405 1871.72 702.92C1871.72 700.435 1869.71 698.42 1867.22 698.42C1864.73 698.42 1862.72 700.435 1862.72 702.92C1862.72 705.405 1864.73 707.42 1867.22 707.42Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter79_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.76 224.961H90.61L110.83 273.141H111.19L131.23 224.961H144.08V288.601H135.45V236.291H135.27L113.79 288.601H108.04L86.56 236.291H86.38V288.601H77.75V224.961H77.76Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.26 224.961H202.34V233.051H169.89V252.021H200.09V260.111H169.89V280.511H203.96V288.601H161.27V224.961H161.26Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.95 224.961H261.03V233.051H228.58V252.021H258.78V260.111H228.58V280.511H262.65V288.601H219.96V224.961H219.95Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.41 233.051H270.92V224.961H320.54V233.051H300.05V288.601H291.42V233.051H291.41Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.37 261.451L350.28 224.961H361.33L378.68 252.911L396.57 224.961H407.09L383 261.451V288.591H374.37V261.451Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.01 290.21C440.16 290.21 435.69 289.36 431.62 287.65C427.54 285.94 424.05 283.59 421.15 280.59C418.24 277.59 415.97 274.06 414.32 269.98C412.67 265.91 411.85 261.5 411.85 256.77C411.85 252.04 412.67 247.63 414.32 243.56C415.97 239.49 418.24 235.95 421.15 232.95C424.06 229.95 427.55 227.6 431.62 225.89C435.69 224.18 440.16 223.33 445.01 223.33C449.86 223.33 454.33 224.18 458.4 225.89C462.47 227.6 465.96 229.95 468.87 232.95C471.78 235.95 474.05 239.48 475.7 243.56C477.35 247.64 478.17 252.04 478.17 256.77C478.17 261.5 477.35 265.91 475.7 269.98C474.05 274.06 471.77 277.59 468.87 280.59C465.96 283.59 462.47 285.94 458.4 287.65C454.32 289.36 449.86 290.21 445.01 290.21ZM445.01 282.12C448.66 282.12 451.96 281.45 454.9 280.1C457.83 278.75 460.35 276.94 462.45 274.66C464.55 272.38 466.16 269.7 467.3 266.62C468.44 263.53 469.01 260.25 469.01 256.78C469.01 253.31 468.44 250.02 467.3 246.94C466.16 243.85 464.54 241.17 462.45 238.9C460.35 236.62 457.83 234.81 454.9 233.46C451.96 232.11 448.67 231.44 445.01 231.44C441.35 231.44 438.06 232.11 435.12 233.46C432.18 234.81 429.67 236.62 427.57 238.9C425.47 241.18 423.85 243.86 422.72 246.94C421.58 250.03 421.01 253.31 421.01 256.78C421.01 260.25 421.58 263.54 422.72 266.62C423.86 269.71 425.47 272.39 427.57 274.66C429.67 276.94 432.18 278.75 435.12 280.1C438.06 281.45 441.35 282.12 445.01 282.12Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.57 224.961V263.971C499.57 265.951 499.84 268.001 500.38 270.131C500.92 272.261 501.82 274.221 503.08 276.021C504.34 277.821 505.99 279.291 508.02 280.421C510.06 281.561 512.57 282.131 515.57 282.131C518.57 282.131 521.08 281.561 523.12 280.421C525.16 279.281 526.81 277.811 528.06 276.021C529.32 274.221 530.22 272.261 530.76 270.131C531.3 268.001 531.57 265.951 531.57 263.971V224.961H540.2V265.321C540.2 269.041 539.57 272.411 538.31 275.431C537.05 278.461 535.31 281.081 533.1 283.291C530.88 285.511 528.28 287.221 525.28 288.411C522.28 289.611 519.05 290.211 515.57 290.211C512.09 290.211 508.86 289.611 505.86 288.411C502.86 287.211 500.26 285.501 498.04 283.291C495.82 281.071 494.08 278.451 492.83 275.431C491.57 272.401 490.94 269.031 490.94 265.321V224.961H499.57Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.63 224.961H580.01C584.08 224.961 587.44 225.511 590.08 226.621C592.72 227.731 594.8 229.141 596.33 230.841C597.86 232.551 598.92 234.471 599.52 236.591C600.12 238.721 600.42 240.771 600.42 242.751C600.42 244.731 600.06 246.751 599.34 248.641C598.62 250.531 597.59 252.241 596.24 253.761C594.89 255.291 593.24 256.581 591.3 257.621C589.35 258.671 587.18 259.311 584.78 259.551L602.85 288.581H592.06L575.88 260.541H566.26V288.581H557.63V224.941V224.961ZM566.26 253.001H577.59C579.27 253.001 580.93 252.871 582.58 252.601C584.23 252.331 585.7 251.841 586.98 251.121C588.27 250.401 589.3 249.371 590.08 248.021C590.86 246.671 591.25 244.921 591.25 242.761C591.25 240.601 590.86 238.851 590.08 237.501C589.3 236.151 588.27 235.121 586.98 234.401C585.69 233.681 584.22 233.191 582.58 232.921C580.93 232.651 579.27 232.521 577.59 232.521H566.26V253.011V253.001Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3899 339.26H118.39V347.35H87.0199V367.3H116.23V375.39H87.0199V402.89H78.3899V339.25V339.26Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.33 339.26H155.15L182.38 402.9H172.31L165.93 387.17H135.64L129.35 402.9H119.28L147.32 339.26H147.33ZM162.79 379.62L150.93 350.41H150.75L138.71 379.62H162.8H162.79Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.14 339.26H190.12L208.82 391.03H209L228.42 339.26H237.86L212.78 402.9H204.69L180.15 339.26H180.14Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.48 404.521C272.63 404.521 268.16 403.671 264.09 401.961C260.01 400.251 256.52 397.901 253.62 394.901C250.71 391.901 248.44 388.371 246.79 384.291C245.14 380.221 244.32 375.811 244.32 371.081C244.32 366.351 245.14 361.941 246.79 357.871C248.44 353.801 250.71 350.261 253.62 347.261C256.53 344.261 260.02 341.911 264.09 340.201C268.16 338.491 272.63 337.641 277.48 337.641C282.33 337.641 286.8 338.491 290.87 340.201C294.94 341.911 298.43 344.261 301.34 347.261C304.25 350.261 306.52 353.791 308.17 357.871C309.82 361.951 310.64 366.351 310.64 371.081C310.64 375.811 309.82 380.221 308.17 384.291C306.52 388.371 304.24 391.901 301.34 394.901C298.43 397.901 294.94 400.251 290.87 401.961C286.79 403.671 282.33 404.521 277.48 404.521ZM277.48 396.431C281.13 396.431 284.43 395.761 287.37 394.411C290.3 393.061 292.82 391.251 294.92 388.971C297.02 386.691 298.63 384.011 299.77 380.931C300.91 377.841 301.48 374.561 301.48 371.091C301.48 367.621 300.91 364.331 299.77 361.251C298.63 358.161 297.01 355.481 294.92 353.211C292.82 350.931 290.3 349.121 287.37 347.771C284.43 346.421 281.14 345.751 277.48 345.751C273.82 345.751 270.53 346.421 267.59 347.771C264.65 349.121 262.14 350.931 260.04 353.211C257.94 355.491 256.32 358.171 255.19 361.251C254.05 364.341 253.48 367.621 253.48 371.091C253.48 374.561 254.05 377.851 255.19 380.931C256.33 384.021 257.94 386.701 260.04 388.971C262.14 391.251 264.65 393.061 267.59 394.411C270.53 395.761 273.82 396.431 277.48 396.431Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.48 339.26H346.86C350.93 339.26 354.29 339.81 356.93 340.92C359.57 342.03 361.65 343.44 363.18 345.14C364.71 346.85 365.77 348.77 366.37 350.89C366.97 353.02 367.27 355.07 367.27 357.05C367.27 359.03 366.91 361.05 366.19 362.94C365.47 364.83 364.44 366.54 363.09 368.06C361.74 369.59 360.09 370.88 358.15 371.92C356.2 372.97 354.03 373.61 351.63 373.85L369.7 402.88H358.91L342.73 374.84H333.11V402.88H324.48V339.24V339.26ZM333.11 367.31H344.44C346.12 367.31 347.78 367.18 349.43 366.91C351.08 366.64 352.55 366.15 353.83 365.43C355.12 364.71 356.15 363.68 356.93 362.33C357.71 360.98 358.1 359.23 358.1 357.07C358.1 354.91 357.71 353.16 356.93 351.81C356.15 350.46 355.12 349.43 353.83 348.71C352.54 347.99 351.07 347.5 349.43 347.23C347.78 346.96 346.12 346.83 344.44 346.83H333.11V367.32V367.31Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.37 339.26H391V402.9H382.37V339.26Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.62 347.35H403.13V339.26H452.75V347.35H432.26V402.9H423.63V347.35H423.62Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.88 339.26H505.96V347.35H473.51V366.32H503.71V374.41H473.51V394.81H507.58V402.9H464.89V339.26H464.88Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.7 467.32C120.9 464.98 118.62 463.19 115.87 461.93C113.11 460.67 110.27 460.04 107.33 460.04C103.74 460.04 100.48 460.71 97.5799 462.06C94.6699 463.41 92.1899 465.25 90.1199 467.59C88.0499 469.93 86.4499 472.67 85.3099 475.81C84.1699 478.96 83.5999 482.33 83.5999 485.92C83.5999 489.28 84.1399 492.45 85.2199 495.45C86.2999 498.45 87.8599 501.08 89.8899 503.36C91.9299 505.64 94.4099 507.44 97.3499 508.75C100.28 510.07 103.61 510.73 107.33 510.73C111.05 510.73 114.19 509.98 116.95 508.48C119.71 506.98 122.04 504.88 123.96 502.19L131.24 507.67C130.76 508.33 129.92 509.27 128.72 510.5C127.52 511.73 125.93 512.96 123.96 514.19C121.98 515.42 119.6 516.5 116.81 517.43C114.02 518.36 110.8 518.82 107.15 518.82C102.12 518.82 97.5799 517.86 93.5299 515.94C89.4799 514.02 86.0399 511.51 83.1899 508.39C80.3399 505.28 78.1699 501.75 76.6699 497.83C75.1699 493.91 74.4199 489.94 74.4199 485.92C74.4199 481.01 75.2299 476.47 76.8499 472.3C78.4699 468.14 80.7299 464.54 83.6399 461.51C86.5499 458.48 90.0399 456.13 94.1099 454.45C98.1799 452.77 102.68 451.93 107.59 451.93C111.78 451.93 115.9 452.74 119.95 454.36C123.99 455.98 127.3 458.47 129.88 461.82L122.69 467.3L122.7 467.32Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.98 453.571H168.36C172.43 453.571 175.79 454.121 178.43 455.231C181.07 456.341 183.15 457.751 184.68 459.451C186.21 461.161 187.27 463.081 187.87 465.201C188.47 467.331 188.77 469.381 188.77 471.361C188.77 473.341 188.41 475.361 187.69 477.251C186.97 479.141 185.94 480.851 184.59 482.371C183.24 483.901 181.59 485.191 179.65 486.231C177.7 487.281 175.53 487.921 173.13 488.161L191.2 517.191H180.41L164.23 489.151H154.61V517.191H145.98V453.551V453.571ZM154.61 481.611H165.94C167.62 481.611 169.28 481.481 170.93 481.211C172.58 480.941 174.05 480.451 175.33 479.731C176.62 479.011 177.65 477.981 178.43 476.631C179.21 475.281 179.6 473.531 179.6 471.371C179.6 469.211 179.21 467.461 178.43 466.111C177.65 464.761 176.62 463.731 175.33 463.011C174.04 462.291 172.57 461.801 170.93 461.531C169.28 461.261 167.62 461.131 165.94 461.131H154.61V481.621V481.611Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.21 453.57H246.29V461.66H213.84V480.63H244.04V488.72H213.84V509.12H247.91V517.21H205.22V453.57H205.21Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.81 453.57H295.63L322.86 517.21H312.79L306.41 501.48H276.12L269.83 517.21H259.76L287.8 453.57H287.81ZM303.27 493.93L291.41 464.72H291.23L279.19 493.93H303.28H303.27Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.9 461.66H323.41V453.57H373.03V461.66H352.54V517.21H343.91V461.66H343.9Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.7 518.821C411.85 518.821 407.38 517.971 403.31 516.261C399.23 514.551 395.74 512.201 392.84 509.201C389.93 506.201 387.66 502.671 386.01 498.591C384.36 494.521 383.54 490.111 383.54 485.381C383.54 480.651 384.36 476.241 386.01 472.171C387.66 468.101 389.93 464.561 392.84 461.561C395.75 458.561 399.24 456.211 403.31 454.501C407.38 452.791 411.85 451.941 416.7 451.941C421.55 451.941 426.02 452.791 430.09 454.501C434.16 456.211 437.65 458.561 440.56 461.561C443.47 464.561 445.74 468.091 447.39 472.171C449.04 476.251 449.86 480.651 449.86 485.381C449.86 490.111 449.04 494.521 447.39 498.591C445.74 502.671 443.46 506.201 440.56 509.201C437.65 512.201 434.16 514.551 430.09 516.261C426.01 517.971 421.55 518.821 416.7 518.821ZM416.7 510.731C420.35 510.731 423.65 510.061 426.59 508.711C429.52 507.361 432.04 505.551 434.14 503.271C436.24 500.991 437.85 498.311 438.99 495.231C440.13 492.141 440.7 488.861 440.7 485.391C440.7 481.921 440.13 478.631 438.99 475.551C437.85 472.461 436.23 469.781 434.14 467.511C432.04 465.231 429.52 463.421 426.59 462.071C423.65 460.721 420.36 460.051 416.7 460.051C413.04 460.051 409.75 460.721 406.81 462.071C403.87 463.421 401.36 465.231 399.26 467.511C397.16 469.791 395.54 472.471 394.41 475.551C393.27 478.641 392.7 481.921 392.7 485.391C392.7 488.861 393.27 492.151 394.41 495.231C395.55 498.321 397.16 501.001 399.26 503.271C401.36 505.551 403.87 507.361 406.81 508.711C409.75 510.061 413.04 510.731 416.7 510.731Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.71 453.571H486.09C490.16 453.571 493.52 454.121 496.16 455.231C498.8 456.341 500.88 457.751 502.41 459.451C503.94 461.161 505 463.081 505.6 465.201C506.2 467.331 506.5 469.381 506.5 471.361C506.5 473.341 506.14 475.361 505.42 477.251C504.7 479.141 503.67 480.851 502.32 482.371C500.97 483.901 499.32 485.191 497.38 486.231C495.43 487.281 493.26 487.921 490.86 488.161L508.93 517.191H498.14L481.96 489.151H472.34V517.191H463.71V453.551V453.571ZM472.34 481.611H483.67C485.35 481.611 487.01 481.481 488.66 481.211C490.31 480.941 491.78 480.451 493.06 479.731C494.35 479.011 495.38 477.981 496.16 476.631C496.94 475.281 497.33 473.531 497.33 471.371C497.33 469.211 496.94 467.461 496.16 466.111C495.38 464.761 494.35 463.731 493.06 463.011C491.77 462.291 490.3 461.801 488.66 461.531C487.01 461.261 485.35 461.131 483.67 461.131H472.34V481.621V481.611Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.56 503.901C526.12 506.241 528.11 507.961 530.54 509.071C532.97 510.181 535.47 510.731 538.04 510.731C539.48 510.731 540.95 510.511 542.44 510.061C543.94 509.611 545.3 508.941 546.53 508.041C547.76 507.141 548.76 506.031 549.54 504.711C550.32 503.391 550.71 501.861 550.71 500.131C550.71 497.671 549.93 495.801 548.37 494.511C546.81 493.221 544.88 492.141 542.57 491.271C540.26 490.401 537.75 489.561 535.02 488.751C532.29 487.941 529.78 486.821 527.47 485.381C525.16 483.941 523.23 482.011 521.67 479.581C520.11 477.151 519.33 473.871 519.33 469.741C519.33 467.881 519.73 465.911 520.54 463.811C521.35 461.711 522.62 459.801 524.36 458.061C526.1 456.321 528.33 454.871 531.06 453.701C533.79 452.531 537.07 451.951 540.9 451.951C544.37 451.951 547.7 452.431 550.88 453.391C554.05 454.351 556.84 456.301 559.24 459.231L552.23 465.611C551.15 463.931 549.62 462.581 547.65 461.571C545.67 460.551 543.43 460.041 540.91 460.041C538.39 460.041 536.52 460.351 534.93 460.981C533.34 461.611 532.07 462.421 531.11 463.411C530.15 464.401 529.48 465.461 529.09 466.601C528.7 467.741 528.51 468.791 528.51 469.751C528.51 472.451 529.29 474.511 530.85 475.951C532.41 477.391 534.34 478.561 536.65 479.461C538.96 480.361 541.47 481.171 544.2 481.891C546.93 482.611 549.44 483.611 551.75 484.901C554.06 486.191 555.99 487.931 557.55 490.111C559.11 492.301 559.89 495.311 559.89 499.141C559.89 502.201 559.31 504.951 558.14 507.411C556.97 509.871 555.4 511.931 553.42 513.611C551.44 515.291 549.11 516.581 546.41 517.471C543.71 518.371 540.84 518.821 537.78 518.821C533.7 518.821 529.84 518.101 526.19 516.661C522.53 515.221 519.63 513.011 517.47 510.011L524.57 503.901H524.56Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.02 453.57H604.01L618.08 504.44H618.26L633.23 453.57H643.12L658.08 504.44H658.26L672.33 453.57H681.32L662.8 517.21H653.63L638.26 465.26H638.08L622.8 517.21H613.63L595.02 453.57Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.73 453.57H701.36V517.21H692.73V453.57Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.17 461.66H712.68V453.57H762.3V461.66H741.81V517.21H733.18V461.66H733.17Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.62 453.57H782.25V480H815.24V453.57H823.87V517.21H815.24V488.09H782.25V517.21H773.62V453.57Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter80_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.49 565.569H100.87C104.94 565.569 108.3 566.119 110.94 567.229C113.58 568.339 115.66 569.749 117.19 571.449C118.72 573.159 119.78 575.079 120.38 577.199C120.98 579.329 121.28 581.379 121.28 583.359C121.28 585.339 120.98 587.389 120.38 589.519C119.78 591.649 118.72 593.559 117.19 595.269C115.66 596.979 113.58 598.389 110.94 599.489C108.3 600.599 104.95 601.149 100.87 601.149H87.12V629.189H78.49V565.549V565.569ZM87.11 593.619H98.44C100.12 593.619 101.78 593.489 103.43 593.219C105.08 592.949 106.55 592.459 107.83 591.739C109.12 591.019 110.15 589.989 110.93 588.639C111.71 587.289 112.1 585.539 112.1 583.379C112.1 581.219 111.71 579.469 110.93 578.119C110.15 576.769 109.12 575.739 107.83 575.019C106.54 574.299 105.07 573.809 103.43 573.539C101.78 573.269 100.12 573.139 98.44 573.139H87.11V593.629V593.619Z",
    fill: "#88D3E1",
    stroke: "#88D3E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.78 630.829C158.93 630.829 154.46 629.979 150.39 628.269C146.31 626.559 142.82 624.209 139.92 621.209C137.01 618.209 134.74 614.679 133.09 610.599C131.44 606.529 130.62 602.119 130.62 597.389C130.62 592.659 131.44 588.249 133.09 584.179C134.74 580.109 137.01 576.569 139.92 573.569C142.83 570.569 146.32 568.219 150.39 566.509C154.46 564.799 158.93 563.949 163.78 563.949C168.63 563.949 173.1 564.799 177.17 566.509C181.24 568.219 184.73 570.569 187.64 573.569C190.55 576.569 192.82 580.099 194.47 584.179C196.12 588.259 196.94 592.659 196.94 597.389C196.94 602.119 196.12 606.529 194.47 610.599C192.82 614.679 190.54 618.209 187.64 621.209C184.73 624.209 181.24 626.559 177.17 628.269C173.09 629.979 168.63 630.829 163.78 630.829ZM163.78 622.739C167.43 622.739 170.73 622.069 173.67 620.719C176.6 619.369 179.12 617.559 181.22 615.279C183.32 612.999 184.93 610.319 186.07 607.239C187.21 604.149 187.78 600.869 187.78 597.399C187.78 593.929 187.21 590.639 186.07 587.559C184.93 584.469 183.31 581.789 181.22 579.519C179.12 577.239 176.6 575.429 173.67 574.079C170.73 572.729 167.44 572.059 163.78 572.059C160.12 572.059 156.83 572.729 153.89 574.079C150.95 575.429 148.44 577.239 146.34 579.519C144.24 581.799 142.62 584.479 141.49 587.559C140.35 590.649 139.78 593.929 139.78 597.399C139.78 600.869 140.35 604.159 141.49 607.239C142.63 610.329 144.24 613.009 146.34 615.279C148.44 617.559 150.95 619.369 153.89 620.719C156.83 622.069 160.12 622.739 163.78 622.739Z",
    fill: "#88D3E1",
    stroke: "#88D3E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.14 565.57H220.77V621.12H249.98V629.21H212.14V565.57Z",
    fill: "#88D3E1",
    stroke: "#88D3E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.24 565.57H298.06L325.29 629.21H315.22L308.84 613.48H278.55L272.26 629.21H262.19L290.23 565.57H290.24ZM305.7 605.93L293.84 576.72H293.66L281.62 605.93H305.71H305.7Z",
    fill: "#88D3E1",
    stroke: "#88D3E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.07 565.569H367.45C371.52 565.569 374.88 566.119 377.52 567.229C380.16 568.339 382.24 569.749 383.77 571.449C385.3 573.159 386.36 575.079 386.96 577.199C387.56 579.329 387.86 581.379 387.86 583.359C387.86 585.339 387.5 587.359 386.78 589.249C386.06 591.139 385.03 592.849 383.68 594.369C382.33 595.899 380.68 597.189 378.74 598.229C376.79 599.279 374.62 599.919 372.22 600.159L390.29 629.189H379.5L363.32 601.149H353.7V629.189H345.07V565.549V565.569ZM353.7 593.619H365.03C366.71 593.619 368.37 593.489 370.02 593.219C371.67 592.949 373.14 592.459 374.42 591.739C375.71 591.019 376.74 589.989 377.52 588.639C378.3 587.289 378.69 585.539 378.69 583.379C378.69 581.219 378.3 579.469 377.52 578.119C376.74 576.769 375.71 575.739 374.42 575.019C373.13 574.299 371.66 573.809 370.02 573.539C368.37 573.269 366.71 573.139 365.03 573.139H353.7V593.629V593.619Z",
    fill: "#88D3E1",
    stroke: "#88D3E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.81 565.57H455.63L482.86 629.21H472.79L466.41 613.48H436.12L429.83 629.21H419.76L447.8 565.57H447.81ZM463.27 605.93L451.41 576.72H451.23L439.19 605.93H463.28H463.27Z",
    fill: "#88D3E1",
    stroke: "#88D3E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.88 579.329C535.08 576.989 532.8 575.199 530.05 573.939C527.29 572.679 524.45 572.049 521.51 572.049C517.92 572.049 514.66 572.719 511.76 574.069C508.85 575.419 506.37 577.259 504.3 579.599C502.23 581.939 500.63 584.679 499.49 587.819C498.35 590.969 497.78 594.339 497.78 597.929C497.78 601.289 498.32 604.459 499.4 607.459C500.48 610.459 502.04 613.089 504.07 615.369C506.11 617.649 508.59 619.449 511.53 620.759C514.46 622.079 517.79 622.739 521.51 622.739C525.23 622.739 528.37 621.989 531.13 620.489C533.89 618.989 536.22 616.889 538.14 614.199L545.42 619.679C544.94 620.339 544.1 621.279 542.9 622.509C541.7 623.739 540.11 624.969 538.14 626.199C536.16 627.429 533.78 628.509 530.99 629.439C528.2 630.369 524.98 630.829 521.33 630.829C516.3 630.829 511.76 629.869 507.71 627.949C503.66 626.029 500.22 623.519 497.37 620.399C494.52 617.289 492.35 613.759 490.85 609.839C489.35 605.919 488.6 601.949 488.6 597.929C488.6 593.019 489.41 588.479 491.03 584.309C492.65 580.149 494.91 576.549 497.82 573.519C500.73 570.489 504.22 568.139 508.29 566.459C512.36 564.779 516.86 563.939 521.77 563.939C525.96 563.939 530.08 564.749 534.13 566.369C538.17 567.989 541.48 570.479 544.06 573.829L536.87 579.309L536.88 579.329Z",
    fill: "#88D3E1",
    stroke: "#88D3E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.17 565.57H600.25V573.66H567.8V592.63H598V600.72H567.8V621.12H601.87V629.21H559.18V565.57H559.17Z",
    fill: "#88D3E1",
    stroke: "#88D3E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.73 629.749C620.11 629.749 618.72 629.169 617.55 627.999C616.38 626.829 615.8 625.439 615.8 623.819C615.8 622.199 616.38 620.809 617.55 619.639C618.72 618.469 620.11 617.889 621.73 617.889C623.35 617.889 624.74 618.469 625.91 619.639C627.08 620.809 627.66 622.199 627.66 623.819C627.66 625.439 627.08 626.829 625.91 627.999C624.74 629.169 623.35 629.749 621.73 629.749Z",
    fill: "#88D3E1",
    stroke: "#88D3E1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter81_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1828.45 803.92C1827.84 804.58 1827.19 805.22 1826.53 805.83L1922.6 891.1C1922.45 889.87 1922.42 888.63 1922.52 887.41L1828.45 803.92Z",
    fill: "url(#paint44_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.28 283.679L1067.67 128.709C1066.78 128.849 1065.87 128.929 1064.96 128.929C1064.56 128.929 1064.16 128.889 1063.77 128.869L1240.32 285.559C1240.95 284.909 1241.6 284.279 1242.28 283.689V283.679Z",
    fill: "url(#paint45_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.22 1099.16C413.22 1099.16 414.18 1099.26 415.13 1099.41L-83.32 658.27C-83.86 658.85 -84.43 659.41 -85.03 659.94L411.28 1099.19C411.59 1099.17 411.9 1099.16 412.21 1099.16H412.22Z",
    fill: "url(#paint46_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.81 1099.69L1272.95 129.49C1271.18 129.57 1269.39 129.41 1267.6 129L636.63 1098.93C638.38 1099.1 640.1 1099.36 641.8 1099.69H641.81Z",
    fill: "url(#paint47_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.52 173.5L271.88 130.51C270.73 130.99 269.56 131.42 268.37 131.79L285.62 173.83C286.92 173.68 288.23 173.57 289.53 173.51L289.52 173.5Z",
    fill: "url(#paint48_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.48 1099.37L483.21 684.459C482.01 684.809 480.79 685.109 479.54 685.359L649.45 1099.38C650.79 1099.38 652.14 1099.38 653.48 1099.37Z",
    fill: "url(#paint49_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608.33 215.489C1609.11 215.459 1609.88 215.469 1610.64 215.499L1607.02 131.459C1605.91 131.809 1604.79 132.099 1603.68 132.329L1607.26 215.569C1607.61 215.539 1607.97 215.509 1608.32 215.499L1608.33 215.489Z",
    fill: "url(#paint50_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635.91 880.85L1645.68 1107.8H1649.05L1639.3 881.17C1638.17 881.12 1637.04 881.02 1635.91 880.86V880.85Z",
    fill: "url(#paint51_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.6 126.339L912.59 307.359C913.47 308.009 914.31 308.709 915.13 309.449L1112.12 124.699C1109.94 125.449 1107.78 126.009 1105.6 126.339Z",
    fill: "url(#paint52_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.08 1099.24L539.97 700.379C539.15 699.609 538.38 698.789 537.65 697.939L110.87 1098.57C112.29 1098.72 113.7 1098.94 115.09 1099.23L115.08 1099.24Z",
    fill: "url(#paint53_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.01 376.2L829.83 133.23C827.68 133.61 825.51 133.9 823.31 134.09L1136.82 380.46C1137.44 378.98 1138.17 377.56 1139.02 376.2H1139.01Z",
    fill: "url(#paint54_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723.71 835.68C1722.92 837.04 1722.02 838.33 1721.03 839.56L1950.68 1020.02C1952.46 1019.42 1954.32 1018.88 1956.24 1018.4L1723.71 835.67V835.68Z",
    fill: "url(#paint55_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.41 446.83L1033.12 130.18C1031.85 131.26 1030.55 132.26 1029.21 133.16L1095.24 448.55C1096.59 447.88 1097.99 447.31 1099.42 446.83H1099.41Z",
    fill: "url(#paint56_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.87 845.47C1181.29 845.45 1179.75 845.32 1178.25 845.07L1231.55 1099.67C1232.97 1099.16 1234.4 1098.78 1235.85 1098.54L1182.87 845.47Z",
    fill: "url(#paint57_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.52 158.18L-23.79 111.84C-23.66 113.11 -23.57 114.41 -23.5 115.73L44.07 162.25C43.88 160.89 43.7 159.53 43.52 158.18Z",
    fill: "url(#paint58_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.12 1098.06L504.6 734.081C502.59 734.031 500.59 733.961 498.58 733.891L992.62 1099.74C993.75 1099.11 994.92 1098.55 996.12 1098.06Z",
    fill: "url(#paint59_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.86 319.19L1920.2 136.25L1919.61 127.18L1774.2 315.38C1775.79 316.57 1777.35 317.84 1778.86 319.19Z",
    fill: "url(#paint60_linear_3544_1524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.93 941.449L921.13 1045.04C921.62 1045.91 922.22 1047.08 922.69 1048.12L1200.1 945.409C1200.32 944.119 1200.6 942.799 1200.93 941.449Z",
    fill: "url(#paint61_linear_3544_1524)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter82_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1301.29 805.141C1303.78 805.141 1305.79 803.126 1305.79 800.641C1305.79 798.155 1303.78 796.141 1301.29 796.141C1298.8 796.141 1296.79 798.155 1296.79 800.641C1296.79 803.126 1298.8 805.141 1301.29 805.141Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter83_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1425.9 791.18C1428.39 791.18 1430.4 789.165 1430.4 786.68C1430.4 784.194 1428.39 782.18 1425.9 782.18C1423.41 782.18 1421.4 784.194 1421.4 786.68C1421.4 789.165 1423.41 791.18 1425.9 791.18Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter84_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1548.02 795.82C1550.51 795.82 1552.52 793.806 1552.52 791.32C1552.52 788.835 1550.51 786.82 1548.02 786.82C1545.53 786.82 1543.52 788.835 1543.52 791.32C1543.52 793.806 1545.53 795.82 1548.02 795.82Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter85_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1564.13 806.279C1566.62 806.279 1568.63 804.265 1568.63 801.779C1568.63 799.294 1566.62 797.279 1564.13 797.279C1561.64 797.279 1559.63 799.294 1559.63 801.779C1559.63 804.265 1561.64 806.279 1564.13 806.279Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter86_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1671.43 803.08C1673.92 803.08 1675.93 801.065 1675.93 798.58C1675.93 796.095 1673.92 794.08 1671.43 794.08C1668.94 794.08 1666.93 796.095 1666.93 798.58C1666.93 801.065 1668.94 803.08 1671.43 803.08Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter87_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1636.38 787.881C1638.87 787.881 1640.88 785.866 1640.88 783.381C1640.88 780.896 1638.87 778.881 1636.38 778.881C1633.89 778.881 1631.88 780.896 1631.88 783.381C1631.88 785.866 1633.89 787.881 1636.38 787.881Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter88_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1694.38 813.17C1696.87 813.17 1698.88 811.155 1698.88 808.67C1698.88 806.185 1696.87 804.17 1694.38 804.17C1691.89 804.17 1689.88 806.185 1689.88 808.67C1689.88 811.155 1691.89 813.17 1694.38 813.17Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter89_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.44 924.311C756.925 924.311 758.94 922.296 758.94 919.811C758.94 917.325 756.925 915.311 754.44 915.311C751.955 915.311 749.94 917.325 749.94 919.811C749.94 922.296 751.955 924.311 754.44 924.311Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter90_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M924.25 1050.86C926.735 1050.86 928.75 1048.84 928.75 1046.36C928.75 1043.87 926.735 1041.86 924.25 1041.86C921.765 1041.86 919.75 1043.87 919.75 1046.36C919.75 1048.84 921.765 1050.86 924.25 1050.86Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter91_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1200.87 947.32C1203.36 947.32 1205.37 945.306 1205.37 942.82C1205.37 940.335 1203.36 938.32 1200.87 938.32C1198.38 938.32 1196.37 940.335 1196.37 942.82C1196.37 945.306 1198.38 947.32 1200.87 947.32Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter92_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M994.77 1103.71C997.255 1103.71 999.27 1101.7 999.27 1099.21C999.27 1096.73 997.255 1094.71 994.77 1094.71C992.285 1094.71 990.27 1096.73 990.27 1099.21C990.27 1101.7 992.285 1103.71 994.77 1103.71Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter93_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1233.21 1103.07C1235.7 1103.07 1237.71 1101.06 1237.71 1098.57C1237.71 1096.09 1235.7 1094.07 1233.21 1094.07C1230.72 1094.07 1228.71 1096.09 1228.71 1098.57C1228.71 1101.06 1230.72 1103.07 1233.21 1103.07Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter94_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1180.93 849.051C1183.42 849.051 1185.43 847.036 1185.43 844.551C1185.43 842.065 1183.42 840.051 1180.93 840.051C1178.44 840.051 1176.43 842.065 1176.43 844.551C1176.43 847.036 1178.44 849.051 1180.93 849.051Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter95_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M647.14 1091.74C649.625 1091.74 651.64 1089.73 651.64 1087.24C651.64 1084.75 649.625 1082.74 647.14 1082.74C644.655 1082.74 642.64 1084.75 642.64 1087.24C642.64 1089.73 644.655 1091.74 647.14 1091.74Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter96_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.56 738.631C504.045 738.631 506.06 736.616 506.06 734.131C506.06 731.646 504.045 729.631 501.56 729.631C499.075 729.631 497.06 731.646 497.06 734.131C497.06 736.616 499.075 738.631 501.56 738.631Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter97_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.06 966.609C260.545 966.609 262.56 964.595 262.56 962.109C262.56 959.624 260.545 957.609 258.06 957.609C255.575 957.609 253.56 959.624 253.56 962.109C253.56 964.595 255.575 966.609 258.06 966.609Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter98_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M913.85 313.359C916.335 313.359 918.35 311.345 918.35 308.859C918.35 306.374 916.335 304.359 913.85 304.359C911.365 304.359 909.35 306.374 909.35 308.859C909.35 311.345 911.365 313.359 913.85 313.359Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter99_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1096.65 452.08C1099.14 452.08 1101.15 450.065 1101.15 447.58C1101.15 445.095 1099.14 443.08 1096.65 443.08C1094.16 443.08 1092.15 445.095 1092.15 447.58C1092.15 450.065 1094.16 452.08 1096.65 452.08Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter100_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1139.34 383.15C1141.83 383.15 1143.84 381.136 1143.84 378.65C1143.84 376.165 1141.83 374.15 1139.34 374.15C1136.85 374.15 1134.84 376.165 1134.84 378.65C1134.84 381.136 1136.85 383.15 1139.34 383.15Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter101_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1071.74 330.359C1074.23 330.359 1076.24 328.345 1076.24 325.859C1076.24 323.374 1074.23 321.359 1071.74 321.359C1069.25 321.359 1067.24 323.374 1067.24 325.859C1067.24 328.345 1069.25 330.359 1071.74 330.359Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter102_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M975.29 255.49C977.775 255.49 979.79 253.476 979.79 250.99C979.79 248.505 977.775 246.49 975.29 246.49C972.805 246.49 970.79 248.505 970.79 250.99C970.79 253.476 972.805 255.49 975.29 255.49Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter103_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1086.2 150.711C1088.69 150.711 1090.7 148.696 1090.7 146.211C1090.7 143.726 1088.69 141.711 1086.2 141.711C1083.71 141.711 1081.7 143.726 1081.7 146.211C1081.7 148.696 1083.71 150.711 1086.2 150.711Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter104_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1195.87 247.52C1198.36 247.52 1200.37 245.505 1200.37 243.02C1200.37 240.534 1198.36 238.52 1195.87 238.52C1193.38 238.52 1191.37 240.534 1191.37 243.02C1191.37 245.505 1193.38 247.52 1195.87 247.52Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter105_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1042.74 191.59C1045.23 191.59 1047.24 189.575 1047.24 187.09C1047.24 184.605 1045.23 182.59 1042.74 182.59C1040.25 182.59 1038.24 184.605 1038.24 187.09C1038.24 189.575 1040.25 191.59 1042.74 191.59Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter106_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M827.48 139.76C829.965 139.76 831.98 137.745 831.98 135.26C831.98 132.774 829.965 130.76 827.48 130.76C824.995 130.76 822.98 132.774 822.98 135.26C822.98 137.745 824.995 139.76 827.48 139.76Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter107_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1030.97 136.17C1033.46 136.17 1035.47 134.155 1035.47 131.67C1035.47 129.185 1033.46 127.17 1030.97 127.17C1028.48 127.17 1026.47 129.185 1026.47 131.67C1026.47 134.155 1028.48 136.17 1030.97 136.17Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter108_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1067.01 133.811C1069.5 133.811 1071.51 131.796 1071.51 129.311C1071.51 126.825 1069.5 124.811 1067.01 124.811C1064.52 124.811 1062.51 126.825 1062.51 129.311C1062.51 131.796 1064.52 133.811 1067.01 133.811Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter109_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1108.42 130.301C1110.91 130.301 1112.92 128.286 1112.92 125.801C1112.92 123.315 1110.91 121.301 1108.42 121.301C1105.93 121.301 1103.92 123.315 1103.92 125.801C1103.92 128.286 1105.93 130.301 1108.42 130.301Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter110_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1269.48 134.77C1271.97 134.77 1273.98 132.755 1273.98 130.27C1273.98 127.784 1271.97 125.77 1269.48 125.77C1266.99 125.77 1264.98 127.784 1264.98 130.27C1264.98 132.755 1266.99 134.77 1269.48 134.77Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter111_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1242.23 289.6C1244.72 289.6 1246.73 287.585 1246.73 285.1C1246.73 282.614 1244.72 280.6 1242.23 280.6C1239.74 280.6 1237.73 282.614 1237.73 285.1C1237.73 287.585 1239.74 289.6 1242.23 289.6Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter112_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8101 164.77C46.2953 164.77 48.3101 162.755 48.3101 160.27C48.3101 157.784 46.2953 155.77 43.8101 155.77C41.3248 155.77 39.3101 157.784 39.3101 160.27C39.3101 162.755 41.3248 164.77 43.8101 164.77Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter113_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3999 136.74C6.88518 136.74 8.8999 134.726 8.8999 132.24C8.8999 129.755 6.88518 127.74 4.3999 127.74C1.91462 127.74 -0.100098 129.755 -0.100098 132.24C-0.100098 134.726 1.91462 136.74 4.3999 136.74Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter114_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.04 135.029C272.525 135.029 274.54 133.015 274.54 130.529C274.54 128.044 272.525 126.029 270.04 126.029C267.555 126.029 265.54 128.044 265.54 130.529C265.54 133.015 267.555 135.029 270.04 135.029Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter115_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.62 178.221C290.105 178.221 292.12 176.206 292.12 173.721C292.12 171.235 290.105 169.221 287.62 169.221C285.135 169.221 283.12 171.235 283.12 173.721C283.12 176.206 285.135 178.221 287.62 178.221Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter116_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.98999 740.961C6.47527 740.961 8.48999 738.946 8.48999 736.461C8.48999 733.976 6.47527 731.961 3.98999 731.961C1.50471 731.961 -0.51001 733.976 -0.51001 736.461C-0.51001 738.946 1.50471 740.961 3.98999 740.961Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter117_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.46 1104.54C415.945 1104.54 417.96 1102.52 417.96 1100.04C417.96 1097.55 415.945 1095.54 413.46 1095.54C410.975 1095.54 408.96 1097.55 408.96 1100.04C408.96 1102.52 410.975 1104.54 413.46 1104.54Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter118_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.16 1105.07C114.645 1105.07 116.66 1103.06 116.66 1100.57C116.66 1098.09 114.645 1096.07 112.16 1096.07C109.675 1096.07 107.66 1098.09 107.66 1100.57C107.66 1103.06 109.675 1105.07 112.16 1105.07Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter119_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1605.34 137.789C1607.83 137.789 1609.84 135.774 1609.84 133.289C1609.84 130.804 1607.83 128.789 1605.34 128.789C1602.85 128.789 1600.84 130.804 1600.84 133.289C1600.84 135.774 1602.85 137.789 1605.34 137.789Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter120_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1609.35 220.33C1611.84 220.33 1613.85 218.315 1613.85 215.83C1613.85 213.345 1611.84 211.33 1609.35 211.33C1606.86 211.33 1604.85 213.345 1604.85 215.83C1604.85 218.315 1606.86 220.33 1609.35 220.33Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter121_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1916.86 138.77C1919.35 138.77 1921.36 136.755 1921.36 134.27C1921.36 131.784 1919.35 129.77 1916.86 129.77C1914.37 129.77 1912.36 131.784 1912.36 134.27C1912.36 136.755 1914.37 138.77 1916.86 138.77Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter122_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1775.47 322.631C1777.96 322.631 1779.97 320.616 1779.97 318.131C1779.97 315.646 1777.96 313.631 1775.47 313.631C1772.98 313.631 1770.97 315.646 1770.97 318.131C1770.97 320.616 1772.98 322.631 1775.47 322.631Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter123_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1637.74 885.619C1640.23 885.619 1642.24 883.604 1642.24 881.119C1642.24 878.634 1640.23 876.619 1637.74 876.619C1635.25 876.619 1633.24 878.634 1633.24 881.119C1633.24 883.604 1635.25 885.619 1637.74 885.619Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter124_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1647.3 1109.54C1649.79 1109.54 1651.8 1107.52 1651.8 1105.04C1651.8 1102.55 1649.79 1100.54 1647.3 1100.54C1644.81 1100.54 1642.8 1102.55 1642.8 1105.04C1642.8 1107.52 1644.81 1109.54 1647.3 1109.54Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter125_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1914.5 993.721C1916.99 993.721 1919 991.706 1919 989.221C1919 986.735 1916.99 984.721 1914.5 984.721C1912.01 984.721 1910 986.735 1910 989.221C1910 991.706 1912.01 993.721 1914.5 993.721Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter126_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1722.02 842.301C1724.51 842.301 1726.52 840.286 1726.52 837.801C1726.52 835.315 1724.51 833.301 1722.02 833.301C1719.53 833.301 1717.52 835.315 1717.52 837.801C1717.52 840.286 1719.53 842.301 1722.02 842.301Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter127_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1827.17 808.699C1829.66 808.699 1831.67 806.685 1831.67 804.199C1831.67 801.714 1829.66 799.699 1827.17 799.699C1824.68 799.699 1822.67 801.714 1822.67 804.199C1822.67 806.685 1824.68 808.699 1827.17 808.699Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter128_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1914.89 887.24C1917.38 887.24 1919.39 885.226 1919.39 882.74C1919.39 880.255 1917.38 878.24 1914.89 878.24C1912.4 878.24 1910.39 880.255 1910.39 882.74C1910.39 885.226 1912.4 887.24 1914.89 887.24Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter129_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.25 688.48C483.735 688.48 485.75 686.466 485.75 683.98C485.75 681.495 483.735 679.48 481.25 679.48C478.765 679.48 476.75 681.495 476.75 683.98C476.75 686.466 478.765 688.48 481.25 688.48Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter130_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M538.32 703.35C540.805 703.35 542.82 701.335 542.82 698.85C542.82 696.364 540.805 694.35 538.32 694.35C535.835 694.35 533.82 696.364 533.82 698.85C533.82 701.335 535.835 703.35 538.32 703.35Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.91,
    filter: "url(#filter131_d_3544_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M843.02 713.939H70.6199C59.6074 713.939 50.6799 722.867 50.6799 733.879V984.109C50.6799 995.122 59.6074 1004.05 70.6199 1004.05H843.02C854.033 1004.05 862.96 995.122 862.96 984.109V733.879C862.96 722.867 854.033 713.939 843.02 713.939Z",
    fill: "#0C1119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.02 713.939H70.6199C59.6074 713.939 50.6799 722.867 50.6799 733.879V984.109C50.6799 995.122 59.6074 1004.05 70.6199 1004.05H843.02C854.033 1004.05 862.96 995.122 862.96 984.109V733.879C862.96 722.867 854.033 713.939 843.02 713.939Z",
    stroke: "#324767",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.6602 749.33H91.4802C94.9102 749.33 96.9702 750.44 96.9702 753.55C96.9702 756.66 94.9502 757.96 91.5702 757.96H88.7202V764.48H87.6602V749.33ZM91.3002 757.07C94.3902 757.07 95.8801 756.04 95.8801 753.55C95.8801 751.06 94.3402 750.22 91.2102 750.22H88.7202V757.07H91.3002Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.51 758.98C100.51 755.29 102.81 753.16 105.47 753.16C108.13 753.16 110.43 755.28 110.43 758.98C110.43 762.68 108.13 764.76 105.47 764.76C102.81 764.76 100.51 762.64 100.51 758.98ZM109.35 758.98C109.35 756.07 107.69 754.06 105.46 754.06C103.23 754.06 101.57 756.07 101.57 758.98C101.57 761.89 103.23 763.86 105.46 763.86C107.69 763.86 109.35 761.89 109.35 758.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.56 762.999V747.939H116.58V763.139C116.58 763.629 116.78 763.859 117.06 763.859C117.16 763.859 117.25 763.859 117.47 763.809L117.64 764.639C117.43 764.699 117.24 764.749 116.91 764.749C116.02 764.749 115.56 764.199 115.56 762.989V762.999Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.06 761.73C122.06 759.28 124.27 758.11 129.18 757.57C129.21 755.87 128.75 754.06 126.58 754.06C125.09 754.06 123.8 754.8 123.06 755.36L122.59 754.61C123.37 754.06 124.9 753.17 126.7 753.17C129.32 753.17 130.2 755.07 130.2 757.43V764.48H129.34L129.23 763.04H129.18C128.05 763.95 126.71 764.75 125.26 764.75C123.51 764.75 122.06 763.8 122.06 761.73ZM129.18 762.1V758.34C124.64 758.86 123.1 759.92 123.1 761.68C123.1 763.26 124.17 763.87 125.44 763.87C126.71 763.87 127.82 763.26 129.18 762.09V762.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.98 753.44H136.84L136.95 755.5H137C137.75 754.14 138.83 753.16 140.14 753.16C140.54 753.16 140.87 753.21 141.23 753.39L141 754.31C140.63 754.18 140.43 754.13 140 754.13C139.01 754.13 137.83 754.88 136.99 756.97V764.48H135.97V753.44H135.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.95 749.33H156.01L161.35 764.48H160.23L157.2 755.56C156.58 753.76 156.05 752.17 155.52 750.33H155.43C154.9 752.18 154.37 753.77 153.75 755.56L150.68 764.48H149.61L154.95 749.33ZM152.05 758.39H158.84V759.28H152.05V758.39Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.56 758.98C164.56 755.29 166.92 753.16 169.6 753.16C171.1 753.16 172.08 753.83 172.83 754.52L172.23 755.23C171.52 754.57 170.69 754.06 169.62 754.06C167.36 754.06 165.62 756.07 165.62 758.98C165.62 761.89 167.21 763.86 169.61 763.86C170.79 763.86 171.81 763.29 172.57 762.59L173.09 763.3C172.15 764.15 170.97 764.76 169.56 764.76C166.71 764.76 164.55 762.64 164.55 758.98H164.56Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.34 758.98C176.34 755.38 178.68 753.16 181.15 753.16C183.77 753.16 185.38 755.02 185.38 758.27C185.38 758.55 185.38 758.82 185.32 759.1H177.38C177.42 761.89 179.05 763.88 181.54 763.88C182.74 763.88 183.68 763.48 184.51 762.9L184.93 763.67C184.06 764.21 183.07 764.76 181.45 764.76C178.63 764.76 176.35 762.59 176.35 758.98H176.34ZM184.42 758.26C184.42 755.44 183.14 754.04 181.16 754.04C179.29 754.04 177.6 755.62 177.37 758.26H184.42Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.26 749.871C196.26 749.301 196.68 748.971 197.18 748.971C197.68 748.971 198.1 749.301 198.1 749.871C198.1 750.401 197.68 750.771 197.18 750.771C196.68 750.771 196.26 750.401 196.26 749.871ZM196.65 753.441H197.67V764.481H196.65V753.441Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.39 763.23L202.98 762.49C203.91 763.27 204.92 763.89 206.49 763.89C208.23 763.89 209.13 762.87 209.13 761.71C209.13 760.33 207.7 759.72 206.43 759.26C204.76 758.67 202.91 757.99 202.91 756.11C202.91 754.52 204.17 753.17 206.47 753.17C207.65 753.17 208.82 753.66 209.63 754.32L209.08 755.05C208.33 754.49 207.55 754.04 206.44 754.04C204.72 754.04 203.94 755.03 203.94 756.05C203.94 757.31 205.24 757.79 206.56 758.28C208.27 758.93 210.17 759.49 210.17 761.65C210.17 763.31 208.84 764.76 206.45 764.76C204.81 764.76 203.39 764.07 202.4 763.23H202.39Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.56 761.73C220.56 759.28 222.77 758.11 227.68 757.57C227.71 755.87 227.25 754.06 225.08 754.06C223.59 754.06 222.3 754.8 221.56 755.36L221.09 754.61C221.87 754.06 223.4 753.17 225.2 753.17C227.82 753.17 228.7 755.07 228.7 757.43V764.48H227.84L227.73 763.04H227.68C226.55 763.95 225.21 764.75 223.76 764.75C222.01 764.75 220.56 763.8 220.56 761.73ZM227.69 762.1V758.34C223.15 758.86 221.61 759.92 221.61 761.68C221.61 763.26 222.68 763.87 223.95 763.87C225.22 763.87 226.33 763.26 227.69 762.09V762.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 758.98C240 755.29 242.36 753.16 245.04 753.16C246.54 753.16 247.52 753.83 248.27 754.52L247.67 755.23C246.96 754.57 246.13 754.06 245.06 754.06C242.8 754.06 241.06 756.07 241.06 758.98C241.06 761.89 242.65 763.86 245.05 763.86C246.23 763.86 247.25 763.29 248.01 762.59L248.53 763.3C247.59 764.15 246.41 764.76 245 764.76C242.15 764.76 239.99 762.64 239.99 758.98H240Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.1 753.44H253.96L254.07 755.5H254.12C254.87 754.14 255.95 753.16 257.26 753.16C257.66 753.16 257.99 753.21 258.35 753.39L258.12 754.31C257.75 754.18 257.55 754.13 257.12 754.13C256.13 754.13 254.95 754.88 254.11 756.97V764.48H253.09V753.44H253.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.07 758.98C261.07 755.29 263.37 753.16 266.03 753.16C268.69 753.16 270.99 755.28 270.99 758.98C270.99 762.68 268.69 764.76 266.03 764.76C263.37 764.76 261.07 762.64 261.07 758.98ZM269.92 758.98C269.92 756.07 268.26 754.06 266.03 754.06C263.8 754.06 262.14 756.07 262.14 758.98C262.14 761.89 263.8 763.86 266.03 763.86C268.26 763.86 269.92 761.89 269.92 758.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.74 763.23L275.33 762.49C276.26 763.27 277.27 763.89 278.84 763.89C280.58 763.89 281.48 762.87 281.48 761.71C281.48 760.33 280.05 759.72 278.78 759.26C277.11 758.67 275.26 757.99 275.26 756.11C275.26 754.52 276.52 753.17 278.82 753.17C280 753.17 281.17 753.66 281.98 754.32L281.43 755.05C280.68 754.49 279.9 754.04 278.79 754.04C277.07 754.04 276.29 755.03 276.29 756.05C276.29 757.31 277.59 757.79 278.91 758.28C280.62 758.93 282.52 759.49 282.52 761.65C282.52 763.31 281.19 764.76 278.8 764.76C277.16 764.76 275.74 764.07 274.75 763.23H274.74Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.9 763.23L286.49 762.49C287.42 763.27 288.43 763.89 290 763.89C291.74 763.89 292.64 762.87 292.64 761.71C292.64 760.33 291.21 759.72 289.94 759.26C288.27 758.67 286.42 757.99 286.42 756.11C286.42 754.52 287.68 753.17 289.98 753.17C291.16 753.17 292.33 753.66 293.14 754.32L292.59 755.05C291.84 754.49 291.06 754.04 289.95 754.04C288.23 754.04 287.45 755.03 287.45 756.05C287.45 757.31 288.75 757.79 290.07 758.28C291.78 758.93 293.68 759.49 293.68 761.65C293.68 763.31 292.35 764.76 289.96 764.76C288.32 764.76 286.9 764.07 285.91 763.23H285.9Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.47 758.301H302.52V759.201H297.47V758.301Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.37 753.44H308.23L308.34 754.83H308.39C309.47 753.97 310.78 753.16 312.14 753.16C315.1 753.16 316.56 755.38 316.56 758.79C316.56 762.54 314.3 764.75 311.69 764.75C310.64 764.75 309.52 764.25 308.37 763.39V765.43L308.38 769.47H307.36V753.43L307.37 753.44ZM315.5 758.8C315.5 756.09 314.53 754.06 311.99 754.06C310.9 754.06 309.73 754.7 308.4 755.88V762.43C309.65 763.46 310.81 763.85 311.65 763.85C313.9 763.85 315.5 761.79 315.5 758.8Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.7 762.999V747.939H322.72V763.139C322.72 763.629 322.92 763.859 323.2 763.859C323.3 763.859 323.39 763.859 323.61 763.809L323.78 764.639C323.57 764.699 323.38 764.749 323.05 764.749C322.16 764.749 321.7 764.199 321.7 762.989V762.999Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.2 761.73C328.2 759.28 330.41 758.11 335.32 757.57C335.35 755.87 334.89 754.06 332.72 754.06C331.23 754.06 329.94 754.8 329.2 755.36L328.73 754.61C329.51 754.06 331.04 753.17 332.84 753.17C335.46 753.17 336.34 755.07 336.34 757.43V764.48H335.48L335.37 763.04H335.32C334.19 763.95 332.85 764.75 331.4 764.75C329.65 764.75 328.2 763.8 328.2 761.73ZM335.33 762.1V758.34C330.79 758.86 329.25 759.92 329.25 761.68C329.25 763.26 330.32 763.87 331.59 763.87C332.86 763.87 333.97 763.26 335.33 762.09V762.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.13 761.43V754.32H340.41V753.531L342.16 753.43L342.29 750.23H343.15V753.43H346.35V754.32H343.15V761.5C343.15 762.91 343.5 763.86 345.03 763.86C345.44 763.86 346.01 763.69 346.41 763.51L346.68 764.331C346.04 764.561 345.33 764.74 344.88 764.74C342.76 764.74 342.14 763.39 342.14 761.42L342.13 761.43Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.52 753.54L351.06 753.44H354.61V754.33H349.52V753.54ZM351.04 750.98C351.04 748.79 352.02 747.66 353.77 747.66C354.29 747.66 354.87 747.81 355.38 748.03L355.1 748.86C354.65 748.64 354.19 748.55 353.79 748.55C352.6 748.55 352.06 749.45 352.06 751.05V764.48H351.04V750.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.62 758.98C357.62 755.29 359.92 753.16 362.58 753.16C365.24 753.16 367.54 755.28 367.54 758.98C367.54 762.68 365.24 764.76 362.58 764.76C359.92 764.76 357.62 762.64 357.62 758.98ZM366.47 758.98C366.47 756.07 364.81 754.06 362.58 754.06C360.35 754.06 358.69 756.07 358.69 758.98C358.69 761.89 360.35 763.86 362.58 763.86C364.81 763.86 366.47 761.89 366.47 758.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.69 753.44H373.55L373.66 755.5H373.71C374.46 754.14 375.54 753.16 376.85 753.16C377.25 753.16 377.58 753.21 377.94 753.39L377.71 754.31C377.34 754.18 377.14 754.13 376.71 754.13C375.72 754.13 374.54 754.88 373.7 756.97V764.48H372.68V753.44H372.69Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.83 753.44H382.69L382.8 755.15H382.85C383.85 754.03 385.11 753.16 386.34 753.16C388.11 753.16 389 754.05 389.39 755.41C390.64 754.03 391.86 753.16 393.14 753.16C395.34 753.16 396.44 754.54 396.44 757.4V764.48H395.42V757.53C395.42 755.19 394.64 754.08 392.95 754.08C391.91 754.08 390.86 754.77 389.64 756.15V764.48H388.62V757.53C388.62 755.19 387.84 754.08 386.15 754.08C385.15 754.08 384.06 754.77 382.84 756.15V764.48H381.82V753.44H381.83Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.78 753.44H409.64L409.75 754.83H409.8C410.88 753.97 412.19 753.16 413.55 753.16C416.51 753.16 417.97 755.38 417.97 758.79C417.97 762.54 415.71 764.75 413.1 764.75C412.05 764.75 410.93 764.25 409.78 763.39V765.43L409.79 769.47H408.77V753.43L408.78 753.44ZM416.9 758.8C416.9 756.09 415.93 754.06 413.39 754.06C412.3 754.06 411.13 754.7 409.8 755.88V762.43C411.05 763.46 412.21 763.85 413.05 763.85C415.3 763.85 416.9 761.79 416.9 758.8Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.13 753.44H423.99L424.1 755.5H424.15C424.9 754.14 425.98 753.16 427.29 753.16C427.69 753.16 428.02 753.21 428.38 753.39L428.15 754.31C427.78 754.18 427.58 754.13 427.15 754.13C426.16 754.13 424.98 754.88 424.14 756.97V764.48H423.12V753.44H423.13Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.1 758.98C431.1 755.29 433.4 753.16 436.06 753.16C438.72 753.16 441.02 755.28 441.02 758.98C441.02 762.68 438.72 764.76 436.06 764.76C433.4 764.76 431.1 762.64 431.1 758.98ZM439.95 758.98C439.95 756.07 438.29 754.06 436.06 754.06C433.83 754.06 432.17 756.07 432.17 758.98C432.17 761.89 433.83 763.86 436.06 763.86C438.29 763.86 439.95 761.89 439.95 758.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.26 758.979C445.26 755.419 447.52 753.159 450.16 753.159C451.48 753.159 452.39 753.659 453.49 754.519L453.44 752.489V747.939H454.46V764.479H453.6L453.49 763.049H453.44C452.53 763.959 451.31 764.759 449.84 764.759C447.07 764.759 445.27 762.709 445.27 758.979H445.26ZM453.43 762.029V755.479C452.27 754.449 451.3 754.059 450.21 754.059C448.02 754.059 446.32 756.199 446.32 758.969C446.32 761.909 447.63 763.849 449.97 763.849C451.19 763.849 452.27 763.209 453.43 762.029Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.35 760.519V753.439H461.37V760.389C461.37 762.729 462.11 763.839 463.89 763.839C465.21 763.839 466.16 763.149 467.45 761.589V753.439H468.47V764.479H467.61L467.5 762.629H467.45C466.37 763.899 465.22 764.749 463.7 764.749C461.42 764.749 460.36 763.369 460.36 760.509L460.35 760.519Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.61 758.98C473.61 755.29 475.97 753.16 478.65 753.16C480.15 753.16 481.13 753.83 481.88 754.52L481.28 755.23C480.57 754.57 479.74 754.06 478.67 754.06C476.41 754.06 474.67 756.07 474.67 758.98C474.67 761.89 476.26 763.86 478.66 763.86C479.84 763.86 480.86 763.29 481.62 762.59L482.14 763.3C481.2 764.15 480.02 764.76 478.61 764.76C475.76 764.76 473.6 762.64 473.6 758.98H473.61Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.73 761.43V754.32H485.01V753.531L486.76 753.43L486.89 750.23H487.75V753.43H490.95V754.32H487.75V761.5C487.75 762.91 488.1 763.86 489.63 763.86C490.04 763.86 490.61 763.69 491.01 763.51L491.28 764.331C490.64 764.561 489.93 764.74 489.48 764.74C487.36 764.74 486.74 763.39 486.74 761.42L486.73 761.43Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.19 761.43V754.32H500.47V753.531L502.22 753.43L502.35 750.23H503.21V753.43H506.41V754.32H503.21V761.5C503.21 762.91 503.56 763.86 505.09 763.86C505.5 763.86 506.07 763.69 506.47 763.51L506.74 764.331C506.1 764.561 505.39 764.74 504.94 764.74C502.82 764.74 502.2 763.39 502.2 761.42L502.19 761.43Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.95 747.939H511.97V752.739L511.95 755.169C513.1 754.019 514.25 753.159 515.77 753.159C518.05 753.159 519.11 754.539 519.11 757.399V764.479H518.09V757.529C518.09 755.189 517.35 754.079 515.57 754.079C514.25 754.079 513.3 754.769 511.96 756.149V764.479H510.94V747.939H510.95Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.14 761.73C524.14 759.28 526.35 758.11 531.26 757.57C531.29 755.87 530.83 754.06 528.66 754.06C527.17 754.06 525.88 754.8 525.14 755.36L524.67 754.61C525.45 754.06 526.98 753.17 528.78 753.17C531.4 753.17 532.28 755.07 532.28 757.43V764.48H531.42L531.31 763.04H531.26C530.13 763.95 528.79 764.75 527.34 764.75C525.59 764.75 524.14 763.8 524.14 761.73ZM531.26 762.1V758.34C526.72 758.86 525.18 759.92 525.18 761.68C525.18 763.26 526.25 763.87 527.52 763.87C528.79 763.87 529.9 763.26 531.26 762.09V762.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.07 761.43V754.32H536.35V753.531L538.1 753.43L538.23 750.23H539.09V753.43H542.29V754.32H539.09V761.5C539.09 762.91 539.44 763.86 540.97 763.86C541.38 763.86 541.95 763.69 542.35 763.51L542.62 764.331C541.98 764.561 541.27 764.74 540.82 764.74C538.7 764.74 538.08 763.39 538.08 761.42L538.07 761.43Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.34 758.98C552.34 755.38 554.68 753.16 557.15 753.16C559.77 753.16 561.38 755.02 561.38 758.27C561.38 758.55 561.38 758.82 561.32 759.1H553.38C553.42 761.89 555.05 763.88 557.54 763.88C558.74 763.88 559.68 763.48 560.51 762.9L560.93 763.67C560.06 764.21 559.07 764.76 557.45 764.76C554.63 764.76 552.35 762.59 552.35 758.98H552.34ZM560.42 758.26C560.42 755.44 559.14 754.04 557.16 754.04C555.29 754.04 553.6 755.62 553.37 758.26H560.42Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.21 753.44H567.07L567.18 755.15H567.23C568.36 754.03 569.51 753.16 571.03 753.16C573.31 753.16 574.37 754.54 574.37 757.4V764.48H573.35V757.53C573.35 755.19 572.61 754.08 570.83 754.08C569.51 754.08 568.56 754.77 567.22 756.15V764.48H566.2V753.44H566.21Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.5 761.73C579.5 759.28 581.71 758.11 586.62 757.57C586.65 755.87 586.19 754.06 584.02 754.06C582.53 754.06 581.24 754.8 580.5 755.36L580.03 754.61C580.81 754.06 582.34 753.17 584.14 753.17C586.76 753.17 587.64 755.07 587.64 757.43V764.48H586.78L586.67 763.04H586.62C585.49 763.95 584.15 764.75 582.7 764.75C580.95 764.75 579.5 763.8 579.5 761.73ZM586.62 762.1V758.34C582.08 758.86 580.54 759.92 580.54 761.68C580.54 763.26 581.61 763.87 582.88 763.87C584.15 763.87 585.26 763.26 586.62 762.09V762.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.43 763.359H594.38L594.26 764.479H593.41V747.939H594.43V752.739L594.38 754.889C595.5 753.949 596.84 753.159 598.18 753.159C601.14 753.159 602.6 755.379 602.6 758.789C602.6 762.539 600.34 764.749 597.73 764.749C596.68 764.749 595.46 764.199 594.42 763.359H594.43ZM601.54 758.799C601.54 756.089 600.57 754.059 598.03 754.059C596.94 754.059 595.73 754.699 594.44 755.879V762.429C595.65 763.459 596.85 763.849 597.69 763.849C599.94 763.849 601.54 761.789 601.54 758.799Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.71 762.999V747.939H608.73V763.139C608.73 763.629 608.93 763.859 609.21 763.859C609.31 763.859 609.4 763.859 609.62 763.809L609.79 764.639C609.58 764.699 609.39 764.749 609.06 764.749C608.17 764.749 607.71 764.199 607.71 762.989V762.999Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.07 758.98C614.07 755.38 616.41 753.16 618.88 753.16C621.5 753.16 623.11 755.02 623.11 758.27C623.11 758.55 623.11 758.82 623.05 759.1H615.11C615.15 761.89 616.78 763.88 619.27 763.88C620.47 763.88 621.41 763.48 622.24 762.9L622.66 763.67C621.79 764.21 620.8 764.76 619.18 764.76C616.36 764.76 614.08 762.59 614.08 758.98H614.07ZM622.15 758.26C622.15 755.44 620.87 754.04 618.89 754.04C617.02 754.04 615.33 755.62 615.1 758.26H622.15Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.57 763.23L627.16 762.49C628.09 763.27 629.1 763.89 630.67 763.89C632.41 763.89 633.31 762.87 633.31 761.71C633.31 760.33 631.88 759.72 630.61 759.26C628.94 758.67 627.09 757.99 627.09 756.11C627.09 754.52 628.35 753.17 630.65 753.17C631.83 753.17 633 753.66 633.81 754.32L633.26 755.05C632.51 754.49 631.73 754.04 630.62 754.04C628.9 754.04 628.12 755.03 628.12 756.05C628.12 757.31 629.42 757.79 630.74 758.28C632.45 758.93 634.35 759.49 634.35 761.65C634.35 763.31 633.02 764.76 630.63 764.76C628.99 764.76 627.57 764.07 626.58 763.23H626.57Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.17 753.54L645.71 753.44H649.26V754.33H644.17V753.54ZM645.69 750.98C645.69 748.79 646.67 747.66 648.42 747.66C648.94 747.66 649.52 747.81 650.03 748.03L649.75 748.86C649.3 748.64 648.84 748.55 648.44 748.55C647.25 748.55 646.71 749.45 646.71 751.05V764.48H645.69V750.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.18 761.73C652.18 759.28 654.39 758.11 659.3 757.57C659.33 755.87 658.87 754.06 656.7 754.06C655.21 754.06 653.92 754.8 653.18 755.36L652.71 754.61C653.49 754.06 655.02 753.17 656.82 753.17C659.44 753.17 660.32 755.07 660.32 757.43V764.48H659.46L659.35 763.04H659.3C658.17 763.95 656.83 764.75 655.38 764.75C653.63 764.75 652.18 763.8 652.18 761.73ZM659.3 762.1V758.34C654.76 758.86 653.22 759.92 653.22 761.68C653.22 763.26 654.29 763.87 655.56 763.87C656.83 763.87 657.94 763.26 659.3 762.09V762.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.1 753.44H666.96L667.07 755.15H667.12C668.25 754.03 669.4 753.16 670.92 753.16C673.2 753.16 674.26 754.54 674.26 757.4V764.48H673.24V757.53C673.24 755.19 672.5 754.08 670.72 754.08C669.4 754.08 668.45 754.77 667.11 756.15V764.48H666.09V753.44H666.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.8 763.23L679.39 762.49C680.32 763.27 681.33 763.89 682.9 763.89C684.64 763.89 685.54 762.87 685.54 761.71C685.54 760.33 684.11 759.72 682.84 759.26C681.17 758.67 679.32 757.99 679.32 756.11C679.32 754.52 680.58 753.17 682.88 753.17C684.06 753.17 685.23 753.66 686.04 754.32L685.49 755.05C684.74 754.49 683.96 754.04 682.85 754.04C681.13 754.04 680.35 755.03 680.35 756.05C680.35 757.31 681.65 757.79 682.97 758.28C684.68 758.93 686.58 759.49 686.58 761.65C686.58 763.31 685.25 764.76 682.86 764.76C681.22 764.76 679.8 764.07 678.81 763.23H678.8Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.03 761.43V754.32H696.31V753.531L698.06 753.43L698.19 750.23H699.05V753.43H702.25V754.32H699.05V761.5C699.05 762.91 699.4 763.86 700.93 763.86C701.34 763.86 701.91 763.69 702.31 763.51L702.58 764.331C701.94 764.561 701.23 764.74 700.78 764.74C698.66 764.74 698.04 763.39 698.04 761.42L698.03 761.43Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.61 758.98C705.61 755.29 707.91 753.16 710.57 753.16C713.23 753.16 715.53 755.28 715.53 758.98C715.53 762.68 713.23 764.76 710.57 764.76C707.91 764.76 705.61 762.64 705.61 758.98ZM714.46 758.98C714.46 756.07 712.8 754.06 710.57 754.06C708.34 754.06 706.68 756.07 706.68 758.98C706.68 761.89 708.34 763.86 710.57 763.86C712.8 763.86 714.46 761.89 714.46 758.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.24 756.871C726.24 752.061 728.94 749.051 732.95 749.051C734.99 749.051 736.27 750.011 737.08 750.861L736.46 751.571C735.68 750.721 734.62 750.011 732.96 750.011C729.49 750.011 727.35 752.651 727.35 756.861C727.35 761.071 729.38 763.801 732.83 763.801C734.2 763.801 735.48 763.381 736.21 762.651V757.931H732.59V757.031H737.22V763.041C736.29 764.051 734.73 764.761 732.74 764.761C728.84 764.761 726.23 761.691 726.23 756.881L726.24 756.871Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.93 758.98C741.93 755.29 744.23 753.16 746.89 753.16C749.55 753.16 751.85 755.28 751.85 758.98C751.85 762.68 749.55 764.76 746.89 764.76C744.23 764.76 741.93 762.64 741.93 758.98ZM750.77 758.98C750.77 756.07 749.11 754.06 746.88 754.06C744.65 754.06 742.99 756.07 742.99 758.98C742.99 761.89 744.65 763.86 746.88 763.86C749.11 763.86 750.77 761.89 750.77 758.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.53 749.33H764.59V763.57H771.57V764.48H763.53V749.33Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.6 749.871C775.6 749.301 776.02 748.971 776.52 748.971C777.02 748.971 777.44 749.301 777.44 749.871C777.44 750.401 777.02 750.771 776.52 750.771C776.02 750.771 775.6 750.401 775.6 749.871ZM776 753.441H777.02V764.481H776V753.441Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.26 753.439H782.36L784.84 760.359C785.2 761.429 785.6 762.539 785.96 763.529H786.05C786.41 762.539 786.81 761.419 787.17 760.359L789.65 753.439H790.69L786.6 764.479H785.4L781.26 753.439Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.97 758.98C793.97 755.38 796.31 753.16 798.78 753.16C801.4 753.16 803.01 755.02 803.01 758.27C803.01 758.55 803.01 758.82 802.95 759.1H795.01C795.05 761.89 796.68 763.88 799.17 763.88C800.37 763.88 801.31 763.48 802.14 762.9L802.56 763.67C801.69 764.21 800.7 764.76 799.08 764.76C796.26 764.76 793.98 762.59 793.98 758.98H793.97ZM802.06 758.26C802.06 755.44 800.78 754.04 798.8 754.04C796.93 754.04 795.24 755.62 795.01 758.26H802.06Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1501 798.871C87.1501 798.301 87.5701 797.971 88.0701 797.971C88.5701 797.971 88.9901 798.301 88.9901 798.871C88.9901 799.401 88.5701 799.771 88.0701 799.771C87.5701 799.771 87.1501 799.401 87.1501 798.871ZM87.5401 802.441H88.5601V813.481H87.5401V802.441Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6501 802.44H95.5101L95.6201 804.15H95.6701C96.8001 803.03 97.9501 802.16 99.4701 802.16C101.75 802.16 102.81 803.54 102.81 806.4V813.48H101.79V806.53C101.79 804.19 101.05 803.08 99.2701 803.08C97.9501 803.08 97.0001 803.77 95.6601 805.15V813.48H94.6401V802.44H94.6501Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.37 810.73C114.37 808.28 116.58 807.11 121.49 806.57C121.52 804.87 121.06 803.06 118.89 803.06C117.4 803.06 116.11 803.8 115.37 804.36L114.9 803.61C115.68 803.06 117.21 802.17 119.01 802.17C121.63 802.17 122.51 804.07 122.51 806.43V813.48H121.65L121.54 812.04H121.49C120.36 812.95 119.02 813.75 117.57 813.75C115.82 813.75 114.37 812.8 114.37 810.73ZM121.5 811.1V807.34C116.96 807.86 115.42 808.92 115.42 810.68C115.42 812.26 116.49 812.87 117.76 812.87C119.03 812.87 120.14 812.26 121.5 811.09V811.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.74 811.999V796.939H135.76V812.139C135.76 812.629 135.96 812.859 136.24 812.859C136.34 812.859 136.43 812.859 136.65 812.809L136.82 813.639C136.61 813.699 136.42 813.749 136.09 813.749C135.2 813.749 134.74 813.199 134.74 811.989V811.999Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.63 798.871C141.63 798.301 142.05 797.971 142.55 797.971C143.05 797.971 143.47 798.301 143.47 798.871C143.47 799.401 143.05 799.771 142.55 799.771C142.05 799.771 141.63 799.401 141.63 798.871ZM142.03 802.441H143.05V813.481H142.03V802.441Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.29 802.439H148.39L150.87 809.359C151.23 810.429 151.63 811.539 151.99 812.529H152.08C152.44 811.539 152.84 810.419 153.2 809.359L155.68 802.439H156.72L152.63 813.479H151.43L147.29 802.439Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.01 807.98C160.01 804.38 162.35 802.16 164.82 802.16C167.44 802.16 169.05 804.02 169.05 807.27C169.05 807.55 169.05 807.82 168.99 808.1H161.05C161.09 810.89 162.72 812.88 165.21 812.88C166.41 812.88 167.35 812.48 168.18 811.9L168.6 812.67C167.73 813.21 166.74 813.76 165.12 813.76C162.3 813.76 160.02 811.59 160.02 807.98H160.01ZM168.09 807.26C168.09 804.44 166.81 803.04 164.83 803.04C162.96 803.04 161.27 804.62 161.04 807.26H168.09Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.51 812.23L173.1 811.49C174.03 812.27 175.04 812.89 176.61 812.89C178.35 812.89 179.25 811.87 179.25 810.71C179.25 809.33 177.82 808.72 176.55 808.26C174.88 807.67 173.03 806.99 173.03 805.11C173.03 803.52 174.29 802.17 176.59 802.17C177.77 802.17 178.94 802.66 179.75 803.32L179.2 804.05C178.45 803.49 177.67 803.04 176.56 803.04C174.84 803.04 174.06 804.03 174.06 805.05C174.06 806.31 175.36 806.79 176.68 807.28C178.39 807.93 180.29 808.49 180.29 810.65C180.29 812.31 178.96 813.76 176.57 813.76C174.93 813.76 173.51 813.07 172.52 812.23H172.51Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.84 810.43V803.32H183.12V802.531L184.87 802.43L185 799.23H185.86V802.43H189.06V803.32H185.86V810.5C185.86 811.91 186.21 812.86 187.74 812.86C188.15 812.86 188.72 812.69 189.12 812.51L189.39 813.331C188.75 813.561 188.04 813.74 187.59 813.74C185.47 813.74 184.85 812.39 184.85 810.42L184.84 810.43Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.59 802.44H194.45L194.56 804.5H194.61C195.36 803.14 196.44 802.16 197.75 802.16C198.15 802.16 198.48 802.21 198.84 802.39L198.61 803.31C198.24 803.18 198.04 803.13 197.61 803.13C196.62 803.13 195.44 803.88 194.6 805.97V813.48H193.58V802.44H193.59Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.57 807.98C201.57 804.38 203.91 802.16 206.38 802.16C209 802.16 210.61 804.02 210.61 807.27C210.61 807.55 210.61 807.82 210.55 808.1H202.61C202.65 810.89 204.28 812.88 206.77 812.88C207.97 812.88 208.91 812.48 209.74 811.9L210.16 812.67C209.29 813.21 208.3 813.76 206.68 813.76C203.86 813.76 201.58 811.59 201.58 807.98H201.57ZM209.65 807.26C209.65 804.44 208.37 803.04 206.39 803.04C204.52 803.04 202.83 804.62 202.6 807.26H209.65Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.31 810.73C214.31 808.28 216.52 807.11 221.43 806.57C221.46 804.87 221 803.06 218.83 803.06C217.34 803.06 216.05 803.8 215.31 804.36L214.84 803.61C215.62 803.06 217.15 802.17 218.95 802.17C221.57 802.17 222.45 804.07 222.45 806.43V813.48H221.59L221.48 812.04H221.43C220.3 812.95 218.96 813.75 217.51 813.75C215.76 813.75 214.31 812.8 214.31 810.73ZM221.43 811.1V807.34C216.89 807.86 215.35 808.92 215.35 810.68C215.35 812.26 216.42 812.87 217.69 812.87C218.96 812.87 220.07 812.26 221.43 811.09V811.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.23 802.44H229.09L229.2 804.15H229.25C230.25 803.03 231.51 802.16 232.74 802.16C234.51 802.16 235.4 803.05 235.79 804.41C237.04 803.03 238.26 802.16 239.54 802.16C241.74 802.16 242.84 803.54 242.84 806.4V813.48H241.82V806.53C241.82 804.19 241.04 803.08 239.35 803.08C238.31 803.08 237.26 803.77 236.04 805.15V813.48H235.02V806.53C235.02 804.19 234.24 803.08 232.55 803.08C231.55 803.08 230.46 803.77 229.24 805.15V813.48H228.22V802.44H228.23Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.73 816.35C248.78 815.79 249.5 814.81 249.5 813.5L249.21 812.13L250.03 813.21C249.83 813.53 249.53 813.59 249.23 813.59C248.7 813.59 248.26 813.26 248.26 812.63C248.26 812 248.74 811.67 249.24 811.67C249.95 811.67 250.41 812.3 250.41 813.31C250.41 814.99 249.43 816.31 248.05 817.06L247.72 816.36L247.73 816.35Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.69 812.23L261.28 811.49C262.21 812.27 263.22 812.89 264.79 812.89C266.53 812.89 267.43 811.87 267.43 810.71C267.43 809.33 266 808.72 264.73 808.26C263.06 807.67 261.21 806.99 261.21 805.11C261.21 803.52 262.47 802.17 264.77 802.17C265.95 802.17 267.12 802.66 267.93 803.32L267.38 804.05C266.63 803.49 265.85 803.04 264.74 803.04C263.02 803.04 262.24 804.03 262.24 805.05C262.24 806.31 263.54 806.79 264.86 807.28C266.57 807.93 268.47 808.49 268.47 810.65C268.47 812.31 267.14 813.76 264.75 813.76C263.11 813.76 261.69 813.07 260.7 812.23H260.69Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.29 807.98C272.29 804.38 274.63 802.16 277.1 802.16C279.72 802.16 281.33 804.02 281.33 807.27C281.33 807.55 281.33 807.82 281.27 808.1H273.33C273.37 810.89 275 812.88 277.49 812.88C278.69 812.88 279.63 812.48 280.46 811.9L280.88 812.67C280.01 813.21 279.02 813.76 277.4 813.76C274.58 813.76 272.3 811.59 272.3 807.98H272.29ZM280.38 807.26C280.38 804.44 279.1 803.04 277.12 803.04C275.25 803.04 273.56 804.62 273.33 807.26H280.38Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.17 802.44H287.03L287.14 804.15H287.19C288.32 803.03 289.47 802.16 290.99 802.16C293.27 802.16 294.33 803.54 294.33 806.4V813.48H293.31V806.53C293.31 804.19 292.57 803.08 290.79 803.08C289.47 803.08 288.52 803.77 287.18 805.15V813.48H286.16V802.44H286.17Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.32 807.979C299.32 804.419 301.58 802.159 304.22 802.159C305.54 802.159 306.45 802.659 307.55 803.519L307.5 801.489V796.939H308.52V813.479H307.66L307.55 812.049H307.5C306.59 812.959 305.37 813.759 303.9 813.759C301.13 813.759 299.33 811.709 299.33 807.979H299.32ZM307.5 811.029V804.479C306.34 803.449 305.37 803.059 304.28 803.059C302.09 803.059 300.39 805.199 300.39 807.969C300.39 810.909 301.7 812.849 304.04 812.849C305.26 812.849 306.34 812.209 307.5 811.029Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.24 810.73C320.24 808.28 322.45 807.11 327.36 806.57C327.39 804.87 326.93 803.06 324.76 803.06C323.27 803.06 321.98 803.8 321.24 804.36L320.77 803.61C321.55 803.06 323.08 802.17 324.88 802.17C327.5 802.17 328.38 804.07 328.38 806.43V813.48H327.52L327.41 812.04H327.36C326.23 812.95 324.89 813.75 323.44 813.75C321.69 813.75 320.24 812.8 320.24 810.73ZM327.37 811.1V807.34C322.83 807.86 321.29 808.92 321.29 810.68C321.29 812.26 322.36 812.87 323.63 812.87C324.9 812.87 326.01 812.26 327.37 811.09V811.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.59 798.33H339.71L342.51 807.18C343.09 809.04 343.49 810.43 344.11 812.27H344.2C344.82 810.43 345.22 809.04 345.8 807.18L348.6 798.33H349.67L344.72 813.48H343.58L338.59 798.33Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.35 798.871C353.35 798.301 353.77 797.971 354.27 797.971C354.77 797.971 355.19 798.301 355.19 798.871C355.19 799.401 354.77 799.771 354.27 799.771C353.77 799.771 353.35 799.401 353.35 798.871ZM353.74 802.441H354.76V813.481H353.74V802.441Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.93 807.979C359.93 804.419 362.19 802.159 364.83 802.159C366.15 802.159 367.06 802.659 368.16 803.519L368.11 801.489V796.939H369.13V813.479H368.27L368.16 812.049H368.11C367.2 812.959 365.98 813.759 364.51 813.759C361.74 813.759 359.94 811.709 359.94 807.979H359.93ZM368.1 811.029V804.479C366.94 803.449 365.97 803.059 364.88 803.059C362.69 803.059 360.99 805.199 360.99 807.969C360.99 810.909 362.3 812.849 364.64 812.849C365.86 812.849 366.94 812.209 368.1 811.029Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.27 807.98C374.27 804.38 376.61 802.16 379.08 802.16C381.7 802.16 383.31 804.02 383.31 807.27C383.31 807.55 383.31 807.82 383.25 808.1H375.31C375.35 810.89 376.98 812.88 379.47 812.88C380.67 812.88 381.61 812.48 382.44 811.9L382.86 812.67C381.99 813.21 381 813.76 379.38 813.76C376.56 813.76 374.28 811.59 374.28 807.98H374.27ZM382.35 807.26C382.35 804.44 381.07 803.04 379.09 803.04C377.22 803.04 375.53 804.62 375.3 807.26H382.35Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.22 807.98C387.22 804.29 389.52 802.16 392.18 802.16C394.84 802.16 397.14 804.28 397.14 807.98C397.14 811.68 394.84 813.76 392.18 813.76C389.52 813.76 387.22 811.64 387.22 807.98ZM396.07 807.98C396.07 805.07 394.41 803.06 392.18 803.06C389.95 803.06 388.29 805.07 388.29 807.98C388.29 810.89 389.95 812.86 392.18 812.86C394.41 812.86 396.07 810.89 396.07 807.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.82 798.33H410.32L413.48 807.22C413.88 808.34 414.28 809.46 414.68 810.59H414.77C415.17 809.47 415.52 808.34 415.92 807.22L419.07 798.33H420.57V813.48H419.55V803.52C419.55 802.29 419.62 800.69 419.68 799.43H419.59L418.41 802.81L415.14 811.83H414.22L410.93 802.81L409.73 799.43H409.64C409.7 800.7 409.77 802.3 409.77 803.52V813.48H408.8V798.33H408.82Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.86 807.98C425.86 804.38 428.2 802.16 430.67 802.16C433.29 802.16 434.9 804.02 434.9 807.27C434.9 807.55 434.9 807.82 434.84 808.1H426.9C426.94 810.89 428.57 812.88 431.06 812.88C432.26 812.88 433.2 812.48 434.03 811.9L434.45 812.67C433.58 813.21 432.59 813.76 430.97 813.76C428.15 813.76 425.87 811.59 425.87 807.98H425.86ZM433.94 807.26C433.94 804.44 432.66 803.04 430.68 803.04C428.81 803.04 427.12 804.62 426.89 807.26H433.94Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.36 812.23L438.95 811.49C439.88 812.27 440.89 812.89 442.46 812.89C444.2 812.89 445.1 811.87 445.1 810.71C445.1 809.33 443.67 808.72 442.4 808.26C440.73 807.67 438.88 806.99 438.88 805.11C438.88 803.52 440.14 802.17 442.44 802.17C443.62 802.17 444.79 802.66 445.6 803.32L445.05 804.05C444.3 803.49 443.52 803.04 442.41 803.04C440.69 803.04 439.91 804.03 439.91 805.05C439.91 806.31 441.21 806.79 442.53 807.28C444.24 807.93 446.14 808.49 446.14 810.65C446.14 812.31 444.81 813.76 442.42 813.76C440.78 813.76 439.36 813.07 438.37 812.23H438.36Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.52 812.23L450.11 811.49C451.04 812.27 452.05 812.89 453.62 812.89C455.36 812.89 456.26 811.87 456.26 810.71C456.26 809.33 454.83 808.72 453.56 808.26C451.89 807.67 450.04 806.99 450.04 805.11C450.04 803.52 451.3 802.17 453.6 802.17C454.78 802.17 455.95 802.66 456.76 803.32L456.21 804.05C455.46 803.49 454.68 803.04 453.57 803.04C451.85 803.04 451.07 804.03 451.07 805.05C451.07 806.31 452.37 806.79 453.69 807.28C455.4 807.93 457.3 808.49 457.3 810.65C457.3 812.31 455.97 813.76 453.58 813.76C451.94 813.76 450.52 813.07 449.53 812.23H449.52Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.26 810.73C461.26 808.28 463.47 807.11 468.38 806.57C468.41 804.87 467.95 803.06 465.78 803.06C464.29 803.06 463 803.8 462.26 804.36L461.79 803.61C462.57 803.06 464.1 802.17 465.9 802.17C468.52 802.17 469.4 804.07 469.4 806.43V813.48H468.54L468.43 812.04H468.38C467.25 812.95 465.91 813.75 464.46 813.75C462.71 813.75 461.26 812.8 461.26 810.73ZM468.38 811.1V807.34C463.84 807.86 462.3 808.92 462.3 810.68C462.3 812.26 463.37 812.87 464.64 812.87C465.91 812.87 467.02 812.26 468.38 811.09V811.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.25 815.74C474.25 814.78 474.88 813.79 475.9 813.08V812.99C475.34 812.66 474.92 812.06 474.92 811.22C474.92 810.23 475.63 809.53 476.13 809.18V809.09C475.43 808.5 474.73 807.4 474.73 806.06C474.73 803.79 476.46 802.16 478.62 802.16C479.22 802.16 479.74 802.29 480.09 802.44H483.83V803.3H481.26C481.97 803.91 482.48 804.9 482.48 806.07C482.48 808.33 480.78 809.97 478.62 809.97C478 809.97 477.3 809.8 476.79 809.5C476.31 809.89 475.89 810.36 475.89 811.1C475.89 811.9 476.35 812.54 478 812.54H480.37C482.85 812.54 484.01 813.33 484.01 815.07C484.01 816.97 481.97 818.8 478.79 818.8C476 818.8 474.25 817.6 474.25 815.74ZM482.97 815.18C482.97 813.96 482.09 813.5 480.42 813.5H478.05C477.83 813.5 477.25 813.45 476.68 813.32C475.66 814.01 475.23 814.86 475.23 815.64C475.23 817.04 476.56 817.98 478.89 817.98C481.38 817.98 482.97 816.57 482.97 815.18ZM481.47 806.06C481.47 804.2 480.18 803.01 478.61 803.01C477.04 803.01 475.75 804.18 475.75 806.06C475.75 807.94 477.08 809.16 478.61 809.16C480.14 809.16 481.47 807.91 481.47 806.06Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.04 807.98C487.04 804.38 489.38 802.16 491.85 802.16C494.47 802.16 496.08 804.02 496.08 807.27C496.08 807.55 496.08 807.82 496.02 808.1H488.08C488.12 810.89 489.75 812.88 492.24 812.88C493.44 812.88 494.38 812.48 495.21 811.9L495.63 812.67C494.76 813.21 493.77 813.76 492.15 813.76C489.33 813.76 487.05 811.59 487.05 807.98H487.04ZM495.12 807.26C495.12 804.44 493.84 803.04 491.86 803.04C489.99 803.04 488.3 804.62 488.07 807.26H495.12Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.36 811.999V796.939H508.38V812.139C508.38 812.629 508.58 812.859 508.86 812.859C508.96 812.859 509.05 812.859 509.27 812.809L509.44 813.639C509.23 813.699 509.04 813.749 508.71 813.749C507.82 813.749 507.36 813.199 507.36 811.989V811.999Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.25 798.871C514.25 798.301 514.67 797.971 515.17 797.971C515.67 797.971 516.09 798.301 516.09 798.871C516.09 799.401 515.67 799.771 515.17 799.771C514.67 799.771 514.25 799.401 514.25 798.871ZM514.65 802.441H515.67V813.481H514.65V802.441Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.91 802.439H521.01L523.49 809.359C523.85 810.429 524.25 811.539 524.61 812.529H524.7C525.06 811.539 525.46 810.419 525.82 809.359L528.3 802.439H529.34L525.25 813.479H524.05L519.91 802.439Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.62 807.98C532.62 804.38 534.96 802.16 537.43 802.16C540.05 802.16 541.66 804.02 541.66 807.27C541.66 807.55 541.66 807.82 541.6 808.1H533.66C533.7 810.89 535.33 812.88 537.82 812.88C539.02 812.88 539.96 812.48 540.79 811.9L541.21 812.67C540.34 813.21 539.35 813.76 537.73 813.76C534.91 813.76 532.63 811.59 532.63 807.98H532.62ZM540.71 807.26C540.71 804.44 539.43 803.04 537.45 803.04C535.58 803.04 533.89 804.62 533.66 807.26H540.71Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.48 816.35C546.53 815.79 547.25 814.81 547.25 813.5L546.96 812.13L547.78 813.21C547.58 813.53 547.28 813.59 546.98 813.59C546.45 813.59 546.01 813.26 546.01 812.63C546.01 812 546.49 811.67 546.99 811.67C547.7 811.67 548.16 812.3 548.16 813.31C548.16 814.99 547.18 816.31 545.8 817.06L545.47 816.36L545.48 816.35Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.03 810.73C559.03 808.28 561.24 807.11 566.15 806.57C566.18 804.87 565.72 803.06 563.55 803.06C562.06 803.06 560.77 803.8 560.03 804.36L559.56 803.61C560.34 803.06 561.87 802.17 563.67 802.17C566.29 802.17 567.17 804.07 567.17 806.43V813.48H566.31L566.2 812.04H566.15C565.02 812.95 563.68 813.75 562.23 813.75C560.48 813.75 559.03 812.8 559.03 810.73ZM566.15 811.1V807.34C561.61 807.86 560.07 808.92 560.07 810.68C560.07 812.26 561.14 812.87 562.41 812.87C563.68 812.87 564.79 812.26 566.15 811.09V811.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.95 802.44H573.81L573.92 804.15H573.97C575.1 803.03 576.25 802.16 577.77 802.16C580.05 802.16 581.11 803.54 581.11 806.4V813.48H580.09V806.53C580.09 804.19 579.35 803.08 577.57 803.08C576.25 803.08 575.3 803.77 573.96 805.15V813.48H572.94V802.44H572.95Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.11 807.979C586.11 804.419 588.37 802.159 591.01 802.159C592.33 802.159 593.24 802.659 594.34 803.519L594.29 801.489V796.939H595.31V813.479H594.45L594.34 812.049H594.29C593.38 812.959 592.16 813.759 590.69 813.759C587.92 813.759 586.12 811.709 586.12 807.979H586.11ZM594.28 811.029V804.479C593.12 803.449 592.15 803.059 591.06 803.059C588.87 803.059 587.17 805.199 587.17 807.969C587.17 810.909 588.48 812.849 590.82 812.849C592.04 812.849 593.12 812.209 594.28 811.029Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.44 812.23L607.03 811.49C607.96 812.27 608.97 812.89 610.54 812.89C612.28 812.89 613.18 811.87 613.18 810.71C613.18 809.33 611.75 808.72 610.48 808.26C608.81 807.67 606.96 806.99 606.96 805.11C606.96 803.52 608.22 802.17 610.52 802.17C611.7 802.17 612.87 802.66 613.68 803.32L613.13 804.05C612.38 803.49 611.6 803.04 610.49 803.04C608.77 803.04 607.99 804.03 607.99 805.05C607.99 806.31 609.29 806.79 610.61 807.28C612.32 807.93 614.22 808.49 614.22 810.65C614.22 812.31 612.89 813.76 610.5 813.76C608.86 813.76 607.44 813.07 606.45 812.23H606.44Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.05 807.98C618.05 804.38 620.39 802.16 622.86 802.16C625.48 802.16 627.09 804.02 627.09 807.27C627.09 807.55 627.09 807.82 627.03 808.1H619.09C619.13 810.89 620.76 812.88 623.25 812.88C624.45 812.88 625.39 812.48 626.22 811.9L626.64 812.67C625.77 813.21 624.78 813.76 623.16 813.76C620.34 813.76 618.06 811.59 618.06 807.98H618.05ZM626.13 807.26C626.13 804.44 624.85 803.04 622.87 803.04C621 803.04 619.31 804.62 619.08 807.26H626.13Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.92 802.44H632.78L632.89 804.15H632.94C634.07 803.03 635.22 802.16 636.74 802.16C639.02 802.16 640.08 803.54 640.08 806.4V813.48H639.06V806.53C639.06 804.19 638.32 803.08 636.54 803.08C635.22 803.08 634.27 803.77 632.93 805.15V813.48H631.91V802.44H631.92Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.08 807.979C645.08 804.419 647.34 802.159 649.98 802.159C651.3 802.159 652.21 802.659 653.31 803.519L653.26 801.489V796.939H654.28V813.479H653.42L653.31 812.049H653.26C652.35 812.959 651.13 813.759 649.66 813.759C646.89 813.759 645.09 811.709 645.09 807.979H645.08ZM653.25 811.029V804.479C652.09 803.449 651.12 803.059 650.03 803.059C647.84 803.059 646.14 805.199 646.14 807.969C646.14 810.909 647.45 812.849 649.79 812.849C651.01 812.849 652.09 812.209 653.25 811.029Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666 810.73C666 808.28 668.21 807.11 673.12 806.57C673.15 804.87 672.69 803.06 670.52 803.06C669.03 803.06 667.74 803.8 667 804.36L666.53 803.61C667.31 803.06 668.84 802.17 670.64 802.17C673.26 802.17 674.14 804.07 674.14 806.43V813.48H673.28L673.17 812.04H673.12C671.99 812.95 670.65 813.75 669.2 813.75C667.45 813.75 666 812.8 666 810.73ZM673.12 811.1V807.34C668.58 807.86 667.04 808.92 667.04 810.68C667.04 812.26 668.11 812.87 669.38 812.87C670.65 812.87 671.76 812.26 673.12 811.09V811.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.5 805.871C685.5 801.061 688.2 798.051 692.21 798.051C694.25 798.051 695.53 799.011 696.34 799.861L695.72 800.571C694.94 799.721 693.88 799.011 692.22 799.011C688.75 799.011 686.61 801.651 686.61 805.861C686.61 810.071 688.64 812.801 692.09 812.801C693.46 812.801 694.74 812.381 695.47 811.651V806.931H691.85V806.031H696.48V812.041C695.55 813.051 693.99 813.761 692 813.761C688.1 813.761 685.49 810.691 685.49 805.881L685.5 805.871Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.23 798.33H703.29V813.48H702.23V798.33Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.59 798.33H717.85V799.24H710.65V805.28H716.73V806.19H710.65V813.48H709.59V798.33Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.73 811.999V796.939H729.75V812.139C729.75 812.629 729.95 812.859 730.23 812.859C730.33 812.859 730.42 812.859 730.64 812.809L730.81 813.639C730.6 813.699 730.41 813.749 730.08 813.749C729.19 813.749 728.73 813.199 728.73 811.989V811.999Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.62 798.871C735.62 798.301 736.04 797.971 736.54 797.971C737.04 797.971 737.46 798.301 737.46 798.871C737.46 799.401 737.04 799.771 736.54 799.771C736.04 799.771 735.62 799.401 735.62 798.871ZM736.02 802.441H737.04V813.481H736.02V802.441Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.28 802.439H742.38L744.86 809.359C745.22 810.429 745.62 811.539 745.98 812.529H746.07C746.43 811.539 746.83 810.419 747.19 809.359L749.67 802.439H750.71L746.62 813.479H745.42L741.28 802.439Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.99 807.98C753.99 804.38 756.33 802.16 758.8 802.16C761.42 802.16 763.03 804.02 763.03 807.27C763.03 807.55 763.03 807.82 762.97 808.1H755.03C755.07 810.89 756.7 812.88 759.19 812.88C760.39 812.88 761.33 812.48 762.16 811.9L762.58 812.67C761.71 813.21 760.72 813.76 759.1 813.76C756.28 813.76 754 811.59 754 807.98H753.99ZM762.08 807.26C762.08 804.44 760.8 803.04 758.82 803.04C756.95 803.04 755.26 804.62 755.03 807.26H762.08Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.3 812.73C767.3 812.06 767.77 811.66 768.28 811.66C768.79 811.66 769.25 812.06 769.25 812.73C769.25 813.36 768.78 813.76 768.28 813.76C767.78 813.76 767.3 813.36 767.3 812.73Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9501 847.33H92.0101L97.3501 862.48H96.2301L93.2001 853.56C92.5801 851.76 92.0501 850.17 91.5201 848.33H91.4301C90.9001 850.18 90.3701 851.77 89.7501 853.56L86.6801 862.48H85.6101L90.9501 847.33ZM88.0401 856.39H94.8301V857.28H88.0401V856.39Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.56 856.979C100.56 853.419 102.82 851.159 105.46 851.159C106.78 851.159 107.69 851.659 108.79 852.519L108.74 850.489V845.939H109.76V862.479H108.9L108.79 861.049H108.74C107.83 861.959 106.61 862.759 105.14 862.759C102.37 862.759 100.57 860.709 100.57 856.979H100.56ZM108.73 860.029V853.479C107.57 852.449 106.6 852.059 105.51 852.059C103.32 852.059 101.62 854.199 101.62 856.969C101.62 859.909 102.93 861.849 105.27 861.849C106.49 861.849 107.57 861.209 108.73 860.029Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.91 856.979C114.91 853.419 117.17 851.159 119.81 851.159C121.13 851.159 122.04 851.659 123.14 852.519L123.09 850.489V845.939H124.11V862.479H123.25L123.14 861.049H123.09C122.18 861.959 120.96 862.759 119.49 862.759C116.72 862.759 114.92 860.709 114.92 856.979H114.91ZM123.08 860.029V853.479C121.92 852.449 120.95 852.059 119.86 852.059C117.67 852.059 115.97 854.199 115.97 856.969C115.97 859.909 117.28 861.849 119.62 861.849C120.84 861.849 121.92 861.209 123.08 860.029Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.79 847.871C129.79 847.301 130.21 846.971 130.71 846.971C131.21 846.971 131.63 847.301 131.63 847.871C131.63 848.401 131.21 848.771 130.71 848.771C130.21 848.771 129.79 848.401 129.79 847.871ZM130.18 851.441H131.2V862.481H130.18V851.441Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.55 859.43V852.32H135.83V851.531L137.58 851.43L137.71 848.23H138.57V851.43H141.77V852.32H138.57V859.5C138.57 860.91 138.92 861.86 140.45 861.86C140.86 861.86 141.43 861.69 141.83 861.51L142.1 862.331C141.46 862.561 140.75 862.74 140.3 862.74C138.18 862.74 137.56 861.39 137.56 859.42L137.55 859.43Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.91 847.871C145.91 847.301 146.33 846.971 146.83 846.971C147.33 846.971 147.75 847.301 147.75 847.871C147.75 848.401 147.33 848.771 146.83 848.771C146.33 848.771 145.91 848.401 145.91 847.871ZM146.31 851.441H147.33V862.481H146.31V851.441Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.48 856.98C152.48 853.29 154.78 851.16 157.44 851.16C160.1 851.16 162.4 853.28 162.4 856.98C162.4 860.68 160.1 862.76 157.44 862.76C154.78 862.76 152.48 860.64 152.48 856.98ZM161.33 856.98C161.33 854.07 159.67 852.06 157.44 852.06C155.21 852.06 153.55 854.07 153.55 856.98C153.55 859.89 155.21 861.86 157.44 861.86C159.67 861.86 161.33 859.89 161.33 856.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.56 851.44H168.42L168.53 853.15H168.58C169.71 852.03 170.86 851.16 172.38 851.16C174.66 851.16 175.72 852.54 175.72 855.4V862.48H174.7V855.53C174.7 853.19 173.96 852.08 172.18 852.08C170.86 852.08 169.91 852.77 168.57 854.15V862.48H167.55V851.44H167.56Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.84 859.73C180.84 857.28 183.05 856.11 187.96 855.57C187.99 853.87 187.53 852.06 185.36 852.06C183.87 852.06 182.58 852.8 181.84 853.36L181.37 852.61C182.15 852.06 183.68 851.17 185.48 851.17C188.1 851.17 188.98 853.07 188.98 855.43V862.48H188.12L188.01 861.04H187.96C186.83 861.95 185.49 862.75 184.04 862.75C182.29 862.75 180.84 861.8 180.84 859.73ZM187.97 860.1V856.34C183.43 856.86 181.89 857.92 181.89 859.68C181.89 861.26 182.96 861.87 184.23 861.87C185.5 861.87 186.61 861.26 187.97 860.09V860.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.77 860.999V845.939H195.79V861.139C195.79 861.629 195.99 861.859 196.27 861.859C196.37 861.859 196.46 861.859 196.68 861.809L196.85 862.639C196.64 862.699 196.45 862.749 196.12 862.749C195.23 862.749 194.77 862.199 194.77 860.989V860.999Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.06 860.999V845.939H203.08V861.139C203.08 861.629 203.28 861.859 203.56 861.859C203.66 861.859 203.75 861.859 203.97 861.809L204.14 862.639C203.93 862.699 203.74 862.749 203.41 862.749C202.52 862.749 202.06 862.199 202.06 860.989V860.999Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.77 867.279L208 866.399C208.23 866.489 208.59 866.579 208.9 866.579C210.25 866.579 211.17 865.329 211.73 863.649L212.03 862.689L207.5 851.439H208.6L211.26 858.379C211.62 859.309 212.06 860.499 212.46 861.479H212.55C212.9 860.499 213.26 859.319 213.58 858.379L215.93 851.439H216.97L212.61 863.869C211.99 865.709 210.88 867.509 208.89 867.509C208.48 867.509 208.06 867.419 207.76 867.279H207.77Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.74 865.35C220.79 864.79 221.51 863.81 221.51 862.5L221.22 861.13L222.04 862.21C221.84 862.53 221.54 862.59 221.24 862.59C220.71 862.59 220.27 862.26 220.27 861.63C220.27 861 220.75 860.67 221.25 860.67C221.96 860.67 222.42 861.3 222.42 862.31C222.42 863.99 221.44 865.31 220.06 866.06L219.73 865.36L219.74 865.35Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.5 851.439H233.59L235.58 858.589C235.85 859.619 236.1 860.559 236.33 861.549H236.42C236.69 860.559 236.95 859.609 237.23 858.589L239.24 851.439H240.45L242.46 858.589C242.74 859.619 243 860.559 243.27 861.549H243.36C243.63 860.559 243.88 859.619 244.15 858.589L246.1 851.439H247.13L243.97 862.479H242.64L240.69 855.619C240.38 854.559 240.16 853.549 239.85 852.469H239.76C239.49 853.549 239.23 854.609 238.88 855.659L236.98 862.479H235.74L232.48 851.439H232.5Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.72 856.98C250.72 853.38 253.06 851.16 255.53 851.16C258.15 851.16 259.76 853.02 259.76 856.27C259.76 856.55 259.76 856.82 259.7 857.1H251.76C251.8 859.89 253.43 861.88 255.92 861.88C257.12 861.88 258.06 861.48 258.89 860.9L259.31 861.67C258.44 862.21 257.45 862.76 255.83 862.76C253.01 862.76 250.73 860.59 250.73 856.98H250.72ZM258.8 856.26C258.8 853.44 257.52 852.04 255.54 852.04C253.67 852.04 251.98 853.62 251.75 856.26H258.8Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.47 851.439H270.56L272.55 858.589C272.82 859.619 273.07 860.559 273.3 861.549H273.39C273.66 860.559 273.92 859.609 274.2 858.589L276.21 851.439H277.42L279.43 858.589C279.71 859.619 279.97 860.559 280.24 861.549H280.33C280.6 860.559 280.85 859.619 281.12 858.589L283.07 851.439H284.1L280.94 862.479H279.61L277.66 855.619C277.35 854.559 277.13 853.549 276.82 852.469H276.73C276.46 853.549 276.2 854.609 275.85 855.659L273.95 862.479H272.71L269.45 851.439H269.47Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.23 847.871C288.23 847.301 288.65 846.971 289.15 846.971C289.65 846.971 290.07 847.301 290.07 847.871C290.07 848.401 289.65 848.771 289.15 848.771C288.65 848.771 288.23 848.401 288.23 847.871ZM288.63 851.441H289.65V862.481H288.63V851.441Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.73 860.999V845.939H296.75V861.139C296.75 861.629 296.95 861.859 297.23 861.859C297.33 861.859 297.42 861.859 297.64 861.809L297.81 862.639C297.6 862.699 297.41 862.749 297.08 862.749C296.19 862.749 295.73 862.199 295.73 860.989V860.999Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.03 860.999V845.939H304.05V861.139C304.05 861.629 304.25 861.859 304.53 861.859C304.63 861.859 304.72 861.859 304.94 861.809L305.11 862.639C304.9 862.699 304.71 862.749 304.38 862.749C303.49 862.749 303.03 862.199 303.03 860.989V860.999Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.76 845.939H317.78V850.739L317.76 853.169C318.91 852.019 320.06 851.159 321.58 851.159C323.86 851.159 324.92 852.539 324.92 855.399V862.479H323.9V855.529C323.9 853.189 323.16 852.079 321.38 852.079C320.06 852.079 319.11 852.769 317.77 854.149V862.479H316.75V845.939H316.76Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.95 859.73C329.95 857.28 332.16 856.11 337.07 855.57C337.1 853.87 336.64 852.06 334.47 852.06C332.98 852.06 331.69 852.8 330.95 853.36L330.48 852.61C331.26 852.06 332.79 851.17 334.59 851.17C337.21 851.17 338.09 853.07 338.09 855.43V862.48H337.23L337.12 861.04H337.07C335.94 861.95 334.6 862.75 333.15 862.75C331.4 862.75 329.95 861.8 329.95 859.73ZM337.07 860.1V856.34C332.53 856.86 330.99 857.92 330.99 859.68C330.99 861.26 332.06 861.87 333.33 861.87C334.6 861.87 335.71 861.26 337.07 860.09V860.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.03 851.439H343.13L345.61 858.359C345.97 859.429 346.37 860.539 346.73 861.529H346.82C347.18 860.539 347.58 859.419 347.94 858.359L350.42 851.439H351.46L347.37 862.479H346.17L342.03 851.439Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.74 856.98C354.74 853.38 357.08 851.16 359.55 851.16C362.17 851.16 363.78 853.02 363.78 856.27C363.78 856.55 363.78 856.82 363.72 857.1H355.78C355.82 859.89 357.45 861.88 359.94 861.88C361.14 861.88 362.08 861.48 362.91 860.9L363.33 861.67C362.46 862.21 361.47 862.76 359.85 862.76C357.03 862.76 354.75 860.59 354.75 856.98H354.74ZM362.83 856.26C362.83 853.44 361.55 852.04 359.57 852.04C357.7 852.04 356.01 853.62 355.78 856.26H362.83Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.27 859.73C374.27 857.28 376.48 856.11 381.39 855.57C381.42 853.87 380.96 852.06 378.79 852.06C377.3 852.06 376.01 852.8 375.27 853.36L374.8 852.61C375.58 852.06 377.11 851.17 378.91 851.17C381.53 851.17 382.41 853.07 382.41 855.43V862.48H381.55L381.44 861.04H381.39C380.26 861.95 378.92 862.75 377.47 862.75C375.72 862.75 374.27 861.8 374.27 859.73ZM381.39 860.1V856.34C376.85 856.86 375.31 857.92 375.31 859.68C375.31 861.26 376.38 861.87 377.65 861.87C378.92 861.87 380.03 861.26 381.39 860.09V860.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.19 851.44H389.05L389.16 853.15H389.21C390.34 852.03 391.49 851.16 393.01 851.16C395.29 851.16 396.35 852.54 396.35 855.4V862.48H395.33V855.53C395.33 853.19 394.59 852.08 392.81 852.08C391.49 852.08 390.54 852.77 389.2 854.15V862.48H388.18V851.44H388.19Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.92 859.73C407.92 857.28 410.13 856.11 415.04 855.57C415.07 853.87 414.61 852.06 412.44 852.06C410.95 852.06 409.66 852.8 408.92 853.36L408.45 852.61C409.23 852.06 410.76 851.17 412.56 851.17C415.18 851.17 416.06 853.07 416.06 855.43V862.48H415.2L415.09 861.04H415.04C413.91 861.95 412.57 862.75 411.12 862.75C409.37 862.75 407.92 861.8 407.92 859.73ZM415.04 860.1V856.34C410.5 856.86 408.96 857.92 408.96 859.68C408.96 861.26 410.03 861.87 411.3 861.87C412.57 861.87 413.68 861.26 415.04 860.09V860.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.92 856.979C420.92 853.419 423.18 851.159 425.82 851.159C427.14 851.159 428.05 851.659 429.15 852.519L429.1 850.489V845.939H430.12V862.479H429.26L429.15 861.049H429.1C428.19 861.959 426.97 862.759 425.5 862.759C422.73 862.759 420.93 860.709 420.93 856.979H420.92ZM429.1 860.029V853.479C427.94 852.449 426.97 852.059 425.88 852.059C423.69 852.059 421.99 854.199 421.99 856.969C421.99 859.909 423.3 861.849 425.64 861.849C426.86 861.849 427.94 861.209 429.1 860.029Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.27 856.979C435.27 853.419 437.53 851.159 440.17 851.159C441.49 851.159 442.4 851.659 443.5 852.519L443.45 850.489V845.939H444.47V862.479H443.61L443.5 861.049H443.45C442.54 861.959 441.32 862.759 439.85 862.759C437.08 862.759 435.28 860.709 435.28 856.979H435.27ZM443.45 860.029V853.479C442.29 852.449 441.32 852.059 440.23 852.059C438.04 852.059 436.34 854.199 436.34 856.969C436.34 859.909 437.65 861.849 439.99 861.849C441.21 861.849 442.29 861.209 443.45 860.029Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.62 856.98C449.62 853.38 451.96 851.16 454.43 851.16C457.05 851.16 458.66 853.02 458.66 856.27C458.66 856.55 458.66 856.82 458.6 857.1H450.66C450.7 859.89 452.33 861.88 454.82 861.88C456.02 861.88 456.96 861.48 457.79 860.9L458.21 861.67C457.34 862.21 456.35 862.76 454.73 862.76C451.91 862.76 449.63 860.59 449.63 856.98H449.62ZM457.7 856.26C457.7 853.44 456.42 852.04 454.44 852.04C452.57 852.04 450.88 853.62 450.65 856.26H457.7Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.57 856.979C462.57 853.419 464.83 851.159 467.47 851.159C468.79 851.159 469.7 851.659 470.8 852.519L470.75 850.489V845.939H471.77V862.479H470.91L470.8 861.049H470.75C469.84 861.959 468.62 862.759 467.15 862.759C464.38 862.759 462.58 860.709 462.58 856.979H462.57ZM470.75 860.029V853.479C469.59 852.449 468.62 852.059 467.53 852.059C465.34 852.059 463.64 854.199 463.64 856.969C463.64 859.909 464.95 861.849 467.29 861.849C468.51 861.849 469.59 861.209 470.75 860.029Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.28 860.999V845.939H485.3V861.139C485.3 861.629 485.5 861.859 485.78 861.859C485.88 861.859 485.97 861.859 486.19 861.809L486.36 862.639C486.15 862.699 485.96 862.749 485.63 862.749C484.74 862.749 484.28 862.199 484.28 860.989V860.999Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.78 859.73C490.78 857.28 492.99 856.11 497.9 855.57C497.93 853.87 497.47 852.06 495.3 852.06C493.81 852.06 492.52 852.8 491.78 853.36L491.31 852.61C492.09 852.06 493.62 851.17 495.42 851.17C498.04 851.17 498.92 853.07 498.92 855.43V862.48H498.06L497.95 861.04H497.9C496.77 861.95 495.43 862.75 493.98 862.75C492.23 862.75 490.78 861.8 490.78 859.73ZM497.91 860.1V856.34C493.37 856.86 491.83 857.92 491.83 859.68C491.83 861.26 492.9 861.87 494.17 861.87C495.44 861.87 496.55 861.26 497.91 860.09V860.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.13 867.279L503.36 866.399C503.59 866.489 503.95 866.579 504.26 866.579C505.61 866.579 506.53 865.329 507.09 863.649L507.39 862.689L502.86 851.439H503.96L506.62 858.379C506.98 859.309 507.42 860.499 507.82 861.479H507.91C508.26 860.499 508.62 859.319 508.94 858.379L511.29 851.439H512.33L507.97 863.869C507.35 865.709 506.24 867.509 504.25 867.509C503.84 867.509 503.42 867.419 503.12 867.279H503.13Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.62 856.98C515.62 853.38 517.96 851.16 520.43 851.16C523.05 851.16 524.66 853.02 524.66 856.27C524.66 856.55 524.66 856.82 524.6 857.1H516.66C516.7 859.89 518.33 861.88 520.82 861.88C522.02 861.88 522.96 861.48 523.79 860.9L524.21 861.67C523.34 862.21 522.35 862.76 520.73 862.76C517.91 862.76 515.63 860.59 515.63 856.98H515.62ZM523.71 856.26C523.71 853.44 522.43 852.04 520.45 852.04C518.58 852.04 516.89 853.62 516.66 856.26H523.71Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.5 851.44H530.36L530.47 853.5H530.52C531.27 852.14 532.35 851.16 533.66 851.16C534.06 851.16 534.39 851.21 534.75 851.39L534.52 852.31C534.15 852.18 533.95 852.13 533.52 852.13C532.53 852.13 531.35 852.88 530.51 854.97V862.48H529.49V851.44H529.5Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.14 856.98C544.14 853.29 546.44 851.16 549.1 851.16C551.76 851.16 554.06 853.28 554.06 856.98C554.06 860.68 551.76 862.76 549.1 862.76C546.44 862.76 544.14 860.64 544.14 856.98ZM552.99 856.98C552.99 854.07 551.33 852.06 549.1 852.06C546.87 852.06 545.21 854.07 545.21 856.98C545.21 859.89 546.87 861.86 549.1 861.86C551.33 861.86 552.99 859.89 552.99 856.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.83 851.54L559.37 851.44H562.92V852.33H557.83V851.54ZM559.35 848.98C559.35 846.79 560.33 845.66 562.08 845.66C562.6 845.66 563.18 845.81 563.69 846.03L563.41 846.86C562.96 846.64 562.5 846.55 562.1 846.55C560.91 846.55 560.37 847.45 560.37 849.05V862.48H559.35V848.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.16 851.54L573.7 851.44H577.25V852.33H572.16V851.54ZM573.67 848.98C573.67 846.79 574.65 845.66 576.4 845.66C576.92 845.66 577.5 845.81 578.01 846.03L577.73 846.86C577.28 846.64 576.82 846.55 576.42 846.55C575.23 846.55 574.69 847.45 574.69 849.05V862.48H573.67V848.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.16 859.73C580.16 857.28 582.37 856.11 587.28 855.57C587.31 853.87 586.85 852.06 584.68 852.06C583.19 852.06 581.9 852.8 581.16 853.36L580.69 852.61C581.47 852.06 583 851.17 584.8 851.17C587.42 851.17 588.3 853.07 588.3 855.43V862.48H587.44L587.33 861.04H587.28C586.15 861.95 584.81 862.75 583.36 862.75C581.61 862.75 580.16 861.8 580.16 859.73ZM587.28 860.1V856.34C582.74 856.86 581.2 857.92 581.2 859.68C581.2 861.26 582.27 861.87 583.54 861.87C584.81 861.87 585.92 861.26 587.28 860.09V860.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.08 851.44H594.94L595.05 853.15H595.1C596.23 852.03 597.38 851.16 598.9 851.16C601.18 851.16 602.24 852.54 602.24 855.4V862.48H601.22V855.53C601.22 853.19 600.48 852.08 598.7 852.08C597.38 852.08 596.43 852.77 595.09 854.15V862.48H594.07V851.44H594.08Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.79 861.23L607.38 860.49C608.31 861.27 609.32 861.89 610.89 861.89C612.63 861.89 613.53 860.87 613.53 859.71C613.53 858.33 612.1 857.72 610.83 857.26C609.16 856.67 607.31 855.99 607.31 854.11C607.31 852.52 608.57 851.17 610.87 851.17C612.05 851.17 613.22 851.66 614.03 852.32L613.48 853.05C612.73 852.49 611.95 852.04 610.84 852.04C609.12 852.04 608.34 853.03 608.34 854.05C608.34 855.31 609.64 855.79 610.96 856.28C612.67 856.93 614.57 857.49 614.57 859.65C614.57 861.31 613.24 862.76 610.85 862.76C609.21 862.76 607.79 862.07 606.8 861.23H606.79Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.83 856.98C624.83 853.29 627.13 851.16 629.79 851.16C632.45 851.16 634.75 853.28 634.75 856.98C634.75 860.68 632.45 862.76 629.79 862.76C627.13 862.76 624.83 860.64 624.83 856.98ZM633.68 856.98C633.68 854.07 632.02 852.06 629.79 852.06C627.56 852.06 625.9 854.07 625.9 856.98C625.9 859.89 627.56 861.86 629.79 861.86C632.02 861.86 633.68 859.89 633.68 856.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.9 851.44H640.76L640.87 853.5H640.92C641.67 852.14 642.75 851.16 644.06 851.16C644.46 851.16 644.79 851.21 645.15 851.39L644.92 852.31C644.55 852.18 644.35 852.13 643.92 852.13C642.93 852.13 641.75 852.88 640.91 854.97V862.48H639.89V851.44H639.9Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.68 859.73C654.68 857.28 656.89 856.11 661.8 855.57C661.83 853.87 661.37 852.06 659.2 852.06C657.71 852.06 656.42 852.8 655.68 853.36L655.21 852.61C655.99 852.06 657.52 851.17 659.32 851.17C661.94 851.17 662.82 853.07 662.82 855.43V862.48H661.96L661.85 861.04H661.8C660.67 861.95 659.33 862.75 657.88 862.75C656.13 862.75 654.68 861.8 654.68 859.73ZM661.8 860.1V856.34C657.26 856.86 655.72 857.92 655.72 859.68C655.72 861.26 656.79 861.87 658.06 861.87C659.33 861.87 660.44 861.26 661.8 860.09V860.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.68 856.979C667.68 853.419 669.94 851.159 672.58 851.159C673.9 851.159 674.81 851.659 675.91 852.519L675.86 850.489V845.939H676.88V862.479H676.02L675.91 861.049H675.86C674.95 861.959 673.73 862.759 672.26 862.759C669.49 862.759 667.69 860.709 667.69 856.979H667.68ZM675.86 860.029V853.479C674.7 852.449 673.73 852.059 672.64 852.059C670.45 852.059 668.75 854.199 668.75 856.969C668.75 859.909 670.06 861.849 672.4 861.849C673.62 861.849 674.7 861.209 675.86 860.029Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.11 851.439H682.21L684.69 858.359C685.05 859.429 685.45 860.539 685.81 861.529H685.9C686.26 860.539 686.66 859.419 687.02 858.359L689.5 851.439H690.54L686.45 862.479H685.25L681.11 851.439Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.83 856.98C693.83 853.38 696.17 851.16 698.64 851.16C701.26 851.16 702.87 853.02 702.87 856.27C702.87 856.55 702.87 856.82 702.81 857.1H694.87C694.91 859.89 696.54 861.88 699.03 861.88C700.23 861.88 701.17 861.48 702 860.9L702.42 861.67C701.55 862.21 700.56 862.76 698.94 862.76C696.12 862.76 693.84 860.59 693.84 856.98H693.83ZM701.91 856.26C701.91 853.44 700.63 852.04 698.65 852.04C696.78 852.04 695.09 853.62 694.86 856.26H701.91Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.7 851.44H708.56L708.67 853.5H708.72C709.47 852.14 710.55 851.16 711.86 851.16C712.26 851.16 712.59 851.21 712.95 851.39L712.72 852.31C712.35 852.18 712.15 852.13 711.72 852.13C710.73 852.13 709.55 852.88 708.71 854.97V862.48H707.69V851.44H707.7Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.09 859.43V852.32H715.37V851.531L717.12 851.43L717.25 848.23H718.11V851.43H721.31V852.32H718.11V859.5C718.11 860.91 718.46 861.86 719.99 861.86C720.4 861.86 720.97 861.69 721.37 861.51L721.64 862.331C721 862.561 720.29 862.74 719.84 862.74C717.72 862.74 717.1 861.39 717.1 859.42L717.09 859.43Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.45 847.871C725.45 847.301 725.87 846.971 726.37 846.971C726.87 846.971 727.29 847.301 727.29 847.871C727.29 848.401 726.87 848.771 726.37 848.771C725.87 848.771 725.45 848.401 725.45 847.871ZM725.85 851.441H726.87V862.481H725.85V851.441Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.58 861.23L732.17 860.49C733.1 861.27 734.11 861.89 735.68 861.89C737.42 861.89 738.32 860.87 738.32 859.71C738.32 858.33 736.89 857.72 735.62 857.26C733.95 856.67 732.1 855.99 732.1 854.11C732.1 852.52 733.36 851.17 735.66 851.17C736.84 851.17 738.01 851.66 738.82 852.32L738.27 853.05C737.52 852.49 736.74 852.04 735.63 852.04C733.91 852.04 733.13 853.03 733.13 854.05C733.13 855.31 734.43 855.79 735.75 856.28C737.46 856.93 739.36 857.49 739.36 859.65C739.36 861.31 738.03 862.76 735.64 862.76C734 862.76 732.58 862.07 731.59 861.23H731.58Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.18 856.98C743.18 853.38 745.52 851.16 747.99 851.16C750.61 851.16 752.22 853.02 752.22 856.27C752.22 856.55 752.22 856.82 752.16 857.1H744.22C744.26 859.89 745.89 861.88 748.38 861.88C749.58 861.88 750.52 861.48 751.35 860.9L751.77 861.67C750.9 862.21 749.91 862.76 748.29 862.76C745.47 862.76 743.19 860.59 743.19 856.98H743.18ZM751.27 856.26C751.27 853.44 749.99 852.04 748.01 852.04C746.14 852.04 744.45 853.62 744.22 856.26H751.27Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.06 851.44H757.92L758.03 853.5H758.08C758.83 852.14 759.91 851.16 761.22 851.16C761.62 851.16 761.95 851.21 762.31 851.39L762.08 852.31C761.71 852.18 761.51 852.13 761.08 852.13C760.09 852.13 758.91 852.88 758.07 854.97V862.48H757.05V851.44H757.06Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.79 861.23L765.38 860.49C766.31 861.27 767.32 861.89 768.89 861.89C770.63 861.89 771.53 860.87 771.53 859.71C771.53 858.33 770.1 857.72 768.83 857.26C767.16 856.67 765.31 855.99 765.31 854.11C765.31 852.52 766.57 851.17 768.87 851.17C770.05 851.17 771.22 851.66 772.03 852.32L771.48 853.05C770.73 852.49 769.95 852.04 768.84 852.04C767.12 852.04 766.34 853.03 766.34 854.05C766.34 855.31 767.64 855.79 768.96 856.28C770.67 856.93 772.57 857.49 772.57 859.65C772.57 861.31 771.24 862.76 768.85 862.76C767.21 862.76 765.79 862.07 764.8 861.23H764.79Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1702 910.23L86.7602 909.49C87.6902 910.27 88.7002 910.89 90.2702 910.89C92.0102 910.89 92.9102 909.87 92.9102 908.71C92.9102 907.33 91.4802 906.72 90.2102 906.26C88.5402 905.67 86.6902 904.99 86.6902 903.11C86.6902 901.52 87.9502 900.17 90.2502 900.17C91.4302 900.17 92.6002 900.66 93.4102 901.32L92.8602 902.05C92.1102 901.49 91.3302 901.04 90.2202 901.04C88.5002 901.04 87.7202 902.03 87.7202 903.05C87.7202 904.31 89.0202 904.79 90.3402 905.28C92.0502 905.93 93.9502 906.49 93.9502 908.65C93.9502 910.32 92.6202 911.76 90.2302 911.76C88.5902 911.76 87.1702 911.07 86.1802 910.23H86.1702Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.77 905.98C97.77 902.38 100.11 900.16 102.58 900.16C105.2 900.16 106.81 902.02 106.81 905.27C106.81 905.55 106.81 905.82 106.75 906.1H98.81C98.85 908.89 100.48 910.88 102.97 910.88C104.17 910.88 105.11 910.48 105.94 909.9L106.36 910.67C105.49 911.21 104.5 911.76 102.88 911.76C100.06 911.76 97.78 909.59 97.78 905.98H97.77ZM105.85 905.26C105.85 902.44 104.57 901.04 102.59 901.04C100.72 901.04 99.03 902.62 98.8 905.26H105.85Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.65 900.44H112.51L112.62 902.15H112.67C113.8 901.03 114.95 900.16 116.47 900.16C118.75 900.16 119.81 901.54 119.81 904.4V911.48H118.79V904.53C118.79 902.19 118.05 901.08 116.27 901.08C114.95 901.08 114 901.77 112.66 903.15V911.48H111.64V900.44H111.65Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8 905.979C124.8 902.419 127.06 900.159 129.7 900.159C131.02 900.159 131.93 900.659 133.03 901.519L132.98 899.489V894.939H134V911.479H133.14L133.03 910.049H132.98C132.07 910.959 130.85 911.759 129.38 911.759C126.61 911.759 124.81 909.709 124.81 905.979H124.8ZM132.97 909.039V902.489C131.81 901.459 130.84 901.069 129.75 901.069C127.56 901.069 125.86 903.209 125.86 905.979C125.86 908.919 127.17 910.859 129.51 910.859C130.73 910.859 131.81 910.219 132.97 909.039Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.68 896.871C139.68 896.301 140.1 895.971 140.6 895.971C141.1 895.971 141.52 896.301 141.52 896.871C141.52 897.401 141.1 897.771 140.6 897.771C140.1 897.771 139.68 897.401 139.68 896.871ZM140.07 900.441H141.09V911.481H140.07V900.441Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.18 900.44H148.04L148.15 902.15H148.2C149.33 901.03 150.48 900.16 152 900.16C154.28 900.16 155.34 901.54 155.34 904.4V911.48H154.32V904.53C154.32 902.19 153.58 901.08 151.8 901.08C150.48 901.08 149.53 901.77 148.19 903.15V911.48H147.17V900.44H147.18Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.32 913.74C160.32 912.78 160.95 911.79 161.97 911.08V910.99C161.41 910.66 160.99 910.06 160.99 909.22C160.99 908.23 161.7 907.53 162.2 907.18V907.09C161.5 906.5 160.8 905.4 160.8 904.06C160.8 901.79 162.53 900.16 164.69 900.16C165.29 900.16 165.81 900.29 166.16 900.44H169.9V901.3H167.33C168.04 901.91 168.55 902.9 168.55 904.07C168.55 906.33 166.85 907.97 164.69 907.97C164.07 907.97 163.37 907.8 162.86 907.5C162.38 907.89 161.96 908.36 161.96 909.1C161.96 909.89 162.42 910.53 164.07 910.53H166.44C168.92 910.53 170.08 911.32 170.08 913.06C170.08 914.96 168.04 916.79 164.86 916.79C162.07 916.79 160.32 915.59 160.32 913.73V913.74ZM169.04 913.18C169.04 911.96 168.16 911.5 166.49 911.5H164.12C163.9 911.5 163.32 911.45 162.75 911.32C161.73 912.01 161.3 912.86 161.3 913.64C161.3 915.04 162.63 915.98 164.96 915.98C167.45 915.98 169.04 914.57 169.04 913.18ZM167.55 904.06C167.55 902.2 166.26 901.01 164.69 901.01C163.12 901.01 161.83 902.18 161.83 904.06C161.83 905.94 163.16 907.16 164.69 907.16C166.22 907.16 167.55 905.91 167.55 904.06Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.95 908.73C179.95 906.28 182.16 905.11 187.07 904.57C187.1 902.87 186.64 901.06 184.47 901.06C182.98 901.06 181.69 901.8 180.95 902.36L180.48 901.61C181.26 901.06 182.79 900.17 184.59 900.17C187.21 900.17 188.09 902.07 188.09 904.43V911.48H187.23L187.12 910.05H187.07C185.94 910.96 184.6 911.76 183.15 911.76C181.4 911.76 179.95 910.81 179.95 908.74V908.73ZM187.07 909.1V905.34C182.53 905.86 180.99 906.92 180.99 908.68C180.99 910.26 182.06 910.87 183.33 910.87C184.6 910.87 185.71 910.26 187.07 909.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.31 900.44H201.17L201.28 901.83H201.33C202.41 900.97 203.72 900.16 205.08 900.16C208.04 900.16 209.5 902.38 209.5 905.79C209.5 909.54 207.24 911.75 204.63 911.75C203.58 911.75 202.46 911.25 201.31 910.39V912.43L201.32 916.47H200.3V900.43L200.31 900.44ZM208.43 905.8C208.43 903.09 207.46 901.06 204.92 901.06C203.83 901.06 202.66 901.7 201.33 902.88V909.43C202.58 910.47 203.74 910.85 204.58 910.85C206.83 910.85 208.43 908.79 208.43 905.8Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.53 908.73C213.53 906.28 215.74 905.11 220.65 904.57C220.68 902.87 220.22 901.06 218.05 901.06C216.56 901.06 215.27 901.8 214.53 902.36L214.06 901.61C214.84 901.06 216.37 900.17 218.17 900.17C220.79 900.17 221.67 902.07 221.67 904.43V911.48H220.81L220.7 910.05H220.65C219.52 910.96 218.18 911.76 216.73 911.76C214.98 911.76 213.53 910.81 213.53 908.74V908.73ZM220.65 909.1V905.34C216.11 905.86 214.57 906.92 214.57 908.68C214.57 910.26 215.64 910.87 216.91 910.87C218.18 910.87 219.29 910.26 220.65 909.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.06 896.871C227.06 896.301 227.48 895.971 227.98 895.971C228.48 895.971 228.9 896.301 228.9 896.871C228.9 897.401 228.48 897.771 227.98 897.771C227.48 897.771 227.06 897.401 227.06 896.871ZM227.45 900.441H228.47V911.481H227.45V900.441Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.64 905.979C233.64 902.419 235.9 900.159 238.54 900.159C239.86 900.159 240.77 900.659 241.87 901.519L241.82 899.489V894.939H242.84V911.479H241.98L241.87 910.049H241.82C240.91 910.959 239.69 911.759 238.22 911.759C235.45 911.759 233.65 909.709 233.65 905.979H233.64ZM241.81 909.039V902.489C240.65 901.459 239.68 901.069 238.59 901.069C236.4 901.069 234.7 903.209 234.7 905.979C234.7 908.919 236.01 910.859 238.35 910.859C239.57 910.859 240.65 910.219 241.81 909.039Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.35 900.44H256.21L256.32 902.15H256.37C257.37 901.03 258.63 900.16 259.86 900.16C261.63 900.16 262.52 901.05 262.91 902.41C264.16 901.03 265.38 900.16 266.66 900.16C268.86 900.16 269.96 901.54 269.96 904.4V911.48H268.94V904.53C268.94 902.19 268.16 901.08 266.47 901.08C265.43 901.08 264.38 901.77 263.16 903.15V911.48H262.14V904.53C262.14 902.19 261.36 901.08 259.67 901.08C258.67 901.08 257.58 901.77 256.36 903.15V911.48H255.34V900.44H255.35Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.94 905.98C274.94 902.38 277.28 900.16 279.75 900.16C282.37 900.16 283.98 902.02 283.98 905.27C283.98 905.55 283.98 905.82 283.92 906.1H275.98C276.02 908.89 277.65 910.88 280.14 910.88C281.34 910.88 282.28 910.48 283.11 909.9L283.53 910.67C282.66 911.21 281.67 911.76 280.05 911.76C277.23 911.76 274.95 909.59 274.95 905.98H274.94ZM283.02 905.26C283.02 902.44 281.74 901.04 279.76 901.04C277.89 901.04 276.2 902.62 275.97 905.26H283.02Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.44 910.23L288.03 909.49C288.96 910.27 289.97 910.89 291.54 910.89C293.28 910.89 294.18 909.87 294.18 908.71C294.18 907.33 292.75 906.72 291.48 906.26C289.81 905.67 287.96 904.99 287.96 903.11C287.96 901.52 289.22 900.17 291.52 900.17C292.7 900.17 293.87 900.66 294.68 901.32L294.13 902.05C293.38 901.49 292.6 901.04 291.49 901.04C289.77 901.04 288.99 902.03 288.99 903.05C288.99 904.31 290.29 904.79 291.61 905.28C293.32 905.93 295.22 906.49 295.22 908.65C295.22 910.32 293.89 911.76 291.5 911.76C289.86 911.76 288.44 911.07 287.45 910.23H287.44Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.59 910.23L299.18 909.49C300.11 910.27 301.12 910.89 302.69 910.89C304.43 910.89 305.33 909.87 305.33 908.71C305.33 907.33 303.9 906.72 302.63 906.26C300.96 905.67 299.11 904.99 299.11 903.11C299.11 901.52 300.37 900.17 302.67 900.17C303.85 900.17 305.02 900.66 305.83 901.32L305.28 902.05C304.53 901.49 303.75 901.04 302.64 901.04C300.92 901.04 300.14 902.03 300.14 903.05C300.14 904.31 301.44 904.79 302.76 905.28C304.47 905.93 306.37 906.49 306.37 908.65C306.37 910.32 305.04 911.76 302.65 911.76C301.01 911.76 299.59 911.07 298.6 910.23H298.59Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.33 908.73C310.33 906.28 312.54 905.11 317.45 904.57C317.48 902.87 317.02 901.06 314.85 901.06C313.36 901.06 312.07 901.8 311.33 902.36L310.86 901.61C311.64 901.06 313.17 900.17 314.97 900.17C317.59 900.17 318.47 902.07 318.47 904.43V911.48H317.61L317.5 910.05H317.45C316.32 910.96 314.98 911.76 313.53 911.76C311.78 911.76 310.33 910.81 310.33 908.74V908.73ZM317.46 909.1V905.34C312.92 905.86 311.38 906.92 311.38 908.68C311.38 910.26 312.45 910.87 313.72 910.87C314.99 910.87 316.1 910.26 317.46 909.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.32 913.74C323.32 912.78 323.95 911.79 324.97 911.08V910.99C324.41 910.66 323.99 910.06 323.99 909.22C323.99 908.23 324.7 907.53 325.2 907.18V907.09C324.5 906.5 323.8 905.4 323.8 904.06C323.8 901.79 325.53 900.16 327.69 900.16C328.29 900.16 328.81 900.29 329.16 900.44H332.9V901.3H330.33C331.04 901.91 331.55 902.9 331.55 904.07C331.55 906.33 329.85 907.97 327.69 907.97C327.07 907.97 326.37 907.8 325.86 907.5C325.38 907.89 324.96 908.36 324.96 909.1C324.96 909.89 325.42 910.53 327.07 910.53H329.44C331.92 910.53 333.08 911.32 333.08 913.06C333.08 914.96 331.04 916.79 327.86 916.79C325.07 916.79 323.32 915.59 323.32 913.73V913.74ZM332.04 913.18C332.04 911.96 331.16 911.5 329.49 911.5H327.12C326.9 911.5 326.32 911.45 325.75 911.32C324.73 912.01 324.3 912.86 324.3 913.64C324.3 915.04 325.63 915.98 327.96 915.98C330.45 915.98 332.04 914.57 332.04 913.18ZM330.55 904.06C330.55 902.2 329.26 901.01 327.69 901.01C326.12 901.01 324.83 902.18 324.83 904.06C324.83 905.94 326.16 907.16 327.69 907.16C329.22 907.16 330.55 905.91 330.55 904.06Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.12 905.98C336.12 902.38 338.46 900.16 340.93 900.16C343.55 900.16 345.16 902.02 345.16 905.27C345.16 905.55 345.16 905.82 345.1 906.1H337.16C337.2 908.89 338.83 910.88 341.32 910.88C342.52 910.88 343.46 910.48 344.29 909.9L344.71 910.67C343.84 911.21 342.85 911.76 341.23 911.76C338.41 911.76 336.13 909.59 336.13 905.98H336.12ZM344.2 905.26C344.2 902.44 342.92 901.04 340.94 901.04C339.07 901.04 337.38 902.62 337.15 905.26H344.2Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.97 914.35C350.02 913.79 350.74 912.81 350.74 911.5L350.45 910.13L351.27 911.21C351.07 911.53 350.77 911.58 350.47 911.58C349.94 911.58 349.5 911.25 349.5 910.62C349.5 909.99 349.98 909.66 350.48 909.66C351.19 909.66 351.65 910.29 351.65 911.3C351.65 912.98 350.67 914.3 349.29 915.05L348.96 914.35H348.97Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.57 908.43V901.32H361.85V900.531L363.6 900.43L363.73 897.23H364.59V900.43H367.79V901.32H364.59V908.5C364.59 909.91 364.94 910.86 366.47 910.86C366.88 910.86 367.45 910.69 367.85 910.51L368.12 911.331C367.48 911.551 366.77 911.74 366.32 911.74C364.2 911.74 363.58 910.39 363.58 908.41L363.57 908.43Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.33 894.939H373.35V899.739L373.33 902.169C374.48 901.019 375.63 900.159 377.15 900.159C379.43 900.159 380.49 901.539 380.49 904.399V911.479H379.47V904.529C379.47 902.189 378.73 901.079 376.95 901.079C375.63 901.079 374.68 901.769 373.34 903.149V911.479H372.32V894.939H372.33Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.52 908.73C385.52 906.28 387.73 905.11 392.64 904.57C392.67 902.87 392.21 901.06 390.04 901.06C388.55 901.06 387.26 901.8 386.52 902.36L386.05 901.61C386.83 901.06 388.36 900.17 390.16 900.17C392.78 900.17 393.66 902.07 393.66 904.43V911.48H392.8L392.69 910.05H392.64C391.51 910.96 390.17 911.76 388.72 911.76C386.97 911.76 385.52 910.81 385.52 908.74V908.73ZM392.64 909.1V905.34C388.1 905.86 386.56 906.92 386.56 908.68C386.56 910.26 387.63 910.87 388.9 910.87C390.17 910.87 391.28 910.26 392.64 909.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.45 908.43V901.32H397.73V900.531L399.48 900.43L399.61 897.23H400.47V900.43H403.67V901.32H400.47V908.5C400.47 909.91 400.82 910.86 402.35 910.86C402.76 910.86 403.33 910.69 403.73 910.51L404 911.331C403.36 911.551 402.65 911.74 402.2 911.74C400.08 911.74 399.46 910.39 399.46 908.41L399.45 908.43Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.9 908.43V901.32H413.18V900.531L414.93 900.43L415.06 897.23H415.92V900.43H419.12V901.32H415.92V908.5C415.92 909.91 416.27 910.86 417.8 910.86C418.21 910.86 418.78 910.69 419.18 910.51L419.45 911.331C418.81 911.551 418.1 911.74 417.65 911.74C415.53 911.74 414.91 910.39 414.91 908.41L414.9 908.43Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.66 894.939H424.68V899.739L424.66 902.169C425.81 901.019 426.96 900.159 428.48 900.159C430.76 900.159 431.82 901.539 431.82 904.399V911.479H430.8V904.529C430.8 902.189 430.06 901.079 428.28 901.079C426.96 901.079 426.01 901.769 424.67 903.149V911.479H423.65V894.939H423.66Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.72 905.98C436.72 902.38 439.06 900.16 441.53 900.16C444.15 900.16 445.76 902.02 445.76 905.27C445.76 905.55 445.76 905.82 445.7 906.1H437.76C437.8 908.89 439.43 910.88 441.92 910.88C443.12 910.88 444.06 910.48 444.89 909.9L445.31 910.67C444.44 911.21 443.45 911.76 441.83 911.76C439.01 911.76 436.73 909.59 436.73 905.98H436.72ZM444.8 905.26C444.8 902.44 443.52 901.04 441.54 901.04C439.67 901.04 437.98 902.62 437.75 905.26H444.8Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.1 905.98C456.1 902.29 458.46 900.16 461.14 900.16C462.64 900.16 463.62 900.83 464.37 901.52L463.77 902.23C463.06 901.57 462.23 901.06 461.16 901.06C458.9 901.06 457.16 903.07 457.16 905.98C457.16 908.89 458.75 910.86 461.15 910.86C462.33 910.86 463.35 910.29 464.11 909.59L464.63 910.3C463.69 911.15 462.51 911.76 461.1 911.76C458.25 911.76 456.09 909.64 456.09 905.98H456.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.2 900.44H470.06L470.17 902.5H470.22C470.97 901.14 472.05 900.16 473.36 900.16C473.76 900.16 474.09 900.21 474.45 900.39L474.22 901.31C473.85 901.18 473.65 901.13 473.22 901.13C472.23 901.13 471.05 901.88 470.21 903.97V911.48H469.19V900.44H469.2Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.17 905.98C477.17 902.38 479.51 900.16 481.98 900.16C484.6 900.16 486.21 902.02 486.21 905.27C486.21 905.55 486.21 905.82 486.15 906.1H478.21C478.25 908.89 479.88 910.88 482.37 910.88C483.57 910.88 484.51 910.48 485.34 909.9L485.76 910.67C484.89 911.21 483.9 911.76 482.28 911.76C479.46 911.76 477.18 909.59 477.18 905.98H477.17ZM485.26 905.26C485.26 902.44 483.98 901.04 482 901.04C480.13 901.04 478.44 902.62 478.21 905.26H485.26Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.91 908.73C489.91 906.28 492.12 905.11 497.03 904.57C497.06 902.87 496.6 901.06 494.43 901.06C492.94 901.06 491.65 901.8 490.91 902.36L490.44 901.61C491.22 901.06 492.75 900.17 494.55 900.17C497.17 900.17 498.05 902.07 498.05 904.43V911.48H497.19L497.08 910.05H497.03C495.9 910.96 494.56 911.76 493.11 911.76C491.36 911.76 489.91 910.81 489.91 908.74V908.73ZM497.04 909.1V905.34C492.5 905.86 490.96 906.92 490.96 908.68C490.96 910.26 492.03 910.87 493.3 910.87C494.57 910.87 495.68 910.26 497.04 909.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.84 908.43V901.32H502.12V900.531L503.87 900.43L504 897.23H504.86V900.43H508.06V901.32H504.86V908.5C504.86 909.91 505.21 910.86 506.74 910.86C507.15 910.86 507.72 910.69 508.12 910.51L508.39 911.331C507.75 911.551 507.04 911.74 506.59 911.74C504.47 911.74 503.85 910.39 503.85 908.41L503.84 908.43Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.42 905.98C511.42 902.29 513.72 900.16 516.38 900.16C519.04 900.16 521.34 902.28 521.34 905.98C521.34 909.68 519.04 911.76 516.38 911.76C513.72 911.76 511.42 909.64 511.42 905.98ZM520.27 905.98C520.27 903.07 518.61 901.06 516.38 901.06C514.15 901.06 512.49 903.07 512.49 905.98C512.49 908.89 514.15 910.86 516.38 910.86C518.61 910.86 520.27 908.89 520.27 905.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.49 900.44H527.35L527.46 902.5H527.51C528.26 901.14 529.34 900.16 530.65 900.16C531.05 900.16 531.38 900.21 531.74 900.39L531.51 901.31C531.14 901.18 530.94 901.13 530.51 901.13C529.52 901.13 528.34 901.88 527.5 903.97V911.48H526.48V900.44H526.49Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.13 905.98C541.13 902.29 543.49 900.16 546.17 900.16C547.67 900.16 548.65 900.83 549.4 901.52L548.8 902.23C548.09 901.57 547.26 901.06 546.19 901.06C543.93 901.06 542.19 903.07 542.19 905.98C542.19 908.89 543.78 910.86 546.18 910.86C547.36 910.86 548.38 910.29 549.14 909.59L549.66 910.3C548.72 911.15 547.54 911.76 546.13 911.76C543.28 911.76 541.12 909.64 541.12 905.98H541.13Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.21 908.73C553.21 906.28 555.42 905.11 560.33 904.57C560.36 902.87 559.9 901.06 557.73 901.06C556.24 901.06 554.95 901.8 554.21 902.36L553.74 901.61C554.52 901.06 556.05 900.17 557.85 900.17C560.47 900.17 561.35 902.07 561.35 904.43V911.48H560.49L560.38 910.05H560.33C559.2 910.96 557.86 911.76 556.41 911.76C554.66 911.76 553.21 910.81 553.21 908.74V908.73ZM560.33 909.1V905.34C555.79 905.86 554.25 906.92 554.25 908.68C554.25 910.26 555.32 910.87 556.59 910.87C557.86 910.87 558.97 910.26 560.33 909.1Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.13 900.44H567.99L568.1 902.15H568.15C569.28 901.03 570.43 900.16 571.95 900.16C574.23 900.16 575.29 901.54 575.29 904.4V911.48H574.27V904.53C574.27 902.19 573.53 901.08 571.75 901.08C570.43 901.08 569.48 901.77 568.14 903.15V911.48H567.12V900.44H567.13Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.72 905.98C586.72 902.29 589.08 900.16 591.76 900.16C593.26 900.16 594.24 900.83 594.99 901.52L594.39 902.23C593.68 901.57 592.85 901.06 591.78 901.06C589.52 901.06 587.78 903.07 587.78 905.98C587.78 908.89 589.37 910.86 591.77 910.86C592.95 910.86 593.97 910.29 594.73 909.59L595.25 910.3C594.31 911.15 593.13 911.76 591.72 911.76C588.87 911.76 586.71 909.64 586.71 905.98H586.72Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.82 894.939H600.84V899.739L600.82 902.169C601.97 901.019 603.12 900.159 604.64 900.159C606.92 900.159 607.98 901.539 607.98 904.399V911.479H606.96V904.529C606.96 902.189 606.22 901.079 604.44 901.079C603.12 901.079 602.17 901.769 600.83 903.149V911.479H599.81V894.939H599.82Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.87 905.98C612.87 902.29 615.17 900.16 617.83 900.16C620.49 900.16 622.79 902.28 622.79 905.98C622.79 909.68 620.49 911.76 617.83 911.76C615.17 911.76 612.87 909.64 612.87 905.98ZM621.72 905.98C621.72 903.07 620.06 901.06 617.83 901.06C615.6 901.06 613.94 903.07 613.94 905.98C613.94 908.89 615.6 910.86 617.83 910.86C620.06 910.86 621.72 908.89 621.72 905.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.02 905.98C627.02 902.29 629.32 900.16 631.98 900.16C634.64 900.16 636.94 902.28 636.94 905.98C636.94 909.68 634.64 911.76 631.98 911.76C629.32 911.76 627.02 909.64 627.02 905.98ZM635.86 905.98C635.86 903.07 634.2 901.06 631.97 901.06C629.74 901.06 628.08 903.07 628.08 905.98C628.08 908.89 629.74 910.86 631.97 910.86C634.2 910.86 635.86 908.89 635.86 905.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.69 910.23L641.28 909.49C642.21 910.27 643.22 910.89 644.79 910.89C646.53 910.89 647.43 909.87 647.43 908.71C647.43 907.33 646 906.72 644.73 906.26C643.06 905.67 641.21 904.99 641.21 903.11C641.21 901.52 642.47 900.17 644.77 900.17C645.95 900.17 647.12 900.66 647.93 901.32L647.38 902.05C646.63 901.49 645.85 901.04 644.74 901.04C643.02 901.04 642.24 902.03 642.24 903.05C642.24 904.31 643.54 904.79 644.86 905.28C646.57 905.93 648.47 906.49 648.47 908.65C648.47 910.32 647.14 911.76 644.75 911.76C643.11 911.76 641.69 911.07 640.7 910.23H640.69Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.29 905.98C652.29 902.38 654.63 900.16 657.1 900.16C659.72 900.16 661.33 902.02 661.33 905.27C661.33 905.55 661.33 905.82 661.27 906.1H653.33C653.37 908.89 655 910.88 657.49 910.88C658.69 910.88 659.63 910.48 660.46 909.9L660.88 910.67C660.01 911.21 659.02 911.76 657.4 911.76C654.58 911.76 652.3 909.59 652.3 905.98H652.29ZM660.38 905.26C660.38 902.44 659.1 901.04 657.12 901.04C655.25 901.04 653.56 902.62 653.33 905.26H660.38Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.87 908.43V901.32H671.15V900.531L672.9 900.43L673.03 897.23H673.89V900.43H677.09V901.32H673.89V908.5C673.89 909.91 674.24 910.86 675.77 910.86C676.18 910.86 676.75 910.69 677.15 910.51L677.42 911.331C676.78 911.551 676.07 911.74 675.62 911.74C673.5 911.74 672.88 910.39 672.88 908.41L672.87 908.43Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.44 905.98C680.44 902.29 682.74 900.16 685.4 900.16C688.06 900.16 690.36 902.28 690.36 905.98C690.36 909.68 688.06 911.76 685.4 911.76C682.74 911.76 680.44 909.64 680.44 905.98ZM689.29 905.98C689.29 903.07 687.63 901.06 685.4 901.06C683.17 901.06 681.51 903.07 681.51 905.98C681.51 908.89 683.17 910.86 685.4 910.86C687.63 910.86 689.29 908.89 689.29 905.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.93 900.44H702.79L702.9 902.5H702.95C703.7 901.14 704.78 900.16 706.09 900.16C706.49 900.16 706.82 900.21 707.18 900.39L706.95 901.31C706.58 901.18 706.38 901.13 705.95 901.13C704.96 901.13 703.78 901.88 702.94 903.97V911.48H701.92V900.44H701.93Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.91 905.98C709.91 902.38 712.25 900.16 714.72 900.16C717.34 900.16 718.95 902.02 718.95 905.27C718.95 905.55 718.95 905.82 718.89 906.1H710.95C710.99 908.89 712.62 910.88 715.11 910.88C716.31 910.88 717.25 910.48 718.08 909.9L718.5 910.67C717.63 911.21 716.64 911.76 715.02 911.76C712.2 911.76 709.92 909.59 709.92 905.98H709.91ZM717.99 905.26C717.99 902.44 716.71 901.04 714.73 901.04C712.86 901.04 711.17 902.62 710.94 905.26H717.99Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.41 910.23L723 909.49C723.93 910.27 724.94 910.89 726.51 910.89C728.25 910.89 729.15 909.87 729.15 908.71C729.15 907.33 727.72 906.72 726.45 906.26C724.78 905.67 722.93 904.99 722.93 903.11C722.93 901.52 724.19 900.17 726.49 900.17C727.67 900.17 728.84 900.66 729.65 901.32L729.1 902.05C728.35 901.49 727.57 901.04 726.46 901.04C724.74 901.04 723.96 902.03 723.96 903.05C723.96 904.31 725.26 904.79 726.58 905.28C728.29 905.93 730.19 906.49 730.19 908.65C730.19 910.32 728.86 911.76 726.47 911.76C724.83 911.76 723.41 911.07 722.42 910.23H722.41Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.94 900.44H735.8L735.91 901.83H735.96C737.04 900.97 738.35 900.16 739.71 900.16C742.67 900.16 744.13 902.38 744.13 905.79C744.13 909.54 741.87 911.75 739.26 911.75C738.21 911.75 737.09 911.25 735.94 910.39V912.43L735.95 916.47H734.93V900.43L734.94 900.44ZM743.06 905.8C743.06 903.09 742.09 901.06 739.55 901.06C738.46 901.06 737.29 901.7 735.96 902.88V909.43C737.21 910.47 738.37 910.85 739.21 910.85C741.46 910.85 743.06 908.79 743.06 905.8Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.36 905.98C748.36 902.29 750.66 900.16 753.32 900.16C755.98 900.16 758.28 902.28 758.28 905.98C758.28 909.68 755.98 911.76 753.32 911.76C750.66 911.76 748.36 909.64 748.36 905.98ZM757.21 905.98C757.21 903.07 755.55 901.06 753.32 901.06C751.09 901.06 749.43 903.07 749.43 905.98C749.43 908.89 751.09 910.86 753.32 910.86C755.55 910.86 757.21 908.89 757.21 905.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.44 900.44H764.3L764.41 902.15H764.46C765.59 901.03 766.74 900.16 768.26 900.16C770.54 900.16 771.6 901.54 771.6 904.4V911.48H770.58V904.53C770.58 902.19 769.84 901.08 768.06 901.08C766.74 901.08 765.79 901.77 764.45 903.15V911.48H763.43V900.44H763.44Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.59 905.979C776.59 902.419 778.85 900.159 781.49 900.159C782.81 900.159 783.72 900.659 784.82 901.519L784.77 899.489V894.939H785.79V911.479H784.93L784.82 910.049H784.77C783.86 910.959 782.64 911.759 781.17 911.759C778.4 911.759 776.6 909.709 776.6 905.979H776.59ZM784.77 909.039V902.489C783.61 901.459 782.64 901.069 781.55 901.069C779.36 901.069 777.66 903.209 777.66 905.979C777.66 908.919 778.97 910.859 781.31 910.859C782.53 910.859 783.61 910.219 784.77 909.039Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8001 957.43V950.32H86.0801V949.531L87.8301 949.43L87.9601 946.23H88.8201V949.43H92.0201V950.32H88.8201V957.5C88.8201 958.91 89.1701 959.86 90.7001 959.86C91.1101 959.86 91.6801 959.69 92.0801 959.51L92.3501 960.331C91.7101 960.551 91.0001 960.74 90.5501 960.74C88.4301 960.74 87.8101 959.39 87.8101 957.41L87.8001 957.43Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3801 954.98C95.3801 951.29 97.6801 949.16 100.34 949.16C103 949.16 105.3 951.28 105.3 954.98C105.3 958.68 103 960.76 100.34 960.76C97.6801 960.76 95.3801 958.64 95.3801 954.98ZM104.22 954.98C104.22 952.07 102.56 950.06 100.33 950.06C98.1001 950.06 96.4401 952.07 96.4401 954.98C96.4401 957.89 98.1001 959.86 100.33 959.86C102.56 959.86 104.22 957.89 104.22 954.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.5 949.54L117.04 949.44H120.59V950.33H115.5V949.54ZM117.02 946.98C117.02 944.79 118 943.66 119.75 943.66C120.27 943.66 120.85 943.81 121.36 944.03L121.08 944.86C120.63 944.64 120.17 944.55 119.77 944.55C118.58 944.55 118.04 945.45 118.04 947.05V960.48H117.02V946.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.6 954.98C123.6 951.29 125.9 949.16 128.56 949.16C131.22 949.16 133.52 951.28 133.52 954.98C133.52 958.68 131.22 960.76 128.56 960.76C125.9 960.76 123.6 958.64 123.6 954.98ZM132.45 954.98C132.45 952.07 130.79 950.06 128.56 950.06C126.33 950.06 124.67 952.07 124.67 954.98C124.67 957.89 126.33 959.86 128.56 959.86C130.79 959.86 132.45 957.89 132.45 954.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.67 949.44H139.53L139.64 951.5H139.69C140.44 950.14 141.52 949.16 142.83 949.16C143.23 949.16 143.56 949.21 143.92 949.39L143.69 950.31C143.32 950.18 143.12 950.13 142.69 950.13C141.7 950.13 140.52 950.88 139.68 952.97V960.48H138.66V949.44H138.67Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.24 949.44H155.1L155.21 951.15H155.26C156.26 950.03 157.52 949.16 158.75 949.16C160.52 949.16 161.41 950.05 161.8 951.41C163.05 950.03 164.27 949.16 165.55 949.16C167.75 949.16 168.85 950.54 168.85 953.4V960.48H167.83V953.53C167.83 951.19 167.05 950.08 165.36 950.08C164.32 950.08 163.27 950.77 162.05 952.15V960.48H161.03V953.53C161.03 951.19 160.25 950.08 158.56 950.08C157.56 950.08 156.47 950.77 155.25 952.15V960.48H154.23V949.44H154.24Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.83 954.98C173.83 951.29 176.13 949.16 178.79 949.16C181.45 949.16 183.75 951.28 183.75 954.98C183.75 958.68 181.45 960.76 178.79 960.76C176.13 960.76 173.83 958.64 173.83 954.98ZM182.68 954.98C182.68 952.07 181.02 950.06 178.79 950.06C176.56 950.06 174.9 952.07 174.9 954.98C174.9 957.89 176.56 959.86 178.79 959.86C181.02 959.86 182.68 957.89 182.68 954.98Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.9 949.44H189.76L189.87 951.5H189.92C190.67 950.14 191.75 949.16 193.06 949.16C193.46 949.16 193.79 949.21 194.15 949.39L193.92 950.31C193.55 950.18 193.35 950.13 192.92 950.13C191.93 950.13 190.75 950.88 189.91 952.97V960.48H188.89V949.44H188.9Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.87 954.98C196.87 951.38 199.21 949.16 201.68 949.16C204.3 949.16 205.91 951.02 205.91 954.27C205.91 954.55 205.91 954.82 205.85 955.1H197.91C197.95 957.89 199.58 959.88 202.07 959.88C203.27 959.88 204.21 959.48 205.04 958.9L205.46 959.67C204.59 960.21 203.6 960.76 201.98 960.76C199.16 960.76 196.88 958.59 196.88 954.98H196.87ZM204.96 954.26C204.96 951.44 203.68 950.04 201.7 950.04C199.83 950.04 198.14 951.62 197.91 954.26H204.96Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.19 949.44H218.05L218.16 951.5H218.21C218.96 950.14 220.04 949.16 221.35 949.16C221.75 949.16 222.08 949.21 222.44 949.39L222.21 950.31C221.84 950.18 221.64 950.13 221.21 950.13C220.22 950.13 219.04 950.88 218.2 952.97V960.48H217.18V949.44H217.19Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.16 954.98C225.16 951.38 227.5 949.16 229.97 949.16C232.59 949.16 234.2 951.02 234.2 954.27C234.2 954.55 234.2 954.82 234.14 955.1H226.2C226.24 957.89 227.87 959.88 230.36 959.88C231.56 959.88 232.5 959.48 233.33 958.9L233.75 959.67C232.88 960.21 231.89 960.76 230.27 960.76C227.45 960.76 225.17 958.59 225.17 954.98H225.16ZM233.25 954.26C233.25 951.44 231.97 950.04 229.99 950.04C228.12 950.04 226.43 951.62 226.2 954.26H233.25Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.47 949.439H238.57L241.05 956.359C241.41 957.429 241.81 958.539 242.17 959.529H242.26C242.62 958.539 243.02 957.419 243.38 956.359L245.86 949.439H246.9L242.81 960.479H241.61L237.47 949.439Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19 954.98C250.19 951.38 252.53 949.16 255 949.16C257.62 949.16 259.23 951.02 259.23 954.27C259.23 954.55 259.23 954.82 259.17 955.1H251.23C251.27 957.89 252.9 959.88 255.39 959.88C256.59 959.88 257.53 959.48 258.36 958.9L258.78 959.67C257.91 960.21 256.92 960.76 255.3 960.76C252.48 960.76 250.2 958.59 250.2 954.98H250.19ZM258.27 954.26C258.27 951.44 256.99 950.04 255.01 950.04C253.14 950.04 251.45 951.62 251.22 954.26H258.27Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.06 949.44H264.92L265.03 951.15H265.08C266.21 950.03 267.36 949.16 268.88 949.16C271.16 949.16 272.22 950.54 272.22 953.4V960.48H271.2V953.53C271.2 951.19 270.46 950.08 268.68 950.08C267.36 950.08 266.41 950.77 265.07 952.15V960.48H264.05V949.44H264.06Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.97 956.519V949.439H278.99V956.389C278.99 958.729 279.73 959.839 281.51 959.839C282.83 959.839 283.78 959.149 285.07 957.589V949.439H286.09V960.479H285.23L285.12 958.629H285.07C283.99 959.899 282.84 960.749 281.32 960.749C279.04 960.749 277.98 959.369 277.98 956.509L277.97 956.519Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.22 954.98C291.22 951.38 293.56 949.16 296.03 949.16C298.65 949.16 300.26 951.02 300.26 954.27C300.26 954.55 300.26 954.82 300.2 955.1H292.26C292.3 957.89 293.93 959.88 296.42 959.88C297.62 959.88 298.56 959.48 299.39 958.9L299.81 959.67C298.94 960.21 297.95 960.76 296.33 960.76C293.51 960.76 291.23 958.59 291.23 954.98H291.22ZM299.3 954.26C299.3 951.44 298.02 950.04 296.04 950.04C294.17 950.04 292.48 951.62 292.25 954.26H299.3Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.52 959.73C304.52 959.06 304.99 958.66 305.5 958.66C306.01 958.66 306.47 959.06 306.47 959.73C306.47 960.36 306 960.76 305.5 960.76C305 960.76 304.52 960.36 304.52 959.73Z",
    fill: "#E3F4FC",
    stroke: "#E3F4FC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3544_1524",
    x: 1037.37,
    y: 114.881,
    width: 878.28,
    height: 1006.01,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.952941 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3544_1524",
    x: 1721.15,
    y: 731.77,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3544_1524",
    x: 1809.93,
    y: 758.809,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3544_1524",
    x: 1813,
    y: 745.5,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3544_1524",
    x: 1777.17,
    y: 680.539,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3544_1524",
    x: 1764.68,
    y: 658.141,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_3544_1524",
    x: 1882.05,
    y: 644.17,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_3544_1524",
    x: 1883.32,
    y: 581.389,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_3544_1524",
    x: 1842.47,
    y: 522.639,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_3544_1524",
    x: 1849.89,
    y: 612.76,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_3544_1524",
    x: 1811.75,
    y: 575.139,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_3544_1524",
    x: 1730.26,
    y: 588.84,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_3544_1524",
    x: 1817.72,
    y: 498.42,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_3544_1524",
    x: 1745.97,
    y: 510.09,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_3544_1524",
    x: 1784.37,
    y: 455.99,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_3544_1524",
    x: 1773.33,
    y: 445.109,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_3544_1524",
    x: 1745.98,
    y: 411.26,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_3544_1524",
    x: 1714.34,
    y: 382.049,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_3544_1524",
    x: 1421.54,
    y: 189.561,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_3544_1524",
    x: 1470.32,
    y: 127.6,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_3544_1524",
    x: 1525.13,
    y: 192.289,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_3544_1524",
    x: 1412.87,
    y: 1086.26,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_3544_1524",
    x: 1461.37,
    y: 1086.43,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_3544_1524",
    x: 1566.7,
    y: 1074.01,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_3544_1524",
    x: 1588.58,
    y: 1081.18,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_3544_1524",
    x: 1507.1,
    y: 1087.32,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_3544_1524",
    x: 1558.41,
    y: 991.25,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_3544_1524",
    x: 1347.21,
    y: 1082.86,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_3544_1524",
    x: 1369.45,
    y: 1084.28,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_d_3544_1524",
    x: 1483.48,
    y: 1018.19,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_d_3544_1524",
    x: 1455.58,
    y: 1001.63,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_d_3544_1524",
    x: 1556.31,
    y: 910.971,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_d_3544_1524",
    x: 1515.45,
    y: 914.9,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_d_3544_1524",
    x: 1507.34,
    y: 890.471,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_d_3544_1524",
    x: 1365.96,
    y: 948.98,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_d_3544_1524",
    x: 1434.85,
    y: 880.461,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_d_3544_1524",
    x: 1450.82,
    y: 844.15,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_d_3544_1524",
    x: 1487.86,
    y: 828.59,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_d_3544_1524",
    x: 1544.48,
    y: 815.65,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_d_3544_1524",
    x: 1225.33,
    y: 798.84,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_d_3544_1524",
    x: 1206.65,
    y: 789.5,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_d_3544_1524",
    x: 1152.07,
    y: 772.891,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_d_3544_1524",
    x: 1138.46,
    y: 772.57,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_d_3544_1524",
    x: 1118.84,
    y: 767.35,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_d_3544_1524",
    x: 1168.6,
    y: 740.811,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_d_3544_1524",
    x: 1141.09,
    y: 712.65,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_d_3544_1524",
    x: 1223.21,
    y: 715.34,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_d_3544_1524",
    x: 1238.09,
    y: 648.85,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_d_3544_1524",
    x: 1218.24,
    y: 639.59,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_d_3544_1524",
    x: 1248.84,
    y: 601.881,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_d_3544_1524",
    x: 1239.41,
    y: 596.75,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_d_3544_1524",
    x: 1146.87,
    y: 606.65,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_d_3544_1524",
    x: 1074.77,
    y: 694.49,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_d_3544_1524",
    x: 1050.1,
    y: 627.789,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_d_3544_1524",
    x: 1054.47,
    y: 564.07,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_d_3544_1524",
    x: 1097.51,
    y: 515.449,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_d_3544_1524",
    x: 1170.36,
    y: 557.311,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter57_d_3544_1524",
    x: 1149.79,
    y: 545.629,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter58_d_3544_1524",
    x: 1138.22,
    y: 456.109,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter59_d_3544_1524",
    x: 1153.73,
    y: 463.52,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter60_d_3544_1524",
    x: 1154.78,
    y: 445.01,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter61_d_3544_1524",
    x: 1233.14,
    y: 466,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter62_d_3544_1524",
    x: 1212.07,
    y: 382.65,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter63_d_3544_1524",
    x: 1184.6,
    y: 416.4,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter64_d_3544_1524",
    x: 1248.91,
    y: 402.92,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter65_d_3544_1524",
    x: 1303.84,
    y: 303.25,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter66_d_3544_1524",
    x: 1340.18,
    y: 277.82,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter67_d_3544_1524",
    x: 1359.79,
    y: 284.1,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter68_d_3544_1524",
    x: 1375,
    y: 237.09,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter69_d_3544_1524",
    x: 1381.7,
    y: 312.9,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter70_d_3544_1524",
    x: 1577.19,
    y: 238.279,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter71_d_3544_1524",
    x: 1552.76,
    y: 275.5,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter72_d_3544_1524",
    x: 1525.46,
    y: 319.949,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter73_d_3544_1524",
    x: 1510.99,
    y: 275.359,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter74_d_3544_1524",
    x: 1468.43,
    y: 235.51,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter75_d_3544_1524",
    x: 1472.12,
    y: 321.699,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter76_d_3544_1524",
    x: 1660.84,
    y: 317.77,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter77_d_3544_1524",
    x: 1643.6,
    y: 301.6,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter78_d_3544_1524",
    x: 1856.72,
    y: 692.42,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter79_d_3544_1524",
    x: -0.330078,
    y: 148.58,
    width: 898.95,
    height: 444.992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.847059 0 0 0 0 0.988235 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter80_d_3544_1524",
    x: 53.74,
    y: 539.189,
    width: 598.67,
    height: 116.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.764706 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter81_d_3544_1524",
    x: -97.03,
    y: 99.8398,
    width: 2065.27,
    height: 1019.96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.788235 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter82_d_3544_1524",
    x: 1290.79,
    y: 790.141,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter83_d_3544_1524",
    x: 1415.4,
    y: 776.18,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter84_d_3544_1524",
    x: 1537.52,
    y: 780.82,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter85_d_3544_1524",
    x: 1553.63,
    y: 791.279,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter86_d_3544_1524",
    x: 1660.93,
    y: 788.08,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter87_d_3544_1524",
    x: 1625.88,
    y: 772.881,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter88_d_3544_1524",
    x: 1683.88,
    y: 798.17,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter89_d_3544_1524",
    x: 743.94,
    y: 909.311,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter90_d_3544_1524",
    x: 913.75,
    y: 1035.86,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter91_d_3544_1524",
    x: 1190.37,
    y: 932.32,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter92_d_3544_1524",
    x: 984.27,
    y: 1088.71,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter93_d_3544_1524",
    x: 1222.71,
    y: 1088.07,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter94_d_3544_1524",
    x: 1170.43,
    y: 834.051,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter95_d_3544_1524",
    x: 636.64,
    y: 1076.74,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter96_d_3544_1524",
    x: 491.06,
    y: 723.631,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter97_d_3544_1524",
    x: 247.56,
    y: 951.609,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter98_d_3544_1524",
    x: 903.35,
    y: 298.359,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter99_d_3544_1524",
    x: 1086.15,
    y: 437.08,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter100_d_3544_1524",
    x: 1128.84,
    y: 368.15,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter101_d_3544_1524",
    x: 1061.24,
    y: 315.359,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter102_d_3544_1524",
    x: 964.79,
    y: 240.49,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter103_d_3544_1524",
    x: 1075.7,
    y: 135.711,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter104_d_3544_1524",
    x: 1185.37,
    y: 232.52,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter105_d_3544_1524",
    x: 1032.24,
    y: 176.59,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter106_d_3544_1524",
    x: 816.98,
    y: 124.76,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter107_d_3544_1524",
    x: 1020.47,
    y: 121.17,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter108_d_3544_1524",
    x: 1056.51,
    y: 118.811,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter109_d_3544_1524",
    x: 1097.92,
    y: 115.301,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter110_d_3544_1524",
    x: 1258.98,
    y: 119.77,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter111_d_3544_1524",
    x: 1231.73,
    y: 274.6,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter112_d_3544_1524",
    x: 33.3101,
    y: 149.77,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter113_d_3544_1524",
    x: -6.1001,
    y: 121.74,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter114_d_3544_1524",
    x: 259.54,
    y: 120.029,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter115_d_3544_1524",
    x: 277.12,
    y: 163.221,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter116_d_3544_1524",
    x: -6.51001,
    y: 725.961,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter117_d_3544_1524",
    x: 402.96,
    y: 1089.54,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter118_d_3544_1524",
    x: 101.66,
    y: 1090.07,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter119_d_3544_1524",
    x: 1594.84,
    y: 122.789,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter120_d_3544_1524",
    x: 1598.85,
    y: 205.33,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter121_d_3544_1524",
    x: 1906.36,
    y: 123.77,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter122_d_3544_1524",
    x: 1764.97,
    y: 307.631,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter123_d_3544_1524",
    x: 1627.24,
    y: 870.619,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter124_d_3544_1524",
    x: 1636.8,
    y: 1094.54,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter125_d_3544_1524",
    x: 1904,
    y: 978.721,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter126_d_3544_1524",
    x: 1711.52,
    y: 827.301,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter127_d_3544_1524",
    x: 1816.67,
    y: 793.699,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter128_d_3544_1524",
    x: 1904.39,
    y: 872.24,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter129_d_3544_1524",
    x: 470.75,
    y: 673.48,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter130_d_3544_1524",
    x: 527.82,
    y: 688.35,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter131_d_3544_1524",
    x: 43.3049,
    y: 706.564,
    width: 833.03,
    height: 310.859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.121569 0 0 0 0 0.12549 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3544_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3544_1524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3544_1524",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(370.8 325.08) scale(917.34 917.34)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19315B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#111F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0B1327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#080B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#070916"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3544_1524",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1490.34 838.619) scale(700.99 700.99)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19315B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0F1B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#070916"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3544_1524",
    x1: 1028.8,
    y1: 1099,
    x2: 1028.8,
    y2: 127.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0B1328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#182F58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19315B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3544_1524",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1026.65 613.29) scale(1046.3 574.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3544_1524",
    x1: 1715.49,
    y1: 260.368,
    x2: 1509.64,
    y2: 705.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3544_1524",
    x1: 2110.67,
    y1: 933.99,
    x2: 1318.87,
    y2: 588.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3544_1524",
    x1: 1357.04,
    y1: 733.747,
    x2: 1334.39,
    y2: 360.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3544_1524",
    x1: 1703.54,
    y1: 841.4,
    x2: 1043.06,
    y2: 217.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3544_1524",
    x1: 1202.42,
    y1: 283.488,
    x2: 1282.07,
    y2: 1105.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3544_1524",
    x1: 1315.57,
    y1: 1203.67,
    x2: 1791.5,
    y2: 635.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3544_1524",
    x1: 1738.96,
    y1: 251.57,
    x2: 1201.37,
    y2: 610.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3544_1524",
    x1: 1692.58,
    y1: 831.909,
    x2: 1689.55,
    y2: 91.1155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3544_1524",
    x1: 1893.23,
    y1: 866.291,
    x2: 1741.13,
    y2: 61.0973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3544_1524",
    x1: 1638.66,
    y1: 1119.46,
    x2: 1390.69,
    y2: 941.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3544_1524",
    x1: 1302.79,
    y1: 1039.17,
    x2: 1940.04,
    y2: 688.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3544_1524",
    x1: 1453.03,
    y1: 1149.33,
    x2: 1615.95,
    y2: 785.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3544_1524",
    x1: 1396.4,
    y1: 1149.08,
    x2: 1608.42,
    y2: 825.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3544_1524",
    x1: 1603.51,
    y1: 890.63,
    x2: 1362.02,
    y2: 1077.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3544_1524",
    x1: 706.208,
    y1: 1632.9,
    x2: 164.593,
    y2: 179.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3544_1524",
    x1: 1014.06,
    y1: 805.552,
    x2: 1640.52,
    y2: 324.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3544_1524",
    x1: 1022.62,
    y1: 414.694,
    x2: 1629.44,
    y2: 974.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3544_1524",
    x1: 1542.26,
    y1: 1223.72,
    x2: 1958.93,
    y2: 525.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3544_1524",
    x1: 2139.27,
    y1: 364.356,
    x2: 1347.47,
    y2: 709.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3544_1524",
    x1: 1991,
    y1: 298.414,
    x2: 1410.52,
    y2: 829.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3544_1524",
    x1: 1324.33,
    y1: 94.0884,
    x2: 1521.99,
    y2: 758.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3544_1524",
    x1: 1850.81,
    y1: 320.82,
    x2: 1353.61,
    y2: 930.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3544_1524",
    x1: 2088.61,
    y1: 43.4774,
    x2: 1206.96,
    y2: 466.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3544_1524",
    x1: 1741.82,
    y1: 187.558,
    x2: 1110.48,
    y2: 657.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3544_1524",
    x1: 1413.68,
    y1: 1023.62,
    x2: 2040.15,
    y2: 542.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3544_1524",
    x1: 1099.86,
    y1: 906.961,
    x2: 1656.82,
    y2: 302.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3544_1524",
    x1: 1467.1,
    y1: -85.4931,
    x2: 1470.57,
    y2: 1106.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3544_1524",
    x1: 1703.88,
    y1: 1227.7,
    x2: 1425.82,
    y2: 483.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3544_1524",
    x1: 1093.68,
    y1: 502.592,
    x2: 1551.66,
    y2: 470.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3544_1524",
    x1: 1478.92,
    y1: 1043.79,
    x2: 687.119,
    y2: 698.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3544_1524",
    x1: 1301.15,
    y1: 446.513,
    x2: 1288.23,
    y2: 888.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3544_1524",
    x1: 1123.96,
    y1: 1118.43,
    x2: 924.021,
    y2: 357.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3544_1524",
    x1: 1712.49,
    y1: 873.099,
    x2: 1051.36,
    y2: 828.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3544_1524",
    x1: 999.697,
    y1: 239.099,
    x2: 1375.84,
    y2: 1016.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3544_1524",
    x1: 1419.53,
    y1: -12.0218,
    x2: 1143.94,
    y2: 1016.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3544_1524",
    x1: 1057.67,
    y1: 187.225,
    x2: 1706.02,
    y2: 661.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3544_1524",
    x1: 904.94,
    y1: 890.21,
    x2: 1828.16,
    y2: 729.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3544_1524",
    x1: 1485.68,
    y1: 213.342,
    x2: 1293.87,
    y2: 1055.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3544_1524",
    x1: 1250.91,
    y1: 174.307,
    x2: 1328.77,
    y2: 957.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3544_1524",
    x1: 1368.86,
    y1: 94.521,
    x2: 1201.76,
    y2: 863.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3544_1524",
    x1: 848.59,
    y1: -76.7381,
    x2: 2391.53,
    y2: 159.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3544_1524",
    x1: -2761.57,
    y1: -3280.86,
    x2: -2757.49,
    y2: -3280.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3544_1524",
    x1: -213.196,
    y1: 572.114,
    x2: 191.45,
    y2: 1246.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3544_1524",
    x1: 1513.89,
    y1: -173.669,
    x2: 227.274,
    y2: 783.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3544_1524",
    x1: 157.211,
    y1: -85.6915,
    x2: 295.721,
    y2: 1151.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3544_1524",
    x1: 157.032,
    y1: -46.6218,
    x2: 295.542,
    y2: 1190.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3544_1524",
    x1: 1595.43,
    y1: -90.7517,
    x2: 1596.88,
    y2: 1115.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3544_1524",
    x1: 1595.43,
    y1: -90.7513,
    x2: 1596.88,
    y2: 1115.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_3544_1524",
    x1: -714.605,
    y1: 1838.82,
    x2: -1327.28,
    y2: 439.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_3544_1524",
    x1: -757.619,
    y1: 1918.32,
    x2: -1391.32,
    y2: 470.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_3544_1524",
    x1: 2240.98,
    y1: 1246.9,
    x2: 2083.19,
    y2: -121.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_3544_1524",
    x1: 2240.98,
    y1: 1246.9,
    x2: 2083.19,
    y2: -121.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_3544_1524",
    x1: 774.198,
    y1: -651.633,
    x2: 667.373,
    y2: 1623.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_3544_1524",
    x1: 709.791,
    y1: -654.658,
    x2: 602.965,
    y2: 1620.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_3544_1524",
    x1: -3417.9,
    y1: -1661.43,
    x2: -2297.75,
    y2: 3871.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_3544_1524",
    x1: -4482.49,
    y1: -2699.28,
    x2: -4009.92,
    y2: 3286.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_3544_1524",
    x1: 752.149,
    y1: 763.675,
    x2: 1989.24,
    y2: 548.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_3544_1524",
    x1: 663.931,
    y1: 945.942,
    x2: 1142.79,
    y2: 1364.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3544_1524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1280,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddle);
export default __webpack_public_path__ + "static/media/middle.aa99f037f6c2275309edc40c0f40034f.svg";
export { ForwardRef as ReactComponent };